(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree14a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree14a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9qak9", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("gDcFo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c1ba1d31bcba154e$export$2e2bcd8739ae039; });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $c1ba1d31bcba154e$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $c1ba1d31bcba154e$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($c1ba1d31bcba154e$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $c1ba1d31bcba154e$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $c1ba1d31bcba154e$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $c1ba1d31bcba154e$var$timeoutDuration);
        }
    };
}
var $c1ba1d31bcba154e$var$supportsMicroTasks = $c1ba1d31bcba154e$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $c1ba1d31bcba154e$var$debounce = $c1ba1d31bcba154e$var$supportsMicroTasks ? $c1ba1d31bcba154e$var$microtaskDebounce : $c1ba1d31bcba154e$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $c1ba1d31bcba154e$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $c1ba1d31bcba154e$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $c1ba1d31bcba154e$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $c1ba1d31bcba154e$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $c1ba1d31bcba154e$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $c1ba1d31bcba154e$var$getScrollParent($c1ba1d31bcba154e$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $c1ba1d31bcba154e$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $c1ba1d31bcba154e$var$isIE11 = $c1ba1d31bcba154e$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $c1ba1d31bcba154e$var$isIE10 = $c1ba1d31bcba154e$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $c1ba1d31bcba154e$var$isIE(version) {
    if (version === 11) return $c1ba1d31bcba154e$var$isIE11;
    if (version === 10) return $c1ba1d31bcba154e$var$isIE10;
    return $c1ba1d31bcba154e$var$isIE11 || $c1ba1d31bcba154e$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $c1ba1d31bcba154e$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $c1ba1d31bcba154e$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $c1ba1d31bcba154e$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $c1ba1d31bcba154e$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $c1ba1d31bcba154e$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $c1ba1d31bcba154e$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $c1ba1d31bcba154e$var$getRoot(node) {
    if (node.parentNode !== null) return $c1ba1d31bcba154e$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $c1ba1d31bcba154e$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($c1ba1d31bcba154e$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $c1ba1d31bcba154e$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $c1ba1d31bcba154e$var$getRoot(element1);
    if (element1root.host) return $c1ba1d31bcba154e$var$findCommonOffsetParent(element1root.host, element2);
    else return $c1ba1d31bcba154e$var$findCommonOffsetParent(element1, $c1ba1d31bcba154e$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $c1ba1d31bcba154e$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $c1ba1d31bcba154e$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $c1ba1d31bcba154e$var$getScroll(element, 'top');
    var scrollLeft = $c1ba1d31bcba154e$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $c1ba1d31bcba154e$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $c1ba1d31bcba154e$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $c1ba1d31bcba154e$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $c1ba1d31bcba154e$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $c1ba1d31bcba154e$var$isIE(10) && getComputedStyle(html);
    return {
        height: $c1ba1d31bcba154e$var$getSize('Height', body, html, computedStyle),
        width: $c1ba1d31bcba154e$var$getSize('Width', body, html, computedStyle)
    };
}
var $c1ba1d31bcba154e$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $c1ba1d31bcba154e$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $c1ba1d31bcba154e$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $c1ba1d31bcba154e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $c1ba1d31bcba154e$var$getClientRect(offsets) {
    return $c1ba1d31bcba154e$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $c1ba1d31bcba154e$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($c1ba1d31bcba154e$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $c1ba1d31bcba154e$var$getScroll(element, 'top');
            var scrollLeft = $c1ba1d31bcba154e$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $c1ba1d31bcba154e$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $c1ba1d31bcba154e$var$getStyleComputedProperty(element);
        horizScrollbar -= $c1ba1d31bcba154e$var$getBordersSize(styles, 'x');
        vertScrollbar -= $c1ba1d31bcba154e$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $c1ba1d31bcba154e$var$getClientRect(result);
}
function $c1ba1d31bcba154e$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $c1ba1d31bcba154e$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $c1ba1d31bcba154e$var$getBoundingClientRect(children);
    var parentRect = $c1ba1d31bcba154e$var$getBoundingClientRect(parent);
    var scrollParent = $c1ba1d31bcba154e$var$getScrollParent(children);
    var styles = $c1ba1d31bcba154e$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $c1ba1d31bcba154e$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $c1ba1d31bcba154e$var$includeScroll(offsets, parent);
    return offsets;
}
function $c1ba1d31bcba154e$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $c1ba1d31bcba154e$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $c1ba1d31bcba154e$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $c1ba1d31bcba154e$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $c1ba1d31bcba154e$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $c1ba1d31bcba154e$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($c1ba1d31bcba154e$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $c1ba1d31bcba154e$var$getParentNode(element);
    if (!parentNode) return false;
    return $c1ba1d31bcba154e$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $c1ba1d31bcba154e$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $c1ba1d31bcba154e$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $c1ba1d31bcba154e$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $c1ba1d31bcba154e$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $c1ba1d31bcba154e$var$getFixedPositionOffsetParent(popper) : $c1ba1d31bcba154e$var$findCommonOffsetParent(popper, $c1ba1d31bcba154e$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $c1ba1d31bcba154e$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $c1ba1d31bcba154e$var$getScrollParent($c1ba1d31bcba154e$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $c1ba1d31bcba154e$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$c1ba1d31bcba154e$var$isFixed(offsetParent)) {
            var _getWindowSizes = $c1ba1d31bcba154e$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $c1ba1d31bcba154e$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $c1ba1d31bcba154e$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $c1ba1d31bcba154e$var$_extends({
            key: key
        }, rects[key], {
            area: $c1ba1d31bcba154e$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $c1ba1d31bcba154e$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $c1ba1d31bcba154e$var$getFixedPositionOffsetParent(popper) : $c1ba1d31bcba154e$var$findCommonOffsetParent(popper, $c1ba1d31bcba154e$var$getReferenceNode(reference));
    return $c1ba1d31bcba154e$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $c1ba1d31bcba154e$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $c1ba1d31bcba154e$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $c1ba1d31bcba154e$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $c1ba1d31bcba154e$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$c1ba1d31bcba154e$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $c1ba1d31bcba154e$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $c1ba1d31bcba154e$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $c1ba1d31bcba154e$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $c1ba1d31bcba154e$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $c1ba1d31bcba154e$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $c1ba1d31bcba154e$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $c1ba1d31bcba154e$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $c1ba1d31bcba154e$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $c1ba1d31bcba154e$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $c1ba1d31bcba154e$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $c1ba1d31bcba154e$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $c1ba1d31bcba154e$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $c1ba1d31bcba154e$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $c1ba1d31bcba154e$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $c1ba1d31bcba154e$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $c1ba1d31bcba154e$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($c1ba1d31bcba154e$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$c1ba1d31bcba154e$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $c1ba1d31bcba154e$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $c1ba1d31bcba154e$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $c1ba1d31bcba154e$var$attachToScrollParents($c1ba1d31bcba154e$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $c1ba1d31bcba154e$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $c1ba1d31bcba154e$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $c1ba1d31bcba154e$var$getScrollParent(reference);
    $c1ba1d31bcba154e$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $c1ba1d31bcba154e$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $c1ba1d31bcba154e$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $c1ba1d31bcba154e$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $c1ba1d31bcba154e$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $c1ba1d31bcba154e$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $c1ba1d31bcba154e$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $c1ba1d31bcba154e$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $c1ba1d31bcba154e$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $c1ba1d31bcba154e$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $c1ba1d31bcba154e$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $c1ba1d31bcba154e$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $c1ba1d31bcba154e$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $c1ba1d31bcba154e$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $c1ba1d31bcba154e$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $c1ba1d31bcba154e$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $c1ba1d31bcba154e$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $c1ba1d31bcba154e$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $c1ba1d31bcba154e$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $c1ba1d31bcba154e$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $c1ba1d31bcba154e$var$isFirefox = $c1ba1d31bcba154e$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $c1ba1d31bcba154e$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $c1ba1d31bcba154e$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $c1ba1d31bcba154e$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $c1ba1d31bcba154e$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$c1ba1d31bcba154e$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $c1ba1d31bcba154e$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $c1ba1d31bcba154e$var$_extends({}, attributes, data.attributes);
    data.styles = $c1ba1d31bcba154e$var$_extends({}, styles, data.styles);
    data.arrowStyles = $c1ba1d31bcba154e$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $c1ba1d31bcba154e$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $c1ba1d31bcba154e$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$c1ba1d31bcba154e$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $c1ba1d31bcba154e$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $c1ba1d31bcba154e$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $c1ba1d31bcba154e$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $c1ba1d31bcba154e$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $c1ba1d31bcba154e$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $c1ba1d31bcba154e$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $c1ba1d31bcba154e$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $c1ba1d31bcba154e$var$validPlacements = $c1ba1d31bcba154e$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $c1ba1d31bcba154e$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $c1ba1d31bcba154e$var$validPlacements.indexOf(placement);
    var arr = $c1ba1d31bcba154e$var$validPlacements.slice(index + 1).concat($c1ba1d31bcba154e$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $c1ba1d31bcba154e$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($c1ba1d31bcba154e$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $c1ba1d31bcba154e$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $c1ba1d31bcba154e$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $c1ba1d31bcba154e$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $c1ba1d31bcba154e$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $c1ba1d31bcba154e$var$clockwise(placement);
            break;
        case $c1ba1d31bcba154e$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $c1ba1d31bcba154e$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $c1ba1d31bcba154e$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $c1ba1d31bcba154e$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $c1ba1d31bcba154e$var$_extends({}, data.offsets.popper, $c1ba1d31bcba154e$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $c1ba1d31bcba154e$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $c1ba1d31bcba154e$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $c1ba1d31bcba154e$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $c1ba1d31bcba154e$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($c1ba1d31bcba154e$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $c1ba1d31bcba154e$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($c1ba1d31bcba154e$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($c1ba1d31bcba154e$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $c1ba1d31bcba154e$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $c1ba1d31bcba154e$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $c1ba1d31bcba154e$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $c1ba1d31bcba154e$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $c1ba1d31bcba154e$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $c1ba1d31bcba154e$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $c1ba1d31bcba154e$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $c1ba1d31bcba154e$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $c1ba1d31bcba154e$var$defineProperty({}, side, reference[side]),
            end: $c1ba1d31bcba154e$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $c1ba1d31bcba154e$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$hide(data) {
    if (!$c1ba1d31bcba154e$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $c1ba1d31bcba154e$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $c1ba1d31bcba154e$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $c1ba1d31bcba154e$var$getOppositePlacement(placement);
    data.offsets.popper = $c1ba1d31bcba154e$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $c1ba1d31bcba154e$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $c1ba1d31bcba154e$var$applyStyle,
        /** @prop {Function} */ onLoad: $c1ba1d31bcba154e$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $c1ba1d31bcba154e$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $c1ba1d31bcba154e$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $c1ba1d31bcba154e$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $c1ba1d31bcba154e$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $c1ba1d31bcba154e$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $c1ba1d31bcba154e$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($c1ba1d31bcba154e$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $c1ba1d31bcba154e$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $c1ba1d31bcba154e$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $c1ba1d31bcba154e$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $c1ba1d31bcba154e$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $c1ba1d31bcba154e$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $c1ba1d31bcba154e$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $c1ba1d31bcba154e$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $c1ba1d31bcba154e$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $c1ba1d31bcba154e$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$c1ba1d31bcba154e$var$Popper.placements = $c1ba1d31bcba154e$var$placements;
$c1ba1d31bcba154e$var$Popper.Defaults = $c1ba1d31bcba154e$var$Defaults;
var $c1ba1d31bcba154e$export$2e2bcd8739ae039 = $c1ba1d31bcba154e$var$Popper;

});

parcelRegister("3fu6U", function(module, exports) {
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if (module.exports) module.exports = lazySizes;
})(typeof window != 'undefined' ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    'use strict';
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = 'addEventListener';
    var _getAttribute = 'getAttribute';
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        'load',
        'error',
        'lazyincluded',
        '_lazyloaded'
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : 'removeEventListener';
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent('Event');
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) el.setAttribute('srcset', full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = 'onscroll' in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, 'opacity') || 1) > 0;
                if (visible && getCSS(parent, 'overflow') != 'visible') {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) source.setAttribute('media', customMedia);
            if (sourceSrcset) source.setAttribute('srcset', sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute('sizes', sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || '');
                }
                firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName('source'), handleSources);
                if (srcset) elem.setAttribute('srcset', srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ('_lazyCache' in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == 'lazy') isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
                addEventListener('scroll', throttledCheckElements, true);
                addEventListener('resize', throttledCheckElements, true);
                addEventListener('pageshow', function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener('hashchange', throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    'focus',
                    'mouseover',
                    'click',
                    'load',
                    'transitionend',
                    'animationend'
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener('load', onload);
                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute('sizes', width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, 'lazybeforesizes', {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});

});


var $9qak9 = parcelRequire("9qak9");
globalThis.$ = (0, (/*@__PURE__*/$parcel$interopDefault($9qak9)));


var $3dcf9cc3f558b410$exports = {};


/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory($3dcf9cc3f558b410$exports, (parcelRequire("9qak9")), (parcelRequire("gDcFo")));
})($3dcf9cc3f558b410$exports, function(exports1, $, Popper) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var $__default = /*#__PURE__*/ _interopDefaultLegacy($);
    var Popper__default = /*#__PURE__*/ _interopDefaultLegacy(Popper);
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Private TransitionEnd Helpers
   */ var TRANSITION_END = 'transitionend';
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    function toType(obj) {
        if (obj === null || typeof obj === 'undefined') return "" + obj;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }
    function getSpecialTransitionEndEvent() {
        return {
            bindType: TRANSITION_END,
            delegateType: TRANSITION_END,
            handle: function handle(event) {
                if ($__default["default"](event.target).is(this)) return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                return undefined;
            }
        };
    }
    function transitionEndEmulator(duration) {
        var _this = this;
        var called = false;
        $__default["default"](this).one(Util.TRANSITION_END, function() {
            called = true;
        });
        setTimeout(function() {
            if (!called) Util.triggerTransitionEnd(_this);
        }, duration);
        return this;
    }
    function setTransitionEndSupport() {
        $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
        $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
   * Public Util API
   */ var Util = {
        TRANSITION_END: 'bsTransitionEnd',
        getUID: function getUID(prefix) {
            do // eslint-disable-next-line no-bitwise
            prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
            while (document.getElementById(prefix));
            return prefix;
        },
        getSelectorFromElement: function getSelectorFromElement(element) {
            var selector = element.getAttribute('data-target');
            if (!selector || selector === '#') {
                var hrefAttr = element.getAttribute('href');
                selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
            }
            try {
                return document.querySelector(selector) ? selector : null;
            } catch (_) {
                return null;
            }
        },
        getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
            if (!element) return 0;
             // Get transition-duration of the element
            var transitionDuration = $__default["default"](element).css('transition-duration');
            var transitionDelay = $__default["default"](element).css('transition-delay');
            var floatTransitionDuration = parseFloat(transitionDuration);
            var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
            if (!floatTransitionDuration && !floatTransitionDelay) return 0;
             // If multiple durations are defined, take the first
            transitionDuration = transitionDuration.split(',')[0];
            transitionDelay = transitionDelay.split(',')[0];
            return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
        },
        reflow: function reflow(element) {
            return element.offsetHeight;
        },
        triggerTransitionEnd: function triggerTransitionEnd(element) {
            $__default["default"](element).trigger(TRANSITION_END);
        },
        supportsTransitionEnd: function supportsTransitionEnd() {
            return Boolean(TRANSITION_END);
        },
        isElement: function isElement(obj) {
            return (obj[0] || obj).nodeType;
        },
        typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
            for(var property in configTypes)if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                var expectedTypes = configTypes[property];
                var value = config[property];
                var valueType = value && Util.isElement(value) ? 'element' : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
            }
        },
        findShadowRoot: function findShadowRoot(element) {
            if (!document.documentElement.attachShadow) return null;
             // Can find the shadow root otherwise it'll return the document
            if (typeof element.getRootNode === 'function') {
                var root = element.getRootNode();
                return root instanceof ShadowRoot ? root : null;
            }
            if (element instanceof ShadowRoot) return element;
             // when we don't find a shadow root
            if (!element.parentNode) return null;
            return Util.findShadowRoot(element.parentNode);
        },
        jQueryDetection: function jQueryDetection() {
            if (typeof $__default["default"] === 'undefined') throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
            var version = $__default["default"].fn.jquery.split(' ')[0].split('.');
            var minMajor = 1;
            var ltMajor = 2;
            var minMinor = 9;
            var minPatch = 1;
            var maxMajor = 4;
            if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
        }
    };
    Util.jQueryDetection();
    setTransitionEndSupport();
    /**
   * Constants
   */ var NAME$a = 'alert';
    var VERSION$a = '4.6.2';
    var DATA_KEY$a = 'bs.alert';
    var EVENT_KEY$a = "." + DATA_KEY$a;
    var DATA_API_KEY$7 = '.data-api';
    var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
    var CLASS_NAME_ALERT = 'alert';
    var CLASS_NAME_FADE$5 = 'fade';
    var CLASS_NAME_SHOW$7 = 'show';
    var EVENT_CLOSE = "close" + EVENT_KEY$a;
    var EVENT_CLOSED = "closed" + EVENT_KEY$a;
    var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$a + DATA_API_KEY$7;
    var SELECTOR_DISMISS = '[data-dismiss="alert"]';
    /**
   * Class definition
   */ var Alert = /*#__PURE__*/ function() {
        function Alert(element) {
            this._element = element;
        } // Getters
        var _proto = Alert.prototype;
        // Public
        _proto.close = function close(element) {
            var rootElement = this._element;
            if (element) rootElement = this._getRootElement(element);
            var customEvent = this._triggerCloseEvent(rootElement);
            if (customEvent.isDefaultPrevented()) return;
            this._removeElement(rootElement);
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$a);
            this._element = null;
        } // Private
        ;
        _proto._getRootElement = function _getRootElement(element) {
            var selector = Util.getSelectorFromElement(element);
            var parent = false;
            if (selector) parent = document.querySelector(selector);
            if (!parent) parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
            return parent;
        };
        _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
            var closeEvent = $__default["default"].Event(EVENT_CLOSE);
            $__default["default"](element).trigger(closeEvent);
            return closeEvent;
        };
        _proto._removeElement = function _removeElement(element) {
            var _this = this;
            $__default["default"](element).removeClass(CLASS_NAME_SHOW$7);
            if (!$__default["default"](element).hasClass(CLASS_NAME_FADE$5)) {
                this._destroyElement(element);
                return;
            }
            var transitionDuration = Util.getTransitionDurationFromElement(element);
            $__default["default"](element).one(Util.TRANSITION_END, function(event) {
                return _this._destroyElement(element, event);
            }).emulateTransitionEnd(transitionDuration);
        };
        _proto._destroyElement = function _destroyElement(element) {
            $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
        } // Static
        ;
        Alert._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$a);
                if (!data) {
                    data = new Alert(this);
                    $element.data(DATA_KEY$a, data);
                }
                if (config === 'close') data[config](this);
            });
        };
        Alert._handleDismiss = function _handleDismiss(alertInstance) {
            return function(event) {
                if (event) event.preventDefault();
                alertInstance.close(this);
            };
        };
        _createClass(Alert, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$a;
                }
            }
        ]);
        return Alert;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
    /**
   * jQuery
   */ $__default["default"].fn[NAME$a] = Alert._jQueryInterface;
    $__default["default"].fn[NAME$a].Constructor = Alert;
    $__default["default"].fn[NAME$a].noConflict = function() {
        $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
        return Alert._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$9 = 'button';
    var VERSION$9 = '4.6.2';
    var DATA_KEY$9 = 'bs.button';
    var EVENT_KEY$9 = "." + DATA_KEY$9;
    var DATA_API_KEY$6 = '.data-api';
    var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
    var CLASS_NAME_ACTIVE$3 = 'active';
    var CLASS_NAME_BUTTON = 'btn';
    var CLASS_NAME_FOCUS = 'focus';
    var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$9 + DATA_API_KEY$6;
    var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$9 + DATA_API_KEY$6 + " " + ("blur" + EVENT_KEY$9 + DATA_API_KEY$6);
    var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$9 + DATA_API_KEY$6;
    var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
    var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
    var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="button"]';
    var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
    var SELECTOR_INPUT = 'input:not([type="hidden"])';
    var SELECTOR_ACTIVE$2 = '.active';
    var SELECTOR_BUTTON = '.btn';
    /**
   * Class definition
   */ var Button = /*#__PURE__*/ function() {
        function Button(element) {
            this._element = element;
            this.shouldAvoidTriggerChange = false;
        } // Getters
        var _proto = Button.prototype;
        // Public
        _proto.toggle = function toggle() {
            var triggerChangeEvent = true;
            var addAriaPressed = true;
            var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];
            if (rootElement) {
                var input = this._element.querySelector(SELECTOR_INPUT);
                if (input) {
                    if (input.type === 'radio') {
                        if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE$3)) triggerChangeEvent = false;
                        else {
                            var activeElement = rootElement.querySelector(SELECTOR_ACTIVE$2);
                            if (activeElement) $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$3);
                        }
                    }
                    if (triggerChangeEvent) {
                        // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
                        if (input.type === 'checkbox' || input.type === 'radio') input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE$3);
                        if (!this.shouldAvoidTriggerChange) $__default["default"](input).trigger('change');
                    }
                    input.focus();
                    addAriaPressed = false;
                }
            }
            if (!(this._element.hasAttribute('disabled') || this._element.classList.contains('disabled'))) {
                if (addAriaPressed) this._element.setAttribute('aria-pressed', !this._element.classList.contains(CLASS_NAME_ACTIVE$3));
                if (triggerChangeEvent) $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE$3);
            }
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$9);
            this._element = null;
        } // Static
        ;
        Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$9);
                if (!data) {
                    data = new Button(this);
                    $element.data(DATA_KEY$9, data);
                }
                data.shouldAvoidTriggerChange = avoidTriggerChange;
                if (config === 'toggle') data[config]();
            });
        };
        _createClass(Button, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$9;
                }
            }
        ]);
        return Button;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = event.target;
        var initialButton = button;
        if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
        if (!button || button.hasAttribute('disabled') || button.classList.contains('disabled')) event.preventDefault(); // work around Firefox bug #1540995
        else {
            var inputBtn = button.querySelector(SELECTOR_INPUT);
            if (inputBtn && (inputBtn.hasAttribute('disabled') || inputBtn.classList.contains('disabled'))) {
                event.preventDefault(); // work around Firefox bug #1540995
                return;
            }
            if (initialButton.tagName === 'INPUT' || button.tagName !== 'LABEL') Button._jQueryInterface.call($__default["default"](button), 'toggle', initialButton.tagName === 'INPUT');
        }
    }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
        $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
    });
    $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function() {
        // ensure correct active class is set to match the controls' actual values/states
        // find all checkboxes/readio buttons inside data-toggle groups
        var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));
        for(var i = 0, len = buttons.length; i < len; i++){
            var button = buttons[i];
            var input = button.querySelector(SELECTOR_INPUT);
            if (input.checked || input.hasAttribute('checked')) button.classList.add(CLASS_NAME_ACTIVE$3);
            else button.classList.remove(CLASS_NAME_ACTIVE$3);
        } // find all button toggles
        buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$4));
        for(var _i = 0, _len = buttons.length; _i < _len; _i++){
            var _button = buttons[_i];
            if (_button.getAttribute('aria-pressed') === 'true') _button.classList.add(CLASS_NAME_ACTIVE$3);
            else _button.classList.remove(CLASS_NAME_ACTIVE$3);
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$9] = Button._jQueryInterface;
    $__default["default"].fn[NAME$9].Constructor = Button;
    $__default["default"].fn[NAME$9].noConflict = function() {
        $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
        return Button._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$8 = 'carousel';
    var VERSION$8 = '4.6.2';
    var DATA_KEY$8 = 'bs.carousel';
    var EVENT_KEY$8 = "." + DATA_KEY$8;
    var DATA_API_KEY$5 = '.data-api';
    var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
    var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    var SWIPE_THRESHOLD = 40;
    var CLASS_NAME_CAROUSEL = 'carousel';
    var CLASS_NAME_ACTIVE$2 = 'active';
    var CLASS_NAME_SLIDE = 'slide';
    var CLASS_NAME_RIGHT = 'carousel-item-right';
    var CLASS_NAME_LEFT = 'carousel-item-left';
    var CLASS_NAME_NEXT = 'carousel-item-next';
    var CLASS_NAME_PREV = 'carousel-item-prev';
    var CLASS_NAME_POINTER_EVENT = 'pointer-event';
    var DIRECTION_NEXT = 'next';
    var DIRECTION_PREV = 'prev';
    var DIRECTION_LEFT = 'left';
    var DIRECTION_RIGHT = 'right';
    var EVENT_SLIDE = "slide" + EVENT_KEY$8;
    var EVENT_SLID = "slid" + EVENT_KEY$8;
    var EVENT_KEYDOWN = "keydown" + EVENT_KEY$8;
    var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$8;
    var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$8;
    var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$8;
    var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$8;
    var EVENT_TOUCHEND = "touchend" + EVENT_KEY$8;
    var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$8;
    var EVENT_POINTERUP = "pointerup" + EVENT_KEY$8;
    var EVENT_DRAG_START = "dragstart" + EVENT_KEY$8;
    var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$5;
    var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$8 + DATA_API_KEY$5;
    var SELECTOR_ACTIVE$1 = '.active';
    var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
    var SELECTOR_ITEM = '.carousel-item';
    var SELECTOR_ITEM_IMG = '.carousel-item img';
    var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
    var SELECTOR_INDICATORS = '.carousel-indicators';
    var SELECTOR_DATA_SLIDE = '[data-slide], [data-slide-to]';
    var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
    var Default$7 = {
        interval: 5000,
        keyboard: true,
        slide: false,
        pause: 'hover',
        wrap: true,
        touch: true
    };
    var DefaultType$7 = {
        interval: '(number|boolean)',
        keyboard: 'boolean',
        slide: '(boolean|string)',
        pause: '(string|boolean)',
        wrap: 'boolean',
        touch: 'boolean'
    };
    var PointerType = {
        TOUCH: 'touch',
        PEN: 'pen'
    };
    /**
   * Class definition
   */ var Carousel = /*#__PURE__*/ function() {
        function Carousel(element, config) {
            this._items = null;
            this._interval = null;
            this._activeElement = null;
            this._isPaused = false;
            this._isSliding = false;
            this.touchTimeout = null;
            this.touchStartX = 0;
            this.touchDeltaX = 0;
            this._config = this._getConfig(config);
            this._element = element;
            this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
            this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
            this._addEventListeners();
        } // Getters
        var _proto = Carousel.prototype;
        // Public
        _proto.next = function next() {
            if (!this._isSliding) this._slide(DIRECTION_NEXT);
        };
        _proto.nextWhenVisible = function nextWhenVisible() {
            var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && $element.is(':visible') && $element.css('visibility') !== 'hidden') this.next();
        };
        _proto.prev = function prev() {
            if (!this._isSliding) this._slide(DIRECTION_PREV);
        };
        _proto.pause = function pause(event) {
            if (!event) this._isPaused = true;
            if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
                Util.triggerTransitionEnd(this._element);
                this.cycle(true);
            }
            clearInterval(this._interval);
            this._interval = null;
        };
        _proto.cycle = function cycle(event) {
            if (!event) this._isPaused = false;
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
            if (this._config.interval && !this._isPaused) {
                this._updateInterval();
                this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
            }
        };
        _proto.to = function to(index) {
            var _this = this;
            this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeIndex = this._getItemIndex(this._activeElement);
            if (index > this._items.length - 1 || index < 0) return;
            if (this._isSliding) {
                $__default["default"](this._element).one(EVENT_SLID, function() {
                    return _this.to(index);
                });
                return;
            }
            if (activeIndex === index) {
                this.pause();
                this.cycle();
                return;
            }
            var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;
            this._slide(direction, this._items[index]);
        };
        _proto.dispose = function dispose() {
            $__default["default"](this._element).off(EVENT_KEY$8);
            $__default["default"].removeData(this._element, DATA_KEY$8);
            this._items = null;
            this._config = null;
            this._element = null;
            this._interval = null;
            this._isPaused = null;
            this._isSliding = null;
            this._activeElement = null;
            this._indicatorsElement = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$7, config);
            Util.typeCheckConfig(NAME$8, config, DefaultType$7);
            return config;
        };
        _proto._handleSwipe = function _handleSwipe() {
            var absDeltax = Math.abs(this.touchDeltaX);
            if (absDeltax <= SWIPE_THRESHOLD) return;
            var direction = absDeltax / this.touchDeltaX;
            this.touchDeltaX = 0; // swipe left
            if (direction > 0) this.prev();
             // swipe right
            if (direction < 0) this.next();
        };
        _proto._addEventListeners = function _addEventListeners() {
            var _this2 = this;
            if (this._config.keyboard) $__default["default"](this._element).on(EVENT_KEYDOWN, function(event) {
                return _this2._keydown(event);
            });
            if (this._config.pause === 'hover') $__default["default"](this._element).on(EVENT_MOUSEENTER, function(event) {
                return _this2.pause(event);
            }).on(EVENT_MOUSELEAVE, function(event) {
                return _this2.cycle(event);
            });
            if (this._config.touch) this._addTouchEventListeners();
        };
        _proto._addTouchEventListeners = function _addTouchEventListeners() {
            var _this3 = this;
            if (!this._touchSupported) return;
            var start = function start(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchStartX = event.originalEvent.clientX;
                else if (!_this3._pointerEvent) _this3.touchStartX = event.originalEvent.touches[0].clientX;
            };
            var move = function move(event) {
                // ensure swiping with one touch and not pinching
                _this3.touchDeltaX = event.originalEvent.touches && event.originalEvent.touches.length > 1 ? 0 : event.originalEvent.touches[0].clientX - _this3.touchStartX;
            };
            var end = function end(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
                _this3._handleSwipe();
                if (_this3._config.pause === 'hover') {
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this3.pause();
                    if (_this3.touchTimeout) clearTimeout(_this3.touchTimeout);
                    _this3.touchTimeout = setTimeout(function(event) {
                        return _this3.cycle(event);
                    }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
                }
            };
            $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function(e) {
                return e.preventDefault();
            });
            if (this._pointerEvent) {
                $__default["default"](this._element).on(EVENT_POINTERDOWN, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_POINTERUP, function(event) {
                    return end(event);
                });
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                $__default["default"](this._element).on(EVENT_TOUCHSTART, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHMOVE, function(event) {
                    return move(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHEND, function(event) {
                    return end(event);
                });
            }
        };
        _proto._keydown = function _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            switch(event.which){
                case ARROW_LEFT_KEYCODE:
                    event.preventDefault();
                    this.prev();
                    break;
                case ARROW_RIGHT_KEYCODE:
                    event.preventDefault();
                    this.next();
                    break;
            }
        };
        _proto._getItemIndex = function _getItemIndex(element) {
            this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
            return this._items.indexOf(element);
        };
        _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
            var isNextDirection = direction === DIRECTION_NEXT;
            var isPrevDirection = direction === DIRECTION_PREV;
            var activeIndex = this._getItemIndex(activeElement);
            var lastItemIndex = this._items.length - 1;
            var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
            if (isGoingToWrap && !this._config.wrap) return activeElement;
            var delta = direction === DIRECTION_PREV ? -1 : 1;
            var itemIndex = (activeIndex + delta) % this._items.length;
            return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
        };
        _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
            var targetIndex = this._getItemIndex(relatedTarget);
            var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));
            var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
                relatedTarget: relatedTarget,
                direction: eventDirectionName,
                from: fromIndex,
                to: targetIndex
            });
            $__default["default"](this._element).trigger(slideEvent);
            return slideEvent;
        };
        _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
            if (this._indicatorsElement) {
                var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
                $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$2);
                var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
                if (nextIndicator) $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$2);
            }
        };
        _proto._updateInterval = function _updateInterval() {
            var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            if (!element) return;
            var elementInterval = parseInt(element.getAttribute('data-interval'), 10);
            if (elementInterval) {
                this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
                this._config.interval = elementInterval;
            } else this._config.interval = this._config.defaultInterval || this._config.interval;
        };
        _proto._slide = function _slide(direction, element) {
            var _this4 = this;
            var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeElementIndex = this._getItemIndex(activeElement);
            var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
            var nextElementIndex = this._getItemIndex(nextElement);
            var isCycling = Boolean(this._interval);
            var directionalClassName;
            var orderClassName;
            var eventDirectionName;
            if (direction === DIRECTION_NEXT) {
                directionalClassName = CLASS_NAME_LEFT;
                orderClassName = CLASS_NAME_NEXT;
                eventDirectionName = DIRECTION_LEFT;
            } else {
                directionalClassName = CLASS_NAME_RIGHT;
                orderClassName = CLASS_NAME_PREV;
                eventDirectionName = DIRECTION_RIGHT;
            }
            if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$2)) {
                this._isSliding = false;
                return;
            }
            var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
            if (slideEvent.isDefaultPrevented()) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            return;
            this._isSliding = true;
            if (isCycling) this.pause();
            this._setActiveIndicatorElement(nextElement);
            this._activeElement = nextElement;
            var slidEvent = $__default["default"].Event(EVENT_SLID, {
                relatedTarget: nextElement,
                direction: eventDirectionName,
                from: activeElementIndex,
                to: nextElementIndex
            });
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
                $__default["default"](nextElement).addClass(orderClassName);
                Util.reflow(nextElement);
                $__default["default"](activeElement).addClass(directionalClassName);
                $__default["default"](nextElement).addClass(directionalClassName);
                var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
                $__default["default"](activeElement).one(Util.TRANSITION_END, function() {
                    $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$2);
                    $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2 + " " + orderClassName + " " + directionalClassName);
                    _this4._isSliding = false;
                    setTimeout(function() {
                        return $__default["default"](_this4._element).trigger(slidEvent);
                    }, 0);
                }).emulateTransitionEnd(transitionDuration);
            } else {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2);
                $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$2);
                this._isSliding = false;
                $__default["default"](this._element).trigger(slidEvent);
            }
            if (isCycling) this.cycle();
        } // Static
        ;
        Carousel._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$8);
                var _config = _extends({}, Default$7, $__default["default"](this).data());
                if (typeof config === 'object') _config = _extends({}, _config, config);
                var action = typeof config === 'string' ? config : _config.slide;
                if (!data) {
                    data = new Carousel(this, _config);
                    $__default["default"](this).data(DATA_KEY$8, data);
                }
                if (typeof config === 'number') data.to(config);
                else if (typeof action === 'string') {
                    if (typeof data[action] === 'undefined') throw new TypeError("No method named \"" + action + "\"");
                    data[action]();
                } else if (_config.interval && _config.ride) {
                    data.pause();
                    data.cycle();
                }
            });
        };
        Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
            var selector = Util.getSelectorFromElement(this);
            if (!selector) return;
            var target = $__default["default"](selector)[0];
            if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) return;
            var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
            var slideIndex = this.getAttribute('data-slide-to');
            if (slideIndex) config.interval = false;
            Carousel._jQueryInterface.call($__default["default"](target), config);
            if (slideIndex) $__default["default"](target).data(DATA_KEY$8).to(slideIndex);
            event.preventDefault();
        };
        _createClass(Carousel, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$8;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$7;
                }
            }
        ]);
        return Carousel;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
    $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function() {
        var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));
        for(var i = 0, len = carousels.length; i < len; i++){
            var $carousel = $__default["default"](carousels[i]);
            Carousel._jQueryInterface.call($carousel, $carousel.data());
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$8] = Carousel._jQueryInterface;
    $__default["default"].fn[NAME$8].Constructor = Carousel;
    $__default["default"].fn[NAME$8].noConflict = function() {
        $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
        return Carousel._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$7 = 'collapse';
    var VERSION$7 = '4.6.2';
    var DATA_KEY$7 = 'bs.collapse';
    var EVENT_KEY$7 = "." + DATA_KEY$7;
    var DATA_API_KEY$4 = '.data-api';
    var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
    var CLASS_NAME_SHOW$6 = 'show';
    var CLASS_NAME_COLLAPSE = 'collapse';
    var CLASS_NAME_COLLAPSING = 'collapsing';
    var CLASS_NAME_COLLAPSED = 'collapsed';
    var DIMENSION_WIDTH = 'width';
    var DIMENSION_HEIGHT = 'height';
    var EVENT_SHOW$4 = "show" + EVENT_KEY$7;
    var EVENT_SHOWN$4 = "shown" + EVENT_KEY$7;
    var EVENT_HIDE$4 = "hide" + EVENT_KEY$7;
    var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$7;
    var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$7 + DATA_API_KEY$4;
    var SELECTOR_ACTIVES = '.show, .collapsing';
    var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="collapse"]';
    var Default$6 = {
        toggle: true,
        parent: ''
    };
    var DefaultType$6 = {
        toggle: 'boolean',
        parent: '(string|element)'
    };
    /**
   * Class definition
   */ var Collapse = /*#__PURE__*/ function() {
        function Collapse(element, config) {
            this._isTransitioning = false;
            this._element = element;
            this._config = this._getConfig(config);
            this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
            var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$3));
            for(var i = 0, len = toggleList.length; i < len; i++){
                var elem = toggleList[i];
                var selector = Util.getSelectorFromElement(elem);
                var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function(foundElem) {
                    return foundElem === element;
                });
                if (selector !== null && filterElement.length > 0) {
                    this._selector = selector;
                    this._triggerArray.push(elem);
                }
            }
            this._parent = this._config.parent ? this._getParent() : null;
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._element, this._triggerArray);
            if (this._config.toggle) this.toggle();
        } // Getters
        var _proto = Collapse.prototype;
        // Public
        _proto.toggle = function toggle() {
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) this.hide();
            else this.show();
        };
        _proto.show = function show() {
            var _this = this;
            if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) return;
            var actives;
            var activesData;
            if (this._parent) {
                actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function(elem) {
                    if (typeof _this._config.parent === 'string') return elem.getAttribute('data-parent') === _this._config.parent;
                    return elem.classList.contains(CLASS_NAME_COLLAPSE);
                });
                if (actives.length === 0) actives = null;
            }
            if (actives) {
                activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$7);
                if (activesData && activesData._isTransitioning) return;
            }
            var startEvent = $__default["default"].Event(EVENT_SHOW$4);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            if (actives) {
                Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), 'hide');
                if (!activesData) $__default["default"](actives).data(DATA_KEY$7, null);
            }
            var dimension = this._getDimension();
            $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            if (this._triggerArray.length) $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', true);
            this.setTransitioning(true);
            var complete = function complete() {
                $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
                _this._element.style[dimension] = '';
                _this.setTransitioning(false);
                $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
            };
            var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            var scrollSize = "scroll" + capitalizedDimension;
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            this._element.style[dimension] = this._element[scrollSize] + "px";
        };
        _proto.hide = function hide() {
            var _this2 = this;
            if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) return;
            var startEvent = $__default["default"].Event(EVENT_HIDE$4);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            var dimension = this._getDimension();
            this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
            Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
            var triggerArrayLength = this._triggerArray.length;
            if (triggerArrayLength > 0) for(var i = 0; i < triggerArrayLength; i++){
                var trigger = this._triggerArray[i];
                var selector = Util.getSelectorFromElement(trigger);
                if (selector !== null) {
                    var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));
                    if (!$elem.hasClass(CLASS_NAME_SHOW$6)) $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', false);
                }
            }
            this.setTransitioning(true);
            var complete = function complete() {
                _this2.setTransitioning(false);
                $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN$4);
            };
            this._element.style[dimension] = '';
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        };
        _proto.setTransitioning = function setTransitioning(isTransitioning) {
            this._isTransitioning = isTransitioning;
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$7);
            this._config = null;
            this._parent = null;
            this._element = null;
            this._triggerArray = null;
            this._isTransitioning = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$6, config);
            config.toggle = Boolean(config.toggle); // Coerce string values
            Util.typeCheckConfig(NAME$7, config, DefaultType$6);
            return config;
        };
        _proto._getDimension = function _getDimension() {
            var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
            return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
        };
        _proto._getParent = function _getParent() {
            var _this3 = this;
            var parent;
            if (Util.isElement(this._config.parent)) {
                parent = this._config.parent; // It's a jQuery object
                if (typeof this._config.parent.jquery !== 'undefined') parent = this._config.parent[0];
            } else parent = document.querySelector(this._config.parent);
            var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
            var children = [].slice.call(parent.querySelectorAll(selector));
            $__default["default"](children).each(function(i, element) {
                _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [
                    element
                ]);
            });
            return parent;
        };
        _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
            var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$6);
            if (triggerArray.length) $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
        } // Static
        ;
        Collapse._getTargetFromElement = function _getTargetFromElement(element) {
            var selector = Util.getSelectorFromElement(element);
            return selector ? document.querySelector(selector) : null;
        };
        Collapse._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$7);
                var _config = _extends({}, Default$6, $element.data(), typeof config === 'object' && config ? config : {});
                if (!data && _config.toggle && typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                if (!data) {
                    data = new Collapse(this, _config);
                    $element.data(DATA_KEY$7, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config]();
                }
            });
        };
        _createClass(Collapse, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$7;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$6;
                }
            }
        ]);
        return Collapse;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.currentTarget.tagName === 'A') event.preventDefault();
        var $trigger = $__default["default"](this);
        var selector = Util.getSelectorFromElement(this);
        var selectors = [].slice.call(document.querySelectorAll(selector));
        $__default["default"](selectors).each(function() {
            var $target = $__default["default"](this);
            var data = $target.data(DATA_KEY$7);
            var config = data ? 'toggle' : $trigger.data();
            Collapse._jQueryInterface.call($target, config);
        });
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$7] = Collapse._jQueryInterface;
    $__default["default"].fn[NAME$7].Constructor = Collapse;
    $__default["default"].fn[NAME$7].noConflict = function() {
        $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
        return Collapse._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$6 = 'dropdown';
    var VERSION$6 = '4.6.2';
    var DATA_KEY$6 = 'bs.dropdown';
    var EVENT_KEY$6 = "." + DATA_KEY$6;
    var DATA_API_KEY$3 = '.data-api';
    var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
    var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key
    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE$1);
    var CLASS_NAME_DISABLED$1 = 'disabled';
    var CLASS_NAME_SHOW$5 = 'show';
    var CLASS_NAME_DROPUP = 'dropup';
    var CLASS_NAME_DROPRIGHT = 'dropright';
    var CLASS_NAME_DROPLEFT = 'dropleft';
    var CLASS_NAME_MENURIGHT = 'dropdown-menu-right';
    var CLASS_NAME_POSITION_STATIC = 'position-static';
    var EVENT_HIDE$3 = "hide" + EVENT_KEY$6;
    var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$6;
    var EVENT_SHOW$3 = "show" + EVENT_KEY$6;
    var EVENT_SHOWN$3 = "shown" + EVENT_KEY$6;
    var EVENT_CLICK = "click" + EVENT_KEY$6;
    var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$6 + DATA_API_KEY$3;
    var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$6 + DATA_API_KEY$3;
    var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$6 + DATA_API_KEY$3;
    var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
    var SELECTOR_FORM_CHILD = '.dropdown form';
    var SELECTOR_MENU = '.dropdown-menu';
    var SELECTOR_NAVBAR_NAV = '.navbar-nav';
    var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
    var PLACEMENT_TOP = 'top-start';
    var PLACEMENT_TOPEND = 'top-end';
    var PLACEMENT_BOTTOM = 'bottom-start';
    var PLACEMENT_BOTTOMEND = 'bottom-end';
    var PLACEMENT_RIGHT = 'right-start';
    var PLACEMENT_LEFT = 'left-start';
    var Default$5 = {
        offset: 0,
        flip: true,
        boundary: 'scrollParent',
        reference: 'toggle',
        display: 'dynamic',
        popperConfig: null
    };
    var DefaultType$5 = {
        offset: '(number|string|function)',
        flip: 'boolean',
        boundary: '(string|element)',
        reference: '(string|element)',
        display: 'string',
        popperConfig: '(null|object)'
    };
    /**
   * Class definition
   */ var Dropdown = /*#__PURE__*/ function() {
        function Dropdown(element, config) {
            this._element = element;
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
            this._addEventListeners();
        } // Getters
        var _proto = Dropdown.prototype;
        // Public
        _proto.toggle = function toggle() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) return;
            var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5);
            Dropdown._clearMenus();
            if (isActive) return;
            this.show(true);
        };
        _proto.show = function show(usePopper) {
            if (usePopper === void 0) usePopper = false;
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var showEvent = $__default["default"].Event(EVENT_SHOW$3, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
             // Totally disable Popper for Dropdowns in Navbar
            if (!this._inNavbar && usePopper) {
                // Check for Popper dependency
                if (typeof Popper__default["default"] === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = parent;
                else if (Util.isElement(this._config.reference)) {
                    referenceElement = this._config.reference; // Check if it's jQuery element
                    if (typeof this._config.reference.jquery !== 'undefined') referenceElement = this._config.reference[0];
                } // If boundary is not `scrollParent`, then set position to `static`
                // to allow the menu to "escape" the scroll parent's boundaries
                // https://github.com/twbs/bootstrap/issues/24251
                if (this._config.boundary !== 'scrollParent') $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
                this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
            } // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ('ontouchstart' in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
            this._element.focus();
            this._element.setAttribute('aria-expanded', true);
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_SHOWN$3, relatedTarget));
        };
        _proto.hide = function hide() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            if (this._popper) this._popper.destroy();
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$6);
            $__default["default"](this._element).off(EVENT_KEY$6);
            this._element = null;
            this._menu = null;
            if (this._popper !== null) {
                this._popper.destroy();
                this._popper = null;
            }
        };
        _proto.update = function update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Private
        ;
        _proto._addEventListeners = function _addEventListeners() {
            var _this = this;
            $__default["default"](this._element).on(EVENT_CLICK, function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this.toggle();
            });
        };
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
            Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
            return config;
        };
        _proto._getMenuElement = function _getMenuElement() {
            if (!this._menu) {
                var parent = Dropdown._getParentFromElement(this._element);
                if (parent) this._menu = parent.querySelector(SELECTOR_MENU);
            }
            return this._menu;
        };
        _proto._getPlacement = function _getPlacement() {
            var $parentDropdown = $__default["default"](this._element.parentNode);
            var placement = PLACEMENT_BOTTOM; // Handle dropup
            if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) placement = PLACEMENT_RIGHT;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) placement = PLACEMENT_LEFT;
            else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) placement = PLACEMENT_BOTTOMEND;
            return placement;
        };
        _proto._detectNavbar = function _detectNavbar() {
            return $__default["default"](this._element).closest('.navbar').length > 0;
        };
        _proto._getOffset = function _getOffset() {
            var _this2 = this;
            var offset = {};
            if (typeof this._config.offset === 'function') offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
                return data;
            };
            else offset.offset = this._config.offset;
            return offset;
        };
        _proto._getPopperConfig = function _getPopperConfig() {
            var popperConfig = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            }; // Disable Popper if we have a static display
            if (this._config.display === 'static') popperConfig.modifiers.applyStyle = {
                enabled: false
            };
            return _extends({}, popperConfig, this._config.popperConfig);
        } // Static
        ;
        Dropdown._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$6);
                var _config = typeof config === 'object' ? config : null;
                if (!data) {
                    data = new Dropdown(this, _config);
                    $__default["default"](this).data(DATA_KEY$6, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config]();
                }
            });
        };
        Dropdown._clearMenus = function _clearMenus(event) {
            if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) return;
            var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));
            for(var i = 0, len = toggles.length; i < len; i++){
                var parent = Dropdown._getParentFromElement(toggles[i]);
                var context = $__default["default"](toggles[i]).data(DATA_KEY$6);
                var relatedTarget = {
                    relatedTarget: toggles[i]
                };
                if (event && event.type === 'click') relatedTarget.clickEvent = event;
                if (!context) continue;
                var dropdownMenu = context._menu;
                if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$5)) continue;
                if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) continue;
                var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
                $__default["default"](parent).trigger(hideEvent);
                if (hideEvent.isDefaultPrevented()) continue;
                 // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
                toggles[i].setAttribute('aria-expanded', 'false');
                if (context._popper) context._popper.destroy();
                $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$5);
                $__default["default"](parent).removeClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
            }
        };
        Dropdown._getParentFromElement = function _getParentFromElement(element) {
            var parent;
            var selector = Util.getSelectorFromElement(element);
            if (selector) parent = document.querySelector(selector);
            return parent || element.parentNode;
        } // eslint-disable-next-line complexity
        ;
        Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE$1 && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) return;
            if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED$1)) return;
            var parent = Dropdown._getParentFromElement(this);
            var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$5);
            if (!isActive && event.which === ESCAPE_KEYCODE$1) return;
            event.preventDefault();
            event.stopPropagation();
            if (!isActive || event.which === ESCAPE_KEYCODE$1 || event.which === SPACE_KEYCODE) {
                if (event.which === ESCAPE_KEYCODE$1) $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger('focus');
                $__default["default"](this).trigger('click');
                return;
            }
            var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function(item) {
                return $__default["default"](item).is(':visible');
            });
            if (items.length === 0) return;
            var index = items.indexOf(event.target);
            if (event.which === ARROW_UP_KEYCODE && index > 0) // Up
            index--;
            if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) // Down
            index++;
            if (index < 0) index = 0;
            items[index].focus();
        };
        _createClass(Dropdown, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$6;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$5;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$5;
                }
            }
        ]);
        return Dropdown;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$2 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        event.preventDefault();
        event.stopPropagation();
        Dropdown._jQueryInterface.call($__default["default"](this), 'toggle');
    }).on(EVENT_CLICK_DATA_API$2, SELECTOR_FORM_CHILD, function(e) {
        e.stopPropagation();
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$6] = Dropdown._jQueryInterface;
    $__default["default"].fn[NAME$6].Constructor = Dropdown;
    $__default["default"].fn[NAME$6].noConflict = function() {
        $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
        return Dropdown._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$5 = 'modal';
    var VERSION$5 = '4.6.2';
    var DATA_KEY$5 = 'bs.modal';
    var EVENT_KEY$5 = "." + DATA_KEY$5;
    var DATA_API_KEY$2 = '.data-api';
    var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
    var CLASS_NAME_SCROLLABLE = 'modal-dialog-scrollable';
    var CLASS_NAME_SCROLLBAR_MEASURER = 'modal-scrollbar-measure';
    var CLASS_NAME_BACKDROP = 'modal-backdrop';
    var CLASS_NAME_OPEN = 'modal-open';
    var CLASS_NAME_FADE$4 = 'fade';
    var CLASS_NAME_SHOW$4 = 'show';
    var CLASS_NAME_STATIC = 'modal-static';
    var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
    var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
    var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
    var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
    var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
    var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
    var EVENT_RESIZE = "resize" + EVENT_KEY$5;
    var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$5;
    var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
    var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$5 + DATA_API_KEY$2;
    var SELECTOR_DIALOG = '.modal-dialog';
    var SELECTOR_MODAL_BODY = '.modal-body';
    var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="modal"]';
    var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="modal"]';
    var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
    var SELECTOR_STICKY_CONTENT = '.sticky-top';
    var Default$4 = {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true
    };
    var DefaultType$4 = {
        backdrop: '(boolean|string)',
        keyboard: 'boolean',
        focus: 'boolean',
        show: 'boolean'
    };
    /**
   * Class definition
   */ var Modal = /*#__PURE__*/ function() {
        function Modal(element, config) {
            this._config = this._getConfig(config);
            this._element = element;
            this._dialog = element.querySelector(SELECTOR_DIALOG);
            this._backdrop = null;
            this._isShown = false;
            this._isBodyOverflowing = false;
            this._ignoreBackdropClick = false;
            this._isTransitioning = false;
            this._scrollbarWidth = 0;
        } // Getters
        var _proto = Modal.prototype;
        // Public
        _proto.toggle = function toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        };
        _proto.show = function show(relatedTarget) {
            var _this = this;
            if (this._isShown || this._isTransitioning) return;
            var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
                relatedTarget: relatedTarget
            });
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._isShown = true;
            if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) this._isTransitioning = true;
            this._checkScrollbar();
            this._setScrollbar();
            this._adjustDialog();
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function(event) {
                return _this.hide(event);
            });
            $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function() {
                $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function(event) {
                    if ($__default["default"](event.target).is(_this._element)) _this._ignoreBackdropClick = true;
                });
            });
            this._showBackdrop(function() {
                return _this._showElement(relatedTarget);
            });
        };
        _proto.hide = function hide(event) {
            var _this2 = this;
            if (event) event.preventDefault();
            if (!this._isShown || this._isTransitioning) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
            $__default["default"](this._element).trigger(hideEvent);
            if (!this._isShown || hideEvent.isDefaultPrevented()) return;
            this._isShown = false;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
            if (transition) this._isTransitioning = true;
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$4);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
            $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, function(event) {
                    return _this2._hideModal(event);
                }).emulateTransitionEnd(transitionDuration);
            } else this._hideModal();
        };
        _proto.dispose = function dispose() {
            [
                window,
                this._element,
                this._dialog
            ].forEach(function(htmlElement) {
                return $__default["default"](htmlElement).off(EVENT_KEY$5);
            });
            /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */ $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"].removeData(this._element, DATA_KEY$5);
            this._config = null;
            this._element = null;
            this._dialog = null;
            this._backdrop = null;
            this._isShown = null;
            this._isBodyOverflowing = null;
            this._ignoreBackdropClick = null;
            this._isTransitioning = null;
            this._scrollbarWidth = null;
        };
        _proto.handleUpdate = function handleUpdate() {
            this._adjustDialog();
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$4, config);
            Util.typeCheckConfig(NAME$5, config, DefaultType$4);
            return config;
        };
        _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
            var _this3 = this;
            var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
            $__default["default"](this._element).trigger(hideEventPrevented);
            if (hideEventPrevented.isDefaultPrevented()) return;
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
            this._element.classList.add(CLASS_NAME_STATIC);
            var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
            $__default["default"](this._element).off(Util.TRANSITION_END);
            $__default["default"](this._element).one(Util.TRANSITION_END, function() {
                _this3._element.classList.remove(CLASS_NAME_STATIC);
                if (!isModalOverflowing) $__default["default"](_this3._element).one(Util.TRANSITION_END, function() {
                    _this3._element.style.overflowY = '';
                }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
            }).emulateTransitionEnd(modalTransitionDuration);
            this._element.focus();
        };
        _proto._showElement = function _showElement(relatedTarget) {
            var _this4 = this;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
            var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;
            if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) // Don't move modal's DOM position
            document.body.appendChild(this._element);
            this._element.style.display = 'block';
            this._element.removeAttribute('aria-hidden');
            this._element.setAttribute('aria-modal', true);
            this._element.setAttribute('role', 'dialog');
            if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) modalBody.scrollTop = 0;
            else this._element.scrollTop = 0;
            if (transition) Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_SHOW$4);
            if (this._config.focus) this._enforceFocus();
            var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
                relatedTarget: relatedTarget
            });
            var transitionComplete = function transitionComplete() {
                if (_this4._config.focus) _this4._element.focus();
                _this4._isTransitioning = false;
                $__default["default"](_this4._element).trigger(shownEvent);
            };
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
                $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
            } else transitionComplete();
        };
        _proto._enforceFocus = function _enforceFocus() {
            var _this5 = this;
            $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
            .on(EVENT_FOCUSIN, function(event) {
                if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) _this5._element.focus();
            });
        };
        _proto._setEscapeEvent = function _setEscapeEvent() {
            var _this6 = this;
            if (this._isShown) $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function(event) {
                if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
                    event.preventDefault();
                    _this6.hide();
                } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE) _this6._triggerBackdropTransition();
            });
            else if (!this._isShown) $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
        };
        _proto._setResizeEvent = function _setResizeEvent() {
            var _this7 = this;
            if (this._isShown) $__default["default"](window).on(EVENT_RESIZE, function(event) {
                return _this7.handleUpdate(event);
            });
            else $__default["default"](window).off(EVENT_RESIZE);
        };
        _proto._hideModal = function _hideModal() {
            var _this8 = this;
            this._element.style.display = 'none';
            this._element.setAttribute('aria-hidden', true);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            this._isTransitioning = false;
            this._showBackdrop(function() {
                $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);
                _this8._resetAdjustments();
                _this8._resetScrollbar();
                $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
            });
        };
        _proto._removeBackdrop = function _removeBackdrop() {
            if (this._backdrop) {
                $__default["default"](this._backdrop).remove();
                this._backdrop = null;
            }
        };
        _proto._showBackdrop = function _showBackdrop(callback) {
            var _this9 = this;
            var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4) ? CLASS_NAME_FADE$4 : '';
            if (this._isShown && this._config.backdrop) {
                this._backdrop = document.createElement('div');
                this._backdrop.className = CLASS_NAME_BACKDROP;
                if (animate) this._backdrop.classList.add(animate);
                $__default["default"](this._backdrop).appendTo(document.body);
                $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, function(event) {
                    if (_this9._ignoreBackdropClick) {
                        _this9._ignoreBackdropClick = false;
                        return;
                    }
                    if (event.target !== event.currentTarget) return;
                    if (_this9._config.backdrop === 'static') _this9._triggerBackdropTransition();
                    else _this9.hide();
                });
                if (animate) Util.reflow(this._backdrop);
                $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$4);
                if (!callback) return;
                if (!animate) {
                    callback();
                    return;
                }
                var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
            } else if (!this._isShown && this._backdrop) {
                $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$4);
                var callbackRemove = function callbackRemove() {
                    _this9._removeBackdrop();
                    if (callback) callback();
                };
                if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
                    var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                    $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
                } else callbackRemove();
            } else if (callback) callback();
        } // ----------------------------------------------------------------------
        ;
        _proto._adjustDialog = function _adjustDialog() {
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!this._isBodyOverflowing && isModalOverflowing) this._element.style.paddingLeft = this._scrollbarWidth + "px";
            if (this._isBodyOverflowing && !isModalOverflowing) this._element.style.paddingRight = this._scrollbarWidth + "px";
        };
        _proto._resetAdjustments = function _resetAdjustments() {
            this._element.style.paddingLeft = '';
            this._element.style.paddingRight = '';
        };
        _proto._checkScrollbar = function _checkScrollbar() {
            var rect = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
            this._scrollbarWidth = this._getScrollbarWidth();
        };
        _proto._setScrollbar = function _setScrollbar() {
            var _this10 = this;
            if (this._isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
                var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding
                $__default["default"](fixedContent).each(function(index, element) {
                    var actualPadding = element.style.paddingRight;
                    var calculatedPadding = $__default["default"](element).css('padding-right');
                    $__default["default"](element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
                }); // Adjust sticky content margin
                $__default["default"](stickyContent).each(function(index, element) {
                    var actualMargin = element.style.marginRight;
                    var calculatedMargin = $__default["default"](element).css('margin-right');
                    $__default["default"](element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
                }); // Adjust body padding
                var actualPadding = document.body.style.paddingRight;
                var calculatedPadding = $__default["default"](document.body).css('padding-right');
                $__default["default"](document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
            }
            $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
        };
        _proto._resetScrollbar = function _resetScrollbar() {
            // Restore fixed content padding
            var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
            $__default["default"](fixedContent).each(function(index, element) {
                var padding = $__default["default"](element).data('padding-right');
                $__default["default"](element).removeData('padding-right');
                element.style.paddingRight = padding ? padding : '';
            }); // Restore sticky content
            var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
            $__default["default"](elements).each(function(index, element) {
                var margin = $__default["default"](element).data('margin-right');
                if (typeof margin !== 'undefined') $__default["default"](element).css('margin-right', margin).removeData('margin-right');
            }); // Restore body padding
            var padding = $__default["default"](document.body).data('padding-right');
            $__default["default"](document.body).removeData('padding-right');
            document.body.style.paddingRight = padding ? padding : '';
        };
        _proto._getScrollbarWidth = function _getScrollbarWidth() {
            // thx d.walsh
            var scrollDiv = document.createElement('div');
            scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
            document.body.appendChild(scrollDiv);
            var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return scrollbarWidth;
        } // Static
        ;
        Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$5);
                var _config = _extends({}, Default$4, $__default["default"](this).data(), typeof config === 'object' && config ? config : {});
                if (!data) {
                    data = new Modal(this, _config);
                    $__default["default"](this).data(DATA_KEY$5, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config](relatedTarget);
                } else if (_config.show) data.show(relatedTarget);
            });
        };
        _createClass(Modal, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$5;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$4;
                }
            }
        ]);
        return Modal;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        var _this11 = this;
        var target;
        var selector = Util.getSelectorFromElement(this);
        if (selector) target = document.querySelector(selector);
        var config = $__default["default"](target).data(DATA_KEY$5) ? 'toggle' : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
        if (this.tagName === 'A' || this.tagName === 'AREA') event.preventDefault();
        var $target = $__default["default"](target).one(EVENT_SHOW$2, function(showEvent) {
            if (showEvent.isDefaultPrevented()) // Only register focus restorer if modal will actually get shown
            return;
            $target.one(EVENT_HIDDEN$2, function() {
                if ($__default["default"](_this11).is(':visible')) _this11.focus();
            });
        });
        Modal._jQueryInterface.call($__default["default"](target), config, this);
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
    $__default["default"].fn[NAME$5].Constructor = Modal;
    $__default["default"].fn[NAME$5].noConflict = function() {
        $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
        return Modal._jQueryInterface;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var uriAttrs = [
        'background',
        'cite',
        'href',
        'itemtype',
        'longdesc',
        'poster',
        'src',
        'xlink:href'
    ];
    var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    var DefaultWhitelist = {
        // Global attributes allowed on any supplied element below.
        '*': [
            'class',
            'dir',
            'id',
            'lang',
            'role',
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            'target',
            'href',
            'title',
            'rel'
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            'src',
            'srcset',
            'alt',
            'title',
            'width',
            'height'
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
    /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function allowedAttribute(attr, allowedAttributeList) {
        var attrName = attr.nodeName.toLowerCase();
        if (allowedAttributeList.indexOf(attrName) !== -1) {
            if (uriAttrs.indexOf(attrName) !== -1) return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
            return true;
        }
        var regExp = allowedAttributeList.filter(function(attrRegex) {
            return attrRegex instanceof RegExp;
        }); // Check if a regular expression validates the attribute.
        for(var i = 0, len = regExp.length; i < len; i++){
            if (regExp[i].test(attrName)) return true;
        }
        return false;
    }
    function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
        if (unsafeHtml.length === 0) return unsafeHtml;
        if (sanitizeFn && typeof sanitizeFn === 'function') return sanitizeFn(unsafeHtml);
        var domParser = new window.DOMParser();
        var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
        var whitelistKeys = Object.keys(whiteList);
        var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));
        var _loop = function _loop(i, len) {
            var el = elements[i];
            var elName = el.nodeName.toLowerCase();
            if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
                el.parentNode.removeChild(el);
                return "continue";
            }
            var attributeList = [].slice.call(el.attributes); // eslint-disable-next-line unicorn/prefer-spread
            var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
            attributeList.forEach(function(attr) {
                if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
            });
        };
        for(var i = 0, len = elements.length; i < len; i++){
            var _ret = _loop(i);
            if (_ret === "continue") continue;
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * Constants
   */ var NAME$4 = 'tooltip';
    var VERSION$4 = '4.6.2';
    var DATA_KEY$4 = 'bs.tooltip';
    var EVENT_KEY$4 = "." + DATA_KEY$4;
    var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
    var CLASS_PREFIX$1 = 'bs-tooltip';
    var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');
    var DISALLOWED_ATTRIBUTES = [
        'sanitize',
        'whiteList',
        'sanitizeFn'
    ];
    var CLASS_NAME_FADE$3 = 'fade';
    var CLASS_NAME_SHOW$3 = 'show';
    var HOVER_STATE_SHOW = 'show';
    var HOVER_STATE_OUT = 'out';
    var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
    var SELECTOR_ARROW = '.arrow';
    var TRIGGER_HOVER = 'hover';
    var TRIGGER_FOCUS = 'focus';
    var TRIGGER_CLICK = 'click';
    var TRIGGER_MANUAL = 'manual';
    var AttachmentMap = {
        AUTO: 'auto',
        TOP: 'top',
        RIGHT: 'right',
        BOTTOM: 'bottom',
        LEFT: 'left'
    };
    var Default$3 = {
        animation: true,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        title: '',
        delay: 0,
        html: false,
        selector: false,
        placement: 'top',
        offset: 0,
        container: false,
        fallbackPlacement: 'flip',
        boundary: 'scrollParent',
        customClass: '',
        sanitize: true,
        sanitizeFn: null,
        whiteList: DefaultWhitelist,
        popperConfig: null
    };
    var DefaultType$3 = {
        animation: 'boolean',
        template: 'string',
        title: '(string|element|function)',
        trigger: 'string',
        delay: '(number|object)',
        html: 'boolean',
        selector: '(string|boolean)',
        placement: '(string|function)',
        offset: '(number|string|function)',
        container: '(string|element|boolean)',
        fallbackPlacement: '(string|array)',
        boundary: '(string|element)',
        customClass: '(string|function)',
        sanitize: 'boolean',
        sanitizeFn: '(null|function)',
        whiteList: 'object',
        popperConfig: '(null|object)'
    };
    var Event$1 = {
        HIDE: "hide" + EVENT_KEY$4,
        HIDDEN: "hidden" + EVENT_KEY$4,
        SHOW: "show" + EVENT_KEY$4,
        SHOWN: "shown" + EVENT_KEY$4,
        INSERTED: "inserted" + EVENT_KEY$4,
        CLICK: "click" + EVENT_KEY$4,
        FOCUSIN: "focusin" + EVENT_KEY$4,
        FOCUSOUT: "focusout" + EVENT_KEY$4,
        MOUSEENTER: "mouseenter" + EVENT_KEY$4,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$4
    };
    /**
   * Class definition
   */ var Tooltip = /*#__PURE__*/ function() {
        function Tooltip(element, config) {
            if (typeof Popper__default["default"] === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
             // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._hoverState = '';
            this._activeTrigger = {};
            this._popper = null; // Protected
            this.element = element;
            this.config = this._getConfig(config);
            this.tip = null;
            this._setListeners();
        } // Getters
        var _proto = Tooltip.prototype;
        // Public
        _proto.enable = function enable() {
            this._isEnabled = true;
        };
        _proto.disable = function disable() {
            this._isEnabled = false;
        };
        _proto.toggleEnabled = function toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        };
        _proto.toggle = function toggle(event) {
            if (!this._isEnabled) return;
            if (event) {
                var dataKey = this.constructor.DATA_KEY;
                var context = $__default["default"](event.currentTarget).data(dataKey);
                if (!context) {
                    context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                    $__default["default"](event.currentTarget).data(dataKey, context);
                }
                context._activeTrigger.click = !context._activeTrigger.click;
                if (context._isWithActiveTrigger()) context._enter(null, context);
                else context._leave(null, context);
            } else {
                if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$3)) {
                    this._leave(null, this);
                    return;
                }
                this._enter(null, this);
            }
        };
        _proto.dispose = function dispose() {
            clearTimeout(this._timeout);
            $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
            $__default["default"](this.element).off(this.constructor.EVENT_KEY);
            $__default["default"](this.element).closest('.modal').off('hide.bs.modal', this._hideModalHandler);
            if (this.tip) $__default["default"](this.tip).remove();
            this._isEnabled = null;
            this._timeout = null;
            this._hoverState = null;
            this._activeTrigger = null;
            if (this._popper) this._popper.destroy();
            this._popper = null;
            this.element = null;
            this.config = null;
            this.tip = null;
        };
        _proto.show = function show() {
            var _this = this;
            if ($__default["default"](this.element).css('display') === 'none') throw new Error('Please use show on visible elements');
            var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                $__default["default"](this.element).trigger(showEvent);
                var shadowRoot = Util.findShadowRoot(this.element);
                var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);
                if (showEvent.isDefaultPrevented() || !isInTheDom) return;
                var tip = this.getTipElement();
                var tipId = Util.getUID(this.constructor.NAME);
                tip.setAttribute('id', tipId);
                this.element.setAttribute('aria-describedby', tipId);
                this.setContent();
                if (this.config.animation) $__default["default"](tip).addClass(CLASS_NAME_FADE$3);
                var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;
                var attachment = this._getAttachment(placement);
                this.addAttachmentClass(attachment);
                var container = this._getContainer();
                $__default["default"](tip).data(this.constructor.DATA_KEY, this);
                if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) $__default["default"](tip).appendTo(container);
                $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
                this._popper = new Popper__default["default"](this.element, tip, this._getPopperConfig(attachment));
                $__default["default"](tip).addClass(CLASS_NAME_SHOW$3);
                $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
                var complete = function complete() {
                    if (_this.config.animation) _this._fixTransition();
                    var prevHoverState = _this._hoverState;
                    _this._hoverState = null;
                    $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);
                    if (prevHoverState === HOVER_STATE_OUT) _this._leave(null, _this);
                };
                if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
                    var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
                    $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                } else complete();
            }
        };
        _proto.hide = function hide(callback) {
            var _this2 = this;
            var tip = this.getTipElement();
            var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);
            var complete = function complete() {
                if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) tip.parentNode.removeChild(tip);
                _this2._cleanTipClass();
                _this2.element.removeAttribute('aria-describedby');
                $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);
                if (_this2._popper !== null) _this2._popper.destroy();
                if (callback) callback();
            };
            $__default["default"](this.element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            $__default["default"](tip).removeClass(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ('ontouchstart' in document.documentElement) $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
                var transitionDuration = Util.getTransitionDurationFromElement(tip);
                $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
            this._hoverState = '';
        };
        _proto.update = function update() {
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Protected
        ;
        _proto.isWithContent = function isWithContent() {
            return Boolean(this.getTitle());
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var tip = this.getTipElement();
            this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$3);
        };
        _proto.setElementContent = function setElementContent($element, content) {
            if (typeof content === 'object' && (content.nodeType || content.jquery)) {
                // Content is a DOM node or a jQuery
                if (this.config.html) {
                    if (!$__default["default"](content).parent().is($element)) $element.empty().append(content);
                } else $element.text($__default["default"](content).text());
                return;
            }
            if (this.config.html) {
                if (this.config.sanitize) content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
                $element.html(content);
            } else $element.text(content);
        };
        _proto.getTitle = function getTitle() {
            var title = this.element.getAttribute('data-original-title');
            if (!title) title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
            return title;
        } // Private
        ;
        _proto._getPopperConfig = function _getPopperConfig(attachment) {
            var _this3 = this;
            var defaultBsConfig = {
                placement: attachment,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: SELECTOR_ARROW
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function onCreate(data) {
                    if (data.originalPlacement !== data.placement) _this3._handlePopperPlacementChange(data);
                },
                onUpdate: function onUpdate(data) {
                    return _this3._handlePopperPlacementChange(data);
                }
            };
            return _extends({}, defaultBsConfig, this.config.popperConfig);
        };
        _proto._getOffset = function _getOffset() {
            var _this4 = this;
            var offset = {};
            if (typeof this.config.offset === 'function') offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element));
                return data;
            };
            else offset.offset = this.config.offset;
            return offset;
        };
        _proto._getContainer = function _getContainer() {
            if (this.config.container === false) return document.body;
            if (Util.isElement(this.config.container)) return $__default["default"](this.config.container);
            return $__default["default"](document).find(this.config.container);
        };
        _proto._getAttachment = function _getAttachment(placement) {
            return AttachmentMap[placement.toUpperCase()];
        };
        _proto._setListeners = function _setListeners() {
            var _this5 = this;
            var triggers = this.config.trigger.split(' ');
            triggers.forEach(function(trigger) {
                if (trigger === 'click') $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function(event) {
                    return _this5.toggle(event);
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
                    var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
                    $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function(event) {
                        return _this5._enter(event);
                    }).on(eventOut, _this5.config.selector, function(event) {
                        return _this5._leave(event);
                    });
                }
            });
            this._hideModalHandler = function() {
                if (_this5.element) _this5.hide();
            };
            $__default["default"](this.element).closest('.modal').on('hide.bs.modal', this._hideModalHandler);
            if (this.config.selector) this.config = _extends({}, this.config, {
                trigger: 'manual',
                selector: ''
            });
            else this._fixTitle();
        };
        _proto._fixTitle = function _fixTitle() {
            var titleType = typeof this.element.getAttribute('data-original-title');
            if (this.element.getAttribute('title') || titleType !== 'string') {
                this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
                this.element.setAttribute('title', '');
            }
        };
        _proto._enter = function _enter(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
            if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
                context._hoverState = HOVER_STATE_SHOW;
                return;
            }
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_SHOW;
            if (!context.config.delay || !context.config.delay.show) {
                context.show();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_SHOW) context.show();
            }, context.config.delay.show);
        };
        _proto._leave = function _leave(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
            if (context._isWithActiveTrigger()) return;
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_OUT;
            if (!context.config.delay || !context.config.delay.hide) {
                context.hide();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_OUT) context.hide();
            }, context.config.delay.hide);
        };
        _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
            for(var trigger in this._activeTrigger){
                if (this._activeTrigger[trigger]) return true;
            }
            return false;
        };
        _proto._getConfig = function _getConfig(config) {
            var dataAttributes = $__default["default"](this.element).data();
            Object.keys(dataAttributes).forEach(function(dataAttr) {
                if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) delete dataAttributes[dataAttr];
            });
            config = _extends({}, this.constructor.Default, dataAttributes, typeof config === 'object' && config ? config : {});
            if (typeof config.delay === 'number') config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === 'number') config.title = config.title.toString();
            if (typeof config.content === 'number') config.content = config.content.toString();
            Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
            if (config.sanitize) config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
            return config;
        };
        _proto._getDelegateConfig = function _getDelegateConfig() {
            var config = {};
            if (this.config) {
                for(var key in this.config)if (this.constructor.Default[key] !== this.config[key]) config[key] = this.config[key];
            }
            return config;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX$1);
            if (tabClass !== null && tabClass.length) $tip.removeClass(tabClass.join(''));
        };
        _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
            this.tip = popperData.instance.popper;
            this._cleanTipClass();
            this.addAttachmentClass(this._getAttachment(popperData.placement));
        };
        _proto._fixTransition = function _fixTransition() {
            var tip = this.getTipElement();
            var initConfigAnimation = this.config.animation;
            if (tip.getAttribute('x-placement') !== null) return;
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$3);
            this.config.animation = false;
            this.hide();
            this.show();
            this.config.animation = initConfigAnimation;
        } // Static
        ;
        Tooltip._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$4);
                var _config = typeof config === 'object' && config;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Tooltip(this, _config);
                    $element.data(DATA_KEY$4, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config]();
                }
            });
        };
        _createClass(Tooltip, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$4;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$3;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$4;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$4;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event$1;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$4;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$3;
                }
            }
        ]);
        return Tooltip;
    }();
    /**
   * jQuery
   */ $__default["default"].fn[NAME$4] = Tooltip._jQueryInterface;
    $__default["default"].fn[NAME$4].Constructor = Tooltip;
    $__default["default"].fn[NAME$4].noConflict = function() {
        $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
        return Tooltip._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$3 = 'popover';
    var VERSION$3 = '4.6.2';
    var DATA_KEY$3 = 'bs.popover';
    var EVENT_KEY$3 = "." + DATA_KEY$3;
    var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
    var CLASS_PREFIX = 'bs-popover';
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
    var CLASS_NAME_FADE$2 = 'fade';
    var CLASS_NAME_SHOW$2 = 'show';
    var SELECTOR_TITLE = '.popover-header';
    var SELECTOR_CONTENT = '.popover-body';
    var Default$2 = _extends({}, Tooltip.Default, {
        placement: 'right',
        trigger: 'click',
        content: '',
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
    var DefaultType$2 = _extends({}, Tooltip.DefaultType, {
        content: '(string|element|function)'
    });
    var Event = {
        HIDE: "hide" + EVENT_KEY$3,
        HIDDEN: "hidden" + EVENT_KEY$3,
        SHOW: "show" + EVENT_KEY$3,
        SHOWN: "shown" + EVENT_KEY$3,
        INSERTED: "inserted" + EVENT_KEY$3,
        CLICK: "click" + EVENT_KEY$3,
        FOCUSIN: "focusin" + EVENT_KEY$3,
        FOCUSOUT: "focusout" + EVENT_KEY$3,
        MOUSEENTER: "mouseenter" + EVENT_KEY$3,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$3
    };
    /**
   * Class definition
   */ var Popover = /*#__PURE__*/ function(_Tooltip) {
        _inheritsLoose(Popover, _Tooltip);
        function Popover() {
            return _Tooltip.apply(this, arguments) || this;
        }
        var _proto = Popover.prototype;
        // Overrides
        _proto.isWithContent = function isWithContent() {
            return this.getTitle() || this._getContent();
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events
            this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());
            var content = this._getContent();
            if (typeof content === 'function') content = content.call(this.element);
            this.setElementContent($tip.find(SELECTOR_CONTENT), content);
            $tip.removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$2);
        } // Private
        ;
        _proto._getContent = function _getContent() {
            return this.element.getAttribute('data-content') || this.config.content;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);
            if (tabClass !== null && tabClass.length > 0) $tip.removeClass(tabClass.join(''));
        } // Static
        ;
        Popover._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$3);
                var _config = typeof config === 'object' ? config : null;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Popover(this, _config);
                    $__default["default"](this).data(DATA_KEY$3, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config]();
                }
            });
        };
        _createClass(Popover, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$3;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$2;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$3;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$3;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$3;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$2;
                }
            }
        ]);
        return Popover;
    }(Tooltip);
    /**
   * jQuery
   */ $__default["default"].fn[NAME$3] = Popover._jQueryInterface;
    $__default["default"].fn[NAME$3].Constructor = Popover;
    $__default["default"].fn[NAME$3].noConflict = function() {
        $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
        return Popover._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$2 = 'scrollspy';
    var VERSION$2 = '4.6.2';
    var DATA_KEY$2 = 'bs.scrollspy';
    var EVENT_KEY$2 = "." + DATA_KEY$2;
    var DATA_API_KEY$1 = '.data-api';
    var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
    var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
    var CLASS_NAME_ACTIVE$1 = 'active';
    var EVENT_ACTIVATE = "activate" + EVENT_KEY$2;
    var EVENT_SCROLL = "scroll" + EVENT_KEY$2;
    var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$1;
    var METHOD_OFFSET = 'offset';
    var METHOD_POSITION = 'position';
    var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
    var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
    var SELECTOR_NAV_LINKS = '.nav-link';
    var SELECTOR_NAV_ITEMS = '.nav-item';
    var SELECTOR_LIST_ITEMS = '.list-group-item';
    var SELECTOR_DROPDOWN$1 = '.dropdown';
    var SELECTOR_DROPDOWN_ITEMS = '.dropdown-item';
    var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
    var Default$1 = {
        offset: 10,
        method: 'auto',
        target: ''
    };
    var DefaultType$1 = {
        offset: 'number',
        method: 'string',
        target: '(string|element)'
    };
    /**
   * Class definition
   */ var ScrollSpy = /*#__PURE__*/ function() {
        function ScrollSpy(element, config) {
            var _this = this;
            this._element = element;
            this._scrollElement = element.tagName === 'BODY' ? window : element;
            this._config = this._getConfig(config);
            this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
            this._offsets = [];
            this._targets = [];
            this._activeTarget = null;
            this._scrollHeight = 0;
            $__default["default"](this._scrollElement).on(EVENT_SCROLL, function(event) {
                return _this._process(event);
            });
            this.refresh();
            this._process();
        } // Getters
        var _proto = ScrollSpy.prototype;
        // Public
        _proto.refresh = function refresh() {
            var _this2 = this;
            var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
            var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
            var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
            this._offsets = [];
            this._targets = [];
            this._scrollHeight = this._getScrollHeight();
            var targets = [].slice.call(document.querySelectorAll(this._selector));
            targets.map(function(element) {
                var target;
                var targetSelector = Util.getSelectorFromElement(element);
                if (targetSelector) target = document.querySelector(targetSelector);
                if (target) {
                    var targetBCR = target.getBoundingClientRect();
                    if (targetBCR.width || targetBCR.height) // TODO (fat): remove sketch reliance on jQuery position/offset
                    return [
                        $__default["default"](target)[offsetMethod]().top + offsetBase,
                        targetSelector
                    ];
                }
                return null;
            }).filter(Boolean).sort(function(a, b) {
                return a[0] - b[0];
            }).forEach(function(item) {
                _this2._offsets.push(item[0]);
                _this2._targets.push(item[1]);
            });
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$2);
            $__default["default"](this._scrollElement).off(EVENT_KEY$2);
            this._element = null;
            this._scrollElement = null;
            this._config = null;
            this._selector = null;
            this._offsets = null;
            this._targets = null;
            this._activeTarget = null;
            this._scrollHeight = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$1, typeof config === 'object' && config ? config : {});
            if (typeof config.target !== 'string' && Util.isElement(config.target)) {
                var id = $__default["default"](config.target).attr('id');
                if (!id) {
                    id = Util.getUID(NAME$2);
                    $__default["default"](config.target).attr('id', id);
                }
                config.target = "#" + id;
            }
            Util.typeCheckConfig(NAME$2, config, DefaultType$1);
            return config;
        };
        _proto._getScrollTop = function _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        };
        _proto._getScrollHeight = function _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        };
        _proto._getOffsetHeight = function _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        };
        _proto._process = function _process() {
            var scrollTop = this._getScrollTop() + this._config.offset;
            var scrollHeight = this._getScrollHeight();
            var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
            if (this._scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                var target = this._targets[this._targets.length - 1];
                if (this._activeTarget !== target) this._activate(target);
                return;
            }
            if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;
                this._clear();
                return;
            }
            for(var i = this._offsets.length; i--;){
                var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);
                if (isActiveTarget) this._activate(this._targets[i]);
            }
        };
        _proto._activate = function _activate(target) {
            this._activeTarget = target;
            this._clear();
            var queries = this._selector.split(',').map(function(selector) {
                return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
            });
            var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(','))));
            if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
                $link.closest(SELECTOR_DROPDOWN$1).find(SELECTOR_DROPDOWN_TOGGLE$1).addClass(CLASS_NAME_ACTIVE$1);
                $link.addClass(CLASS_NAME_ACTIVE$1);
            } else {
                // Set triggered link as active
                $link.addClass(CLASS_NAME_ACTIVE$1); // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$1); // Handle special case when .nav-link is inside .nav-item
                $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$1);
            }
            $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
                relatedTarget: target
            });
        };
        _proto._clear = function _clear() {
            [].slice.call(document.querySelectorAll(this._selector)).filter(function(node) {
                return node.classList.contains(CLASS_NAME_ACTIVE$1);
            }).forEach(function(node) {
                return node.classList.remove(CLASS_NAME_ACTIVE$1);
            });
        } // Static
        ;
        ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$2);
                var _config = typeof config === 'object' && config;
                if (!data) {
                    data = new ScrollSpy(this, _config);
                    $__default["default"](this).data(DATA_KEY$2, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config]();
                }
            });
        };
        _createClass(ScrollSpy, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$2;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$1;
                }
            }
        ]);
        return ScrollSpy;
    }();
    /**
   * Data API implementation
   */ $__default["default"](window).on(EVENT_LOAD_DATA_API, function() {
        var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
        var scrollSpysLength = scrollSpys.length;
        for(var i = scrollSpysLength; i--;){
            var $spy = $__default["default"](scrollSpys[i]);
            ScrollSpy._jQueryInterface.call($spy, $spy.data());
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$2] = ScrollSpy._jQueryInterface;
    $__default["default"].fn[NAME$2].Constructor = ScrollSpy;
    $__default["default"].fn[NAME$2].noConflict = function() {
        $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
        return ScrollSpy._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$1 = 'tab';
    var VERSION$1 = '4.6.2';
    var DATA_KEY$1 = 'bs.tab';
    var EVENT_KEY$1 = "." + DATA_KEY$1;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
    var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
    var CLASS_NAME_ACTIVE = 'active';
    var CLASS_NAME_DISABLED = 'disabled';
    var CLASS_NAME_FADE$1 = 'fade';
    var CLASS_NAME_SHOW$1 = 'show';
    var EVENT_HIDE$1 = "hide" + EVENT_KEY$1;
    var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$1;
    var EVENT_SHOW$1 = "show" + EVENT_KEY$1;
    var EVENT_SHOWN$1 = "shown" + EVENT_KEY$1;
    var EVENT_CLICK_DATA_API = "click" + EVENT_KEY$1 + DATA_API_KEY;
    var SELECTOR_DROPDOWN = '.dropdown';
    var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
    var SELECTOR_ACTIVE = '.active';
    var SELECTOR_ACTIVE_UL = '> li > .active';
    var SELECTOR_DATA_TOGGLE = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
    var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
    var SELECTOR_DROPDOWN_ACTIVE_CHILD = '> .dropdown-menu .active';
    /**
   * Class definition
   */ var Tab = /*#__PURE__*/ function() {
        function Tab(element) {
            this._element = element;
        } // Getters
        var _proto = Tab.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || this._element.hasAttribute('disabled')) return;
            var target;
            var previous;
            var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP)[0];
            var selector = Util.getSelectorFromElement(this._element);
            if (listElement) {
                var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
                previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
                previous = previous[previous.length - 1];
            }
            var hideEvent = $__default["default"].Event(EVENT_HIDE$1, {
                relatedTarget: this._element
            });
            var showEvent = $__default["default"].Event(EVENT_SHOW$1, {
                relatedTarget: previous
            });
            if (previous) $__default["default"](previous).trigger(hideEvent);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
            if (selector) target = document.querySelector(selector);
            this._activate(this._element, listElement);
            var complete = function complete() {
                var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$1, {
                    relatedTarget: _this._element
                });
                var shownEvent = $__default["default"].Event(EVENT_SHOWN$1, {
                    relatedTarget: previous
                });
                $__default["default"](previous).trigger(hiddenEvent);
                $__default["default"](_this._element).trigger(shownEvent);
            };
            if (target) this._activate(target, target.parentNode, complete);
            else complete();
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$1);
            this._element = null;
        } // Private
        ;
        _proto._activate = function _activate(element, container, callback) {
            var _this2 = this;
            var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE);
            var active = activeElements[0];
            var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$1);
            var complete = function complete() {
                return _this2._transitionComplete(element, active, callback);
            };
            if (active && isTransitioning) {
                var transitionDuration = Util.getTransitionDurationFromElement(active);
                $__default["default"](active).removeClass(CLASS_NAME_SHOW$1).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._transitionComplete = function _transitionComplete(element, active, callback) {
            if (active) {
                $__default["default"](active).removeClass(CLASS_NAME_ACTIVE);
                var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];
                if (dropdownChild) $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE);
                if (active.getAttribute('role') === 'tab') active.setAttribute('aria-selected', false);
            }
            $__default["default"](element).addClass(CLASS_NAME_ACTIVE);
            if (element.getAttribute('role') === 'tab') element.setAttribute('aria-selected', true);
            Util.reflow(element);
            if (element.classList.contains(CLASS_NAME_FADE$1)) element.classList.add(CLASS_NAME_SHOW$1);
            var parent = element.parentNode;
            if (parent && parent.nodeName === 'LI') parent = parent.parentNode;
            if (parent && $__default["default"](parent).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
                var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN)[0];
                if (dropdownElement) {
                    var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE));
                    $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE);
                }
                element.setAttribute('aria-expanded', true);
            }
            if (callback) callback();
        } // Static
        ;
        Tab._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $this = $__default["default"](this);
                var data = $this.data(DATA_KEY$1);
                if (!data) {
                    data = new Tab(this);
                    $this.data(DATA_KEY$1, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config]();
                }
            });
        };
        _createClass(Tab, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$1;
                }
            }
        ]);
        return Tab;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        Tab._jQueryInterface.call($__default["default"](this), 'show');
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$1] = Tab._jQueryInterface;
    $__default["default"].fn[NAME$1].Constructor = Tab;
    $__default["default"].fn[NAME$1].noConflict = function() {
        $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
        return Tab._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME = 'toast';
    var VERSION = '4.6.2';
    var DATA_KEY = 'bs.toast';
    var EVENT_KEY = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
    var CLASS_NAME_FADE = 'fade';
    var CLASS_NAME_HIDE = 'hide';
    var CLASS_NAME_SHOW = 'show';
    var CLASS_NAME_SHOWING = 'showing';
    var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY;
    var EVENT_HIDE = "hide" + EVENT_KEY;
    var EVENT_HIDDEN = "hidden" + EVENT_KEY;
    var EVENT_SHOW = "show" + EVENT_KEY;
    var EVENT_SHOWN = "shown" + EVENT_KEY;
    var SELECTOR_DATA_DISMISS = '[data-dismiss="toast"]';
    var Default = {
        animation: true,
        autohide: true,
        delay: 500
    };
    var DefaultType = {
        animation: 'boolean',
        autohide: 'boolean',
        delay: 'number'
    };
    /**
   * Class definition
   */ var Toast = /*#__PURE__*/ function() {
        function Toast(element, config) {
            this._element = element;
            this._config = this._getConfig(config);
            this._timeout = null;
            this._setListeners();
        } // Getters
        var _proto = Toast.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            var showEvent = $__default["default"].Event(EVENT_SHOW);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            var complete = function complete() {
                _this._element.classList.remove(CLASS_NAME_SHOWING);
                _this._element.classList.add(CLASS_NAME_SHOW);
                $__default["default"](_this._element).trigger(EVENT_SHOWN);
                if (_this._config.autohide) _this._timeout = setTimeout(function() {
                    _this.hide();
                }, _this._config.delay);
            };
            this._element.classList.remove(CLASS_NAME_HIDE);
            Util.reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOWING);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto.hide = function hide() {
            if (!this._element.classList.contains(CLASS_NAME_SHOW)) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE);
            $__default["default"](this._element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            this._close();
        };
        _proto.dispose = function dispose() {
            this._clearTimeout();
            if (this._element.classList.contains(CLASS_NAME_SHOW)) this._element.classList.remove(CLASS_NAME_SHOW);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
            $__default["default"].removeData(this._element, DATA_KEY);
            this._element = null;
            this._config = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default, $__default["default"](this._element).data(), typeof config === 'object' && config ? config : {});
            Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
            return config;
        };
        _proto._setListeners = function _setListeners() {
            var _this2 = this;
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function() {
                return _this2.hide();
            });
        };
        _proto._close = function _close() {
            var _this3 = this;
            var complete = function complete() {
                _this3._element.classList.add(CLASS_NAME_HIDE);
                $__default["default"](_this3._element).trigger(EVENT_HIDDEN);
            };
            this._element.classList.remove(CLASS_NAME_SHOW);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._clearTimeout = function _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        } // Static
        ;
        Toast._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY);
                var _config = typeof config === 'object' && config;
                if (!data) {
                    data = new Toast(this, _config);
                    $element.data(DATA_KEY, data);
                }
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError("No method named \"" + config + "\"");
                    data[config](this);
                }
            });
        };
        _createClass(Toast, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            }
        ]);
        return Toast;
    }();
    /**
   * jQuery
   */ $__default["default"].fn[NAME] = Toast._jQueryInterface;
    $__default["default"].fn[NAME].Constructor = Toast;
    $__default["default"].fn[NAME].noConflict = function() {
        $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
        return Toast._jQueryInterface;
    };
    exports1.Alert = Alert;
    exports1.Button = Button;
    exports1.Carousel = Carousel;
    exports1.Collapse = Collapse;
    exports1.Dropdown = Dropdown;
    exports1.Modal = Modal;
    exports1.Popover = Popover;
    exports1.Scrollspy = ScrollSpy;
    exports1.Tab = Tab;
    exports1.Toast = Toast;
    exports1.Tooltip = Tooltip;
    exports1.Util = Util;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



// Import lazysizes
parcelRequire("3fu6U");
var $6b30f036c45bb934$exports = {};

(function(window1, factory) {
    if (!window1) return;
    var globalInstall = function() {
        factory(window1.lazySizes);
        window1.removeEventListener('lazyunveilread', globalInstall, true);
    };
    factory = factory.bind(null, window1, window1.document);
    if ($6b30f036c45bb934$exports) factory((parcelRequire("3fu6U")));
    else if (typeof define == 'function' && define.amd) define([
        'lazysizes'
    ], factory);
    else if (window1.lazySizes) globalInstall();
    else window1.addEventListener('lazyunveilread', globalInstall, true);
})(typeof window != 'undefined' ? window : 0, function(window1, document, lazySizes) {
    /*jshint eqnull:true */ 'use strict';
    var polyfill;
    var lazySizesCfg = lazySizes.cfg;
    var img = document.createElement('img');
    var supportSrcset = 'sizes' in img && 'srcset' in img;
    var regHDesc = /\s+\d+h/g;
    var fixEdgeHDescriptor = function() {
        var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
        var forEach = Array.prototype.forEach;
        return function() {
            var img = document.createElement('img');
            var removeHDescriptors = function(source) {
                var ratio, match;
                var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
                if (srcset) {
                    if (match = srcset.match(regDescriptors)) {
                        if (match[2] == 'w') ratio = match[1] / match[3];
                        else ratio = match[3] / match[1];
                        if (ratio) source.setAttribute('data-aspectratio', ratio);
                        source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ''));
                    }
                }
            };
            var handler = function(e) {
                if (e.detail.instance != lazySizes) return;
                var picture = e.target.parentNode;
                if (picture && picture.nodeName == 'PICTURE') forEach.call(picture.getElementsByTagName('source'), removeHDescriptors);
                removeHDescriptors(e.target);
            };
            var test = function() {
                if (!!img.currentSrc) document.removeEventListener('lazybeforeunveil', handler);
            };
            document.addEventListener('lazybeforeunveil', handler);
            img.onload = test;
            img.onerror = test;
            img.srcset = 'data:,a 1w 1h';
            if (img.complete) test();
        };
    }();
    if (!lazySizesCfg.supportsType) lazySizesCfg.supportsType = function(type /*, elem*/ ) {
        return !type;
    };
    if (window1.HTMLPictureElement && supportSrcset) {
        if (!lazySizes.hasHDescriptorFix && document.msElementsFromPoint) {
            lazySizes.hasHDescriptorFix = true;
            fixEdgeHDescriptor();
        }
        return;
    }
    if (window1.picturefill || lazySizesCfg.pf) return;
    lazySizesCfg.pf = function(options) {
        var i, len;
        if (window1.picturefill) return;
        for(i = 0, len = options.elements.length; i < len; i++)polyfill(options.elements[i]);
    };
    // partial polyfill
    polyfill = function() {
        var ascendingSort = function(a, b) {
            return a.w - b.w;
        };
        var regPxLength = /^\s*\d+\.*\d*px\s*$/;
        var reduceCandidate = function(srces) {
            var lowerCandidate, bonusFactor;
            var len = srces.length;
            var candidate = srces[len - 1];
            var i = 0;
            for(i; i < len; i++){
                candidate = srces[i];
                candidate.d = candidate.w / srces.w;
                if (candidate.d >= srces.d) {
                    if (!candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)) {
                        bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
                        if (lowerCandidate.cached) lowerCandidate.d += 0.15 * bonusFactor;
                        if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) candidate = lowerCandidate;
                    }
                    break;
                }
            }
            return candidate;
        };
        var parseWsrcset = function() {
            var candidates;
            var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
            var regMultiple = /\s/;
            var addCandidate = function(match, candidate, url, wDescriptor) {
                candidates.push({
                    c: candidate,
                    u: url,
                    w: wDescriptor * 1
                });
            };
            return function(input) {
                candidates = [];
                input = input.trim();
                input.replace(regHDesc, '').replace(regWCandidates, addCandidate);
                if (!candidates.length && input && !regMultiple.test(input)) candidates.push({
                    c: input,
                    u: input,
                    w: 99
                });
                return candidates;
            };
        }();
        var runMatchMedia = function() {
            if (runMatchMedia.init) return;
            runMatchMedia.init = true;
            addEventListener('resize', function() {
                var timer;
                var matchMediaElems = document.getElementsByClassName('lazymatchmedia');
                var run = function() {
                    var i, len;
                    for(i = 0, len = matchMediaElems.length; i < len; i++)polyfill(matchMediaElems[i]);
                };
                return function() {
                    clearTimeout(timer);
                    timer = setTimeout(run, 66);
                };
            }());
        };
        var createSrcset = function(elem, isImage) {
            var parsedSet;
            var srcSet = elem.getAttribute('srcset') || elem.getAttribute(lazySizesCfg.srcsetAttr);
            if (!srcSet && isImage) srcSet = !elem._lazypolyfill ? elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute('src') : elem._lazypolyfill._set;
            if (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) {
                parsedSet = parseWsrcset(srcSet || '');
                if (isImage && elem.parentNode) {
                    parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';
                    if (parsedSet.isPicture) {
                        if (window1.matchMedia) {
                            lazySizes.aC(elem, 'lazymatchmedia');
                            runMatchMedia();
                        }
                    }
                }
                parsedSet._set = srcSet;
                Object.defineProperty(elem, '_lazypolyfill', {
                    value: parsedSet,
                    writable: true
                });
            }
        };
        var getX = function(elem) {
            var dpr = window1.devicePixelRatio || 1;
            var optimum = lazySizes.getX && lazySizes.getX(elem);
            return Math.min(optimum || dpr, 2.5, dpr);
        };
        var matchesMedia = function(media) {
            if (window1.matchMedia) matchesMedia = function(media) {
                return !media || (matchMedia(media) || {}).matches;
            };
            else return !media;
            return matchesMedia(media);
        };
        var getCandidate = function(elem) {
            var sources, i, len, media, source, srces, src, width;
            source = elem;
            createSrcset(source, true);
            srces = source._lazypolyfill;
            if (srces.isPicture) {
                for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++)if (lazySizesCfg.supportsType(sources[i].getAttribute('type'), elem) && matchesMedia(sources[i].getAttribute('media'))) {
                    source = sources[i];
                    createSrcset(source);
                    srces = source._lazypolyfill;
                    break;
                }
            }
            if (srces.length > 1) {
                width = source.getAttribute('sizes') || '';
                width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
                srces.d = getX(elem);
                if (!srces.src || !srces.w || srces.w < width) {
                    srces.w = width;
                    src = reduceCandidate(srces.sort(ascendingSort));
                    srces.src = src;
                } else src = srces.src;
            } else src = srces[0];
            return src;
        };
        var p = function(elem) {
            if (supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != 'PICTURE') return;
            var candidate = getCandidate(elem);
            if (candidate && candidate.u && elem._lazypolyfill.cur != candidate.u) {
                elem._lazypolyfill.cur = candidate.u;
                candidate.cached = true;
                elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
                elem.setAttribute('src', candidate.u);
            }
        };
        p.parse = parseWsrcset;
        return p;
    }();
    if (lazySizesCfg.loadedClass && lazySizesCfg.loadingClass) (function() {
        var sels = [];
        [
            'img[sizes$="px"][srcset].',
            'picture > img:not([srcset]).'
        ].forEach(function(sel) {
            sels.push(sel + lazySizesCfg.loadedClass);
            sels.push(sel + lazySizesCfg.loadingClass);
        });
        lazySizesCfg.pf({
            elements: document.querySelectorAll(sels.join(', '))
        });
    })();
});


var $625109f2fba08463$exports = {};

/*
This plugin extends lazySizes to lazyLoad:
background images, videos/posters and scripts

Background-Image:
For background images, use data-bg attribute:
<div class="lazyload" data-bg="bg-img.jpg"></div>

 Video:
 For video/audio use data-poster and preload="none":
 <video class="lazyload" preload="none" data-poster="poster.jpg" src="src.mp4">
 <!-- sources -->
 </video>

 For video that plays automatically if in view:
 <video
	class="lazyload"
	preload="none"
	muted=""
	data-autoplay=""
	data-poster="poster.jpg"
	src="src.mp4">
</video>

 Scripts:
 For scripts use data-script:
 <div class="lazyload" data-script="module-name.js"></div>


 Script modules using require:
 For modules using require use data-require:
 <div class="lazyload" data-require="module-name"></div>
*/ (function(window1, factory) {
    var globalInstall = function() {
        factory(window1.lazySizes);
        window1.removeEventListener('lazyunveilread', globalInstall, true);
    };
    factory = factory.bind(null, window1, window1.document);
    if ($625109f2fba08463$exports) factory((parcelRequire("3fu6U")));
    else if (typeof define == 'function' && define.amd) define([
        'lazysizes'
    ], factory);
    else if (window1.lazySizes) globalInstall();
    else window1.addEventListener('lazyunveilread', globalInstall, true);
})(window, function(window1, document, lazySizes) {
    /*jshint eqnull:true */ 'use strict';
    var bgLoad, regBgUrlEscape;
    var uniqueUrls = {};
    if (document.addEventListener) {
        regBgUrlEscape = /\(|\)|\s|'/;
        bgLoad = function(url, cb) {
            var img = document.createElement('img');
            img.onload = function() {
                img.onload = null;
                img.onerror = null;
                img = null;
                cb();
            };
            img.onerror = img.onload;
            img.src = url;
            if (img && img.complete && img.onload) img.onload();
        };
        addEventListener('lazybeforeunveil', function(e) {
            if (e.detail.instance != lazySizes) return;
            var tmp, load, bg, poster;
            if (!e.defaultPrevented) {
                var target = e.target;
                if (target.preload == 'none') target.preload = target.getAttribute('data-preload') || 'auto';
                if (target.getAttribute('data-autoplay') != null) {
                    if (target.getAttribute('data-expand') && !target.autoplay) try {
                        target.play();
                    } catch (er) {}
                    else requestAnimationFrame(function() {
                        target.setAttribute('data-expand', '-10');
                        lazySizes.aC(target, lazySizes.cfg.lazyClass);
                    });
                }
                tmp = target.getAttribute('data-link');
                if (tmp) addStyleScript(tmp, true);
                // handle data-script
                tmp = target.getAttribute('data-script');
                if (tmp) {
                    e.detail.firesLoad = true;
                    load = function() {
                        e.detail.firesLoad = false;
                        lazySizes.fire(target, '_lazyloaded', {}, true, true);
                    };
                    addStyleScript(tmp, null, load);
                }
                // handle data-require
                tmp = target.getAttribute('data-require');
                if (tmp) {
                    if (lazySizes.cfg.requireJs) lazySizes.cfg.requireJs([
                        tmp
                    ]);
                    else addStyleScript(tmp);
                }
                // handle data-bg
                bg = target.getAttribute('data-bg');
                if (bg) {
                    e.detail.firesLoad = true;
                    load = function() {
                        target.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg) + ')';
                        e.detail.firesLoad = false;
                        lazySizes.fire(target, '_lazyloaded', {}, true, true);
                    };
                    bgLoad(bg, load);
                }
                // handle data-poster
                poster = target.getAttribute('data-poster');
                if (poster) {
                    e.detail.firesLoad = true;
                    load = function() {
                        target.poster = poster;
                        e.detail.firesLoad = false;
                        lazySizes.fire(target, '_lazyloaded', {}, true, true);
                    };
                    bgLoad(poster, load);
                }
            }
        }, false);
    }
    function addStyleScript(src, style, cb) {
        if (uniqueUrls[src]) return;
        var elem = document.createElement(style ? 'link' : 'script');
        var insertElem = document.getElementsByTagName('script')[0];
        if (style) {
            elem.rel = 'stylesheet';
            elem.href = src;
        } else {
            elem.onload = function() {
                elem.onerror = null;
                elem.onload = null;
                cb();
            };
            elem.onerror = elem.onload;
            elem.src = src;
        }
        uniqueUrls[src] = true;
        uniqueUrls[elem.src || elem.href] = true;
        insertElem.parentNode.insertBefore(elem, insertElem);
    }
});


var $00c01dc957907631$exports = {};

(function(window1, factory) {
    var globalInstall = function() {
        factory(window1.lazySizes);
        window1.removeEventListener('lazyunveilread', globalInstall, true);
    };
    factory = factory.bind(null, window1, window1.document);
    if ($00c01dc957907631$exports) factory((parcelRequire("3fu6U")));
    else if (typeof define == 'function' && define.amd) define([
        'lazysizes'
    ], factory);
    else if (window1.lazySizes) globalInstall();
    else window1.addEventListener('lazyunveilread', globalInstall, true);
})(window, function(window1, document, lazySizes) {
    'use strict';
    if (!window1.addEventListener) return;
    var lazySizesCfg = lazySizes.cfg;
    var regWhite = /\s+/g;
    var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
    var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
    var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
    var regBgUrlEscape = /\(|\)|'/;
    var allowedBackgroundSize = {
        contain: 1,
        cover: 1
    };
    var proxyWidth = function(elem) {
        var width = lazySizes.gW(elem, elem.parentNode);
        if (!elem._lazysizesWidth || width > elem._lazysizesWidth) elem._lazysizesWidth = width;
        return elem._lazysizesWidth;
    };
    var getBgSize = function(elem) {
        var bgSize;
        bgSize = (getComputedStyle(elem) || {
            getPropertyValue: function() {}
        }).getPropertyValue('background-size');
        if (!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]) bgSize = elem.style.backgroundSize;
        return bgSize;
    };
    var setTypeOrMedia = function(source, match) {
        if (match) {
            var typeMatch = match.match(regType);
            if (typeMatch && typeMatch[1]) source.setAttribute('type', typeMatch[1]);
            else source.setAttribute('media', lazySizesCfg.customMedia[match] || match);
        }
    };
    var createPicture = function(sets, elem, img) {
        var picture = document.createElement('picture');
        var sizes = elem.getAttribute(lazySizesCfg.sizesAttr);
        var ratio = elem.getAttribute('data-ratio');
        var optimumx = elem.getAttribute('data-optimumx');
        if (elem._lazybgset && elem._lazybgset.parentNode == elem) elem.removeChild(elem._lazybgset);
        Object.defineProperty(img, '_lazybgset', {
            value: elem,
            writable: true
        });
        Object.defineProperty(elem, '_lazybgset', {
            value: picture,
            writable: true
        });
        sets = sets.replace(regWhite, ' ').split(regSplitSet);
        picture.style.display = 'none';
        img.className = lazySizesCfg.lazyClass;
        if (sets.length == 1 && !sizes) sizes = 'auto';
        sets.forEach(function(set) {
            var match;
            var source = document.createElement('source');
            if (sizes && sizes != 'auto') source.setAttribute('sizes', sizes);
            if (match = set.match(regSource)) {
                source.setAttribute(lazySizesCfg.srcsetAttr, match[1]);
                setTypeOrMedia(source, match[2]);
                setTypeOrMedia(source, match[3]);
            } else source.setAttribute(lazySizesCfg.srcsetAttr, set);
            picture.appendChild(source);
        });
        if (sizes) {
            img.setAttribute(lazySizesCfg.sizesAttr, sizes);
            elem.removeAttribute(lazySizesCfg.sizesAttr);
            elem.removeAttribute('sizes');
        }
        if (optimumx) img.setAttribute('data-optimumx', optimumx);
        if (ratio) img.setAttribute('data-ratio', ratio);
        picture.appendChild(img);
        elem.appendChild(picture);
    };
    var proxyLoad = function(e) {
        if (!e.target._lazybgset) return;
        var image = e.target;
        var elem = image._lazybgset;
        var bg = image.currentSrc || image.src;
        if (bg) {
            var useSrc = regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg;
            var event = lazySizes.fire(elem, 'bgsetproxy', {
                src: bg,
                useSrc: useSrc,
                fullSrc: null
            });
            if (!event.defaultPrevented) elem.style.backgroundImage = event.detail.fullSrc || 'url(' + event.detail.useSrc + ')';
        }
        if (image._lazybgsetLoading) {
            lazySizes.fire(elem, '_lazyloaded', {}, false, true);
            delete image._lazybgsetLoading;
        }
    };
    addEventListener('lazybeforeunveil', function(e) {
        var set, image, elem;
        if (e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))) return;
        elem = e.target;
        image = document.createElement('img');
        image.alt = '';
        image._lazybgsetLoading = true;
        e.detail.firesLoad = true;
        createPicture(set, elem, image);
        setTimeout(function() {
            lazySizes.loader.unveil(image);
            lazySizes.rAF(function() {
                lazySizes.fire(image, '_lazyloaded', {}, true, true);
                if (image.complete) proxyLoad({
                    target: image
                });
            });
        });
    });
    document.addEventListener('load', proxyLoad, true);
    window1.addEventListener('lazybeforesizes', function(e) {
        if (e.detail.instance != lazySizes) return;
        if (e.target._lazybgset && e.detail.dataAttr) {
            var elem = e.target._lazybgset;
            var bgSize = getBgSize(elem);
            if (allowedBackgroundSize[bgSize]) {
                e.target._lazysizesParentFit = bgSize;
                lazySizes.rAF(function() {
                    e.target.setAttribute('data-parent-fit', bgSize);
                    if (e.target._lazysizesParentFit) delete e.target._lazysizesParentFit;
                });
            }
        }
    }, true);
    document.documentElement.addEventListener('lazybeforesizes', function(e) {
        if (e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes) return;
        e.detail.width = proxyWidth(e.target._lazybgset);
    });
});




// Import and use some of the 'solid', 'regular', 'light' and 'brand' themes of FontAwesome 5 Free/PRO (.npmrc is required)
// We only add icons to the library that we actually use in frontend to keep the bundle size as small as possible
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function $2f7ebf3a194ce8e5$var$_defineProperty(e, r, t) {
    return (r = $2f7ebf3a194ce8e5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2f7ebf3a194ce8e5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $2f7ebf3a194ce8e5$var$_setPrototypeOf(t, e);
}
function $2f7ebf3a194ce8e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f7ebf3a194ce8e5$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f7ebf3a194ce8e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2f7ebf3a194ce8e5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f7ebf3a194ce8e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f7ebf3a194ce8e5$var$_setPrototypeOf(t, e) {
    return $2f7ebf3a194ce8e5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2f7ebf3a194ce8e5$var$_setPrototypeOf(t, e);
}
function $2f7ebf3a194ce8e5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2f7ebf3a194ce8e5$var$_toPropertyKey(t) {
    var i = $2f7ebf3a194ce8e5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2f7ebf3a194ce8e5$var$_wrapRegExp() {
    $2f7ebf3a194ce8e5$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $2f7ebf3a194ce8e5$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $2f7ebf3a194ce8e5$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $2f7ebf3a194ce8e5$var$_wrapRegExp.apply(this, arguments);
}
const $2f7ebf3a194ce8e5$var$noop = ()=>{};
let $2f7ebf3a194ce8e5$var$_WINDOW = {};
let $2f7ebf3a194ce8e5$var$_DOCUMENT = {};
let $2f7ebf3a194ce8e5$var$_MUTATION_OBSERVER = null;
let $2f7ebf3a194ce8e5$var$_PERFORMANCE = {
    mark: $2f7ebf3a194ce8e5$var$noop,
    measure: $2f7ebf3a194ce8e5$var$noop
};
try {
    if (typeof window !== 'undefined') $2f7ebf3a194ce8e5$var$_WINDOW = window;
    if (typeof document !== 'undefined') $2f7ebf3a194ce8e5$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $2f7ebf3a194ce8e5$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $2f7ebf3a194ce8e5$var$_PERFORMANCE = performance;
} catch (e) {}
const { userAgent: $2f7ebf3a194ce8e5$var$userAgent = '' } = $2f7ebf3a194ce8e5$var$_WINDOW.navigator || {};
const $2f7ebf3a194ce8e5$var$WINDOW = $2f7ebf3a194ce8e5$var$_WINDOW;
const $2f7ebf3a194ce8e5$var$DOCUMENT = $2f7ebf3a194ce8e5$var$_DOCUMENT;
const $2f7ebf3a194ce8e5$var$MUTATION_OBSERVER = $2f7ebf3a194ce8e5$var$_MUTATION_OBSERVER;
const $2f7ebf3a194ce8e5$var$PERFORMANCE = $2f7ebf3a194ce8e5$var$_PERFORMANCE;
const $2f7ebf3a194ce8e5$var$IS_BROWSER = !!$2f7ebf3a194ce8e5$var$WINDOW.document;
const $2f7ebf3a194ce8e5$var$IS_DOM = !!$2f7ebf3a194ce8e5$var$DOCUMENT.documentElement && !!$2f7ebf3a194ce8e5$var$DOCUMENT.head && typeof $2f7ebf3a194ce8e5$var$DOCUMENT.addEventListener === 'function' && typeof $2f7ebf3a194ce8e5$var$DOCUMENT.createElement === 'function';
const $2f7ebf3a194ce8e5$var$IS_IE = ~$2f7ebf3a194ce8e5$var$userAgent.indexOf('MSIE') || ~$2f7ebf3a194ce8e5$var$userAgent.indexOf('Trident/');
var $2f7ebf3a194ce8e5$var$p = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $2f7ebf3a194ce8e5$var$g = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var $2f7ebf3a194ce8e5$var$S = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    }
}, $2f7ebf3a194ce8e5$var$A = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $2f7ebf3a194ce8e5$var$P = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $2f7ebf3a194ce8e5$var$s = "classic", $2f7ebf3a194ce8e5$var$t = "duotone", $2f7ebf3a194ce8e5$var$r = "sharp", $2f7ebf3a194ce8e5$var$o = "sharp-duotone", $2f7ebf3a194ce8e5$var$L = [
    $2f7ebf3a194ce8e5$var$s,
    $2f7ebf3a194ce8e5$var$t,
    $2f7ebf3a194ce8e5$var$r,
    $2f7ebf3a194ce8e5$var$o
];
var $2f7ebf3a194ce8e5$var$G = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $2f7ebf3a194ce8e5$var$lt = {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $2f7ebf3a194ce8e5$var$pt = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ]
]), $2f7ebf3a194ce8e5$var$xt = {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        brands: "fab"
    },
    duotone: {
        solid: "fad",
        regular: "fadr",
        light: "fadl",
        thin: "fadt"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds",
        regular: "fasdr",
        light: "fasdl",
        thin: "fasdt"
    }
};
var $2f7ebf3a194ce8e5$var$Ft = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $2f7ebf3a194ce8e5$var$St = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $2f7ebf3a194ce8e5$var$At = [
    "kit"
];
var $2f7ebf3a194ce8e5$var$Ct = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $2f7ebf3a194ce8e5$var$Lt = [
    "fak",
    "fakd"
], $2f7ebf3a194ce8e5$var$Wt = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $2f7ebf3a194ce8e5$var$Et = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $2f7ebf3a194ce8e5$var$t$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $2f7ebf3a194ce8e5$var$r$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $2f7ebf3a194ce8e5$var$bt$1 = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
];
var $2f7ebf3a194ce8e5$var$Yt = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
};
var $2f7ebf3a194ce8e5$var$ua = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    }
}, $2f7ebf3a194ce8e5$var$I$1 = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ]
}, $2f7ebf3a194ce8e5$var$ga = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    }
}, $2f7ebf3a194ce8e5$var$x = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands"
], $2f7ebf3a194ce8e5$var$Ia = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    ...$2f7ebf3a194ce8e5$var$r$1,
    ...$2f7ebf3a194ce8e5$var$x
], $2f7ebf3a194ce8e5$var$m$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands"
], $2f7ebf3a194ce8e5$var$c$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $2f7ebf3a194ce8e5$var$F$1 = $2f7ebf3a194ce8e5$var$c$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $2f7ebf3a194ce8e5$var$ma = [
    ...Object.keys($2f7ebf3a194ce8e5$var$I$1),
    ...$2f7ebf3a194ce8e5$var$m$1,
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $2f7ebf3a194ce8e5$var$t$1.GROUP,
    $2f7ebf3a194ce8e5$var$t$1.SWAP_OPACITY,
    $2f7ebf3a194ce8e5$var$t$1.PRIMARY,
    $2f7ebf3a194ce8e5$var$t$1.SECONDARY
].concat($2f7ebf3a194ce8e5$var$c$1.map((a)=>"".concat(a, "x"))).concat($2f7ebf3a194ce8e5$var$F$1.map((a)=>"w-".concat(a)));
var $2f7ebf3a194ce8e5$var$wa = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
const $2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
const $2f7ebf3a194ce8e5$var$UNITS_IN_GRID = 16;
const $2f7ebf3a194ce8e5$var$DEFAULT_CSS_PREFIX = 'fa';
const $2f7ebf3a194ce8e5$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
const $2f7ebf3a194ce8e5$var$DATA_FA_I2SVG = 'data-fa-i2svg';
const $2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
const $2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
const $2f7ebf3a194ce8e5$var$DATA_PREFIX = 'data-prefix';
const $2f7ebf3a194ce8e5$var$DATA_ICON = 'data-icon';
const $2f7ebf3a194ce8e5$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
const $2f7ebf3a194ce8e5$var$MUTATION_APPROACH_ASYNC = 'async';
const $2f7ebf3a194ce8e5$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
const $2f7ebf3a194ce8e5$var$PRODUCTION = (()=>{
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
})();
function $2f7ebf3a194ce8e5$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get (target, prop) {
            return prop in target ? target[prop] : target[$2f7ebf3a194ce8e5$var$s];
        }
    });
}
const $2f7ebf3a194ce8e5$var$_PREFIX_TO_STYLE = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$S);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$2f7ebf3a194ce8e5$var$_PREFIX_TO_STYLE[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $2f7ebf3a194ce8e5$var$S[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$St['kit']), $2f7ebf3a194ce8e5$var$St['kit-duotone']);
const $2f7ebf3a194ce8e5$var$PREFIX_TO_STYLE = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_PREFIX_TO_STYLE);
const $2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$xt);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, {
    duotone: 'fad'
}), $2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$Et['kit']), $2f7ebf3a194ce8e5$var$Et['kit-duotone']);
const $2f7ebf3a194ce8e5$var$STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX);
const $2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ga);
$2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$Wt['kit']);
const $2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE);
const $2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ua);
$2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$Ct['kit']);
const $2f7ebf3a194ce8e5$var$LONG_STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX);
const $2f7ebf3a194ce8e5$var$ICON_SELECTION_SYNTAX_PATTERN = $2f7ebf3a194ce8e5$var$p; // eslint-disable-line no-useless-escape
const $2f7ebf3a194ce8e5$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
const $2f7ebf3a194ce8e5$var$FONT_FAMILY_PATTERN = $2f7ebf3a194ce8e5$var$g;
const $2f7ebf3a194ce8e5$var$_FONT_WEIGHT_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$G);
const $2f7ebf3a194ce8e5$var$FONT_WEIGHT_TO_PREFIX = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_FONT_WEIGHT_TO_PREFIX);
const $2f7ebf3a194ce8e5$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
const $2f7ebf3a194ce8e5$var$DUOTONE_CLASSES = $2f7ebf3a194ce8e5$var$A;
const $2f7ebf3a194ce8e5$var$RESERVED_CLASSES = [
    ...$2f7ebf3a194ce8e5$var$At,
    ...$2f7ebf3a194ce8e5$var$ma
];
const $2f7ebf3a194ce8e5$var$initial = $2f7ebf3a194ce8e5$var$WINDOW.FontAwesomeConfig || {};
function $2f7ebf3a194ce8e5$var$getAttrConfig(attr) {
    var element = $2f7ebf3a194ce8e5$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $2f7ebf3a194ce8e5$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($2f7ebf3a194ce8e5$var$DOCUMENT && typeof $2f7ebf3a194ce8e5$var$DOCUMENT.querySelector === 'function') {
    const attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    attrs.forEach((_ref)=>{
        let [attr, key] = _ref;
        const val = $2f7ebf3a194ce8e5$var$coerce($2f7ebf3a194ce8e5$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $2f7ebf3a194ce8e5$var$initial[key] = val;
    });
}
const $2f7ebf3a194ce8e5$var$_default = {
    styleDefault: 'solid',
    familyDefault: $2f7ebf3a194ce8e5$var$s,
    cssPrefix: $2f7ebf3a194ce8e5$var$DEFAULT_CSS_PREFIX,
    replacementClass: $2f7ebf3a194ce8e5$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($2f7ebf3a194ce8e5$var$initial.familyPrefix) $2f7ebf3a194ce8e5$var$initial.cssPrefix = $2f7ebf3a194ce8e5$var$initial.familyPrefix;
const $2f7ebf3a194ce8e5$var$_config = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$_default), $2f7ebf3a194ce8e5$var$initial);
if (!$2f7ebf3a194ce8e5$var$_config.autoReplaceSvg) $2f7ebf3a194ce8e5$var$_config.observeMutations = false;
const $2f7ebf3a194ce8e5$var$config = {};
Object.keys($2f7ebf3a194ce8e5$var$_default).forEach((key)=>{
    Object.defineProperty($2f7ebf3a194ce8e5$var$config, key, {
        enumerable: true,
        set: function(val) {
            $2f7ebf3a194ce8e5$var$_config[key] = val;
            $2f7ebf3a194ce8e5$var$_onChangeCb.forEach((cb)=>cb($2f7ebf3a194ce8e5$var$config));
        },
        get: function() {
            return $2f7ebf3a194ce8e5$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($2f7ebf3a194ce8e5$var$config, 'familyPrefix', {
    enumerable: true,
    set: function(val) {
        $2f7ebf3a194ce8e5$var$_config.cssPrefix = val;
        $2f7ebf3a194ce8e5$var$_onChangeCb.forEach((cb)=>cb($2f7ebf3a194ce8e5$var$config));
    },
    get: function() {
        return $2f7ebf3a194ce8e5$var$_config.cssPrefix;
    }
});
$2f7ebf3a194ce8e5$var$WINDOW.FontAwesomeConfig = $2f7ebf3a194ce8e5$var$config;
const $2f7ebf3a194ce8e5$var$_onChangeCb = [];
function $2f7ebf3a194ce8e5$var$onChange(cb) {
    $2f7ebf3a194ce8e5$var$_onChangeCb.push(cb);
    return ()=>{
        $2f7ebf3a194ce8e5$var$_onChangeCb.splice($2f7ebf3a194ce8e5$var$_onChangeCb.indexOf(cb), 1);
    };
}
const $2f7ebf3a194ce8e5$var$d$2 = $2f7ebf3a194ce8e5$var$UNITS_IN_GRID;
const $2f7ebf3a194ce8e5$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $2f7ebf3a194ce8e5$var$insertCss(css) {
    if (!css || !$2f7ebf3a194ce8e5$var$IS_DOM) return;
    const style = $2f7ebf3a194ce8e5$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    const headChildren = $2f7ebf3a194ce8e5$var$DOCUMENT.head.childNodes;
    let beforeChild = null;
    for(let i = headChildren.length - 1; i > -1; i--){
        const child = headChildren[i];
        const tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $2f7ebf3a194ce8e5$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
const $2f7ebf3a194ce8e5$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $2f7ebf3a194ce8e5$var$nextUniqueId() {
    let size = 12;
    let id = '';
    while(size-- > 0)id += $2f7ebf3a194ce8e5$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $2f7ebf3a194ce8e5$var$toArray(obj) {
    const array = [];
    for(let i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $2f7ebf3a194ce8e5$var$classArray(node) {
    if (node.classList) return $2f7ebf3a194ce8e5$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter((i)=>i);
}
function $2f7ebf3a194ce8e5$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $2f7ebf3a194ce8e5$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce((acc, attributeName)=>{
        return acc + "".concat(attributeName, "=\"").concat($2f7ebf3a194ce8e5$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $2f7ebf3a194ce8e5$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce((acc, styleName)=>{
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $2f7ebf3a194ce8e5$var$transformIsMeaningful(transform) {
    return transform.size !== $2f7ebf3a194ce8e5$var$meaninglessTransform.size || transform.x !== $2f7ebf3a194ce8e5$var$meaninglessTransform.x || transform.y !== $2f7ebf3a194ce8e5$var$meaninglessTransform.y || transform.rotate !== $2f7ebf3a194ce8e5$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $2f7ebf3a194ce8e5$var$transformForSvg(_ref) {
    let { transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
    const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $2f7ebf3a194ce8e5$var$transformForCss(_ref2) {
    let { transform: transform, width: width = $2f7ebf3a194ce8e5$var$UNITS_IN_GRID, height: height = $2f7ebf3a194ce8e5$var$UNITS_IN_GRID, startCentered: startCentered = false } = _ref2;
    let val = '';
    if (startCentered && $2f7ebf3a194ce8e5$var$IS_IE) val += "translate(".concat(transform.x / $2f7ebf3a194ce8e5$var$d$2 - width / 2, "em, ").concat(transform.y / $2f7ebf3a194ce8e5$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $2f7ebf3a194ce8e5$var$d$2, "em), calc(-50% + ").concat(transform.y / $2f7ebf3a194ce8e5$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $2f7ebf3a194ce8e5$var$d$2, "em, ").concat(transform.y / $2f7ebf3a194ce8e5$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $2f7ebf3a194ce8e5$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $2f7ebf3a194ce8e5$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $2f7ebf3a194ce8e5$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Sharp Duotone\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}";
function $2f7ebf3a194ce8e5$var$css() {
    const dcp = $2f7ebf3a194ce8e5$var$DEFAULT_CSS_PREFIX;
    const drc = $2f7ebf3a194ce8e5$var$DEFAULT_REPLACEMENT_CLASS;
    const fp = $2f7ebf3a194ce8e5$var$config.cssPrefix;
    const rc = $2f7ebf3a194ce8e5$var$config.replacementClass;
    let s = $2f7ebf3a194ce8e5$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        const dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        const rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
let $2f7ebf3a194ce8e5$var$_cssInserted = false;
function $2f7ebf3a194ce8e5$var$ensureCss() {
    if ($2f7ebf3a194ce8e5$var$config.autoAddCss && !$2f7ebf3a194ce8e5$var$_cssInserted) {
        $2f7ebf3a194ce8e5$var$insertCss($2f7ebf3a194ce8e5$var$css());
        $2f7ebf3a194ce8e5$var$_cssInserted = true;
    }
}
var $2f7ebf3a194ce8e5$var$InjectCSS = {
    mixout () {
        return {
            dom: {
                css: $2f7ebf3a194ce8e5$var$css,
                insertCss: $2f7ebf3a194ce8e5$var$ensureCss
            }
        };
    },
    hooks () {
        return {
            beforeDOMElementCreation () {
                $2f7ebf3a194ce8e5$var$ensureCss();
            },
            beforeI2svg () {
                $2f7ebf3a194ce8e5$var$ensureCss();
            }
        };
    }
};
const $2f7ebf3a194ce8e5$var$w = $2f7ebf3a194ce8e5$var$WINDOW || {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER]) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER] = {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].styles) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].hooks) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].shims) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].shims = [];
var $2f7ebf3a194ce8e5$var$namespace = $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER];
const $2f7ebf3a194ce8e5$var$functions = [];
const $2f7ebf3a194ce8e5$var$listener = function() {
    $2f7ebf3a194ce8e5$var$DOCUMENT.removeEventListener('DOMContentLoaded', $2f7ebf3a194ce8e5$var$listener);
    $2f7ebf3a194ce8e5$var$loaded = 1;
    $2f7ebf3a194ce8e5$var$functions.map((fn)=>fn());
};
let $2f7ebf3a194ce8e5$var$loaded = false;
if ($2f7ebf3a194ce8e5$var$IS_DOM) {
    $2f7ebf3a194ce8e5$var$loaded = ($2f7ebf3a194ce8e5$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($2f7ebf3a194ce8e5$var$DOCUMENT.readyState);
    if (!$2f7ebf3a194ce8e5$var$loaded) $2f7ebf3a194ce8e5$var$DOCUMENT.addEventListener('DOMContentLoaded', $2f7ebf3a194ce8e5$var$listener);
}
function $2f7ebf3a194ce8e5$var$domready(fn) {
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
    $2f7ebf3a194ce8e5$var$loaded ? setTimeout(fn, 0) : $2f7ebf3a194ce8e5$var$functions.push(fn);
}
function $2f7ebf3a194ce8e5$var$toHtml(abstractNodes) {
    const { tag: tag, attributes: attributes = {}, children: children = [] } = abstractNodes;
    if (typeof abstractNodes === 'string') return $2f7ebf3a194ce8e5$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($2f7ebf3a194ce8e5$var$joinAttributes(attributes), ">").concat(children.map($2f7ebf3a194ce8e5$var$toHtml).join(''), "</").concat(tag, ">");
}
function $2f7ebf3a194ce8e5$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $2f7ebf3a194ce8e5$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $2f7ebf3a194ce8e5$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $2f7ebf3a194ce8e5$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $2f7ebf3a194ce8e5$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $2f7ebf3a194ce8e5$var$toHex(unicode) {
    const decoded = $2f7ebf3a194ce8e5$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $2f7ebf3a194ce8e5$var$codePointAt(string, index) {
    const size = string.length;
    let first = string.charCodeAt(index);
    let second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $2f7ebf3a194ce8e5$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce((acc, iconName)=>{
        const icon = icons[iconName];
        const expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $2f7ebf3a194ce8e5$var$defineIcons(prefix, icons) {
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { skipHooks: skipHooks = false } = params;
    const normalized = $2f7ebf3a194ce8e5$var$normalizeIcons(icons);
    if (typeof $2f7ebf3a194ce8e5$var$namespace.hooks.addPack === 'function' && !skipHooks) $2f7ebf3a194ce8e5$var$namespace.hooks.addPack(prefix, $2f7ebf3a194ce8e5$var$normalizeIcons(icons));
    else $2f7ebf3a194ce8e5$var$namespace.styles[prefix] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $2f7ebf3a194ce8e5$var$defineIcons('fa', icons);
}
const $2f7ebf3a194ce8e5$var$duotonePathRe = [
    /*#__PURE__*/ $2f7ebf3a194ce8e5$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $2f7ebf3a194ce8e5$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)".*path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $2f7ebf3a194ce8e5$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2
    })
];
const { styles: $2f7ebf3a194ce8e5$var$styles, shims: $2f7ebf3a194ce8e5$var$shims } = $2f7ebf3a194ce8e5$var$namespace;
const $2f7ebf3a194ce8e5$var$FAMILY_NAMES = Object.keys($2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE);
const $2f7ebf3a194ce8e5$var$PREFIXES_FOR_FAMILY = $2f7ebf3a194ce8e5$var$FAMILY_NAMES.reduce((acc, familyId)=>{
    acc[familyId] = Object.keys($2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
let $2f7ebf3a194ce8e5$var$_defaultUsablePrefix = null;
let $2f7ebf3a194ce8e5$var$_byUnicode = {};
let $2f7ebf3a194ce8e5$var$_byLigature = {};
let $2f7ebf3a194ce8e5$var$_byOldName = {};
let $2f7ebf3a194ce8e5$var$_byOldUnicode = {};
let $2f7ebf3a194ce8e5$var$_byAlias = {};
function $2f7ebf3a194ce8e5$var$isReserved(name) {
    return ~$2f7ebf3a194ce8e5$var$RESERVED_CLASSES.indexOf(name);
}
function $2f7ebf3a194ce8e5$var$getIconName(cssPrefix, cls) {
    const parts = cls.split('-');
    const prefix = parts[0];
    const iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$2f7ebf3a194ce8e5$var$isReserved(iconName)) return iconName;
    else return null;
}
const $2f7ebf3a194ce8e5$var$build = ()=>{
    const lookup = (reducer)=>{
        return $2f7ebf3a194ce8e5$var$reduce($2f7ebf3a194ce8e5$var$styles, (o$$1, style, prefix)=>{
            o$$1[prefix] = $2f7ebf3a194ce8e5$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $2f7ebf3a194ce8e5$var$_byUnicode = lookup((acc, icon, iconName)=>{
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'number';
            });
            aliases.forEach((alias)=>{
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $2f7ebf3a194ce8e5$var$_byLigature = lookup((acc, icon, iconName)=>{
        acc[iconName] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'string';
            });
            aliases.forEach((alias)=>{
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $2f7ebf3a194ce8e5$var$_byAlias = lookup((acc, icon, iconName)=>{
        const aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach((alias)=>{
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    const hasRegular = 'far' in $2f7ebf3a194ce8e5$var$styles || $2f7ebf3a194ce8e5$var$config.autoFetchSvg;
    const shimLookups = $2f7ebf3a194ce8e5$var$reduce($2f7ebf3a194ce8e5$var$shims, (acc, shim)=>{
        const maybeNameMaybeUnicode = shim[0];
        let prefix = shim[1];
        const iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $2f7ebf3a194ce8e5$var$_byOldName = shimLookups.names;
    $2f7ebf3a194ce8e5$var$_byOldUnicode = shimLookups.unicodes;
    $2f7ebf3a194ce8e5$var$_defaultUsablePrefix = $2f7ebf3a194ce8e5$var$getCanonicalPrefix($2f7ebf3a194ce8e5$var$config.styleDefault, {
        family: $2f7ebf3a194ce8e5$var$config.familyDefault
    });
};
$2f7ebf3a194ce8e5$var$onChange((c$$1)=>{
    $2f7ebf3a194ce8e5$var$_defaultUsablePrefix = $2f7ebf3a194ce8e5$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $2f7ebf3a194ce8e5$var$config.familyDefault
    });
});
$2f7ebf3a194ce8e5$var$build();
function $2f7ebf3a194ce8e5$var$byUnicode(prefix, unicode) {
    return ($2f7ebf3a194ce8e5$var$_byUnicode[prefix] || {})[unicode];
}
function $2f7ebf3a194ce8e5$var$byLigature(prefix, ligature) {
    return ($2f7ebf3a194ce8e5$var$_byLigature[prefix] || {})[ligature];
}
function $2f7ebf3a194ce8e5$var$byAlias(prefix, alias) {
    return ($2f7ebf3a194ce8e5$var$_byAlias[prefix] || {})[alias];
}
function $2f7ebf3a194ce8e5$var$byOldName(name) {
    return $2f7ebf3a194ce8e5$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $2f7ebf3a194ce8e5$var$byOldUnicode(unicode) {
    const oldUnicode = $2f7ebf3a194ce8e5$var$_byOldUnicode[unicode];
    const newUnicode = $2f7ebf3a194ce8e5$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix() {
    return $2f7ebf3a194ce8e5$var$_defaultUsablePrefix;
}
const $2f7ebf3a194ce8e5$var$emptyCanonicalIcon = ()=>{
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $2f7ebf3a194ce8e5$var$getFamilyId(values) {
    let family = $2f7ebf3a194ce8e5$var$s;
    const famProps = $2f7ebf3a194ce8e5$var$FAMILY_NAMES.reduce((acc, familyId)=>{
        acc[familyId] = "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $2f7ebf3a194ce8e5$var$L.forEach((familyId)=>{
        if (values.includes(famProps[familyId]) || values.some((v$$1)=>$2f7ebf3a194ce8e5$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) family = familyId;
    });
    return family;
}
function $2f7ebf3a194ce8e5$var$getCanonicalPrefix(styleOrPrefix) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { family: family = $2f7ebf3a194ce8e5$var$s } = params;
    const style = $2f7ebf3a194ce8e5$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $2f7ebf3a194ce8e5$var$t && !styleOrPrefix) return 'fad';
    const prefix = $2f7ebf3a194ce8e5$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $2f7ebf3a194ce8e5$var$STYLE_TO_PREFIX[family][style];
    const defined = styleOrPrefix in $2f7ebf3a194ce8e5$var$namespace.styles ? styleOrPrefix : null;
    const result = prefix || defined || null;
    return result;
}
function $2f7ebf3a194ce8e5$var$moveNonFaClassesToRest(classNames) {
    let rest = [];
    let iconName = null;
    classNames.forEach((cls)=>{
        const result = $2f7ebf3a194ce8e5$var$getIconName($2f7ebf3a194ce8e5$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $2f7ebf3a194ce8e5$var$sortedUniqueValues(arr) {
    return arr.sort().filter((value, index, arr)=>{
        return arr.indexOf(value) === index;
    });
}
function $2f7ebf3a194ce8e5$var$getCanonicalIcon(values) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { skipLookups: skipLookups = false } = params;
    let givenPrefix = null;
    const faCombinedClasses = $2f7ebf3a194ce8e5$var$Ia.concat($2f7ebf3a194ce8e5$var$bt$1);
    const faStyleOrFamilyClasses = $2f7ebf3a194ce8e5$var$sortedUniqueValues(values.filter((cls)=>faCombinedClasses.includes(cls)));
    const nonStyleOrFamilyClasses = $2f7ebf3a194ce8e5$var$sortedUniqueValues(values.filter((cls)=>!$2f7ebf3a194ce8e5$var$Ia.includes(cls)));
    const faStyles = faStyleOrFamilyClasses.filter((cls)=>{
        givenPrefix = cls;
        return !$2f7ebf3a194ce8e5$var$P.includes(cls);
    });
    const [styleFromValues = null] = faStyles;
    const family = $2f7ebf3a194ce8e5$var$getFamilyId(faStyleOrFamilyClasses);
    const canonical = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $2f7ebf3a194ce8e5$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, canonical), $2f7ebf3a194ce8e5$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $2f7ebf3a194ce8e5$var$styles,
        config: $2f7ebf3a194ce8e5$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $2f7ebf3a194ce8e5$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $2f7ebf3a194ce8e5$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    let { prefix: prefix, iconName: iconName } = canonical;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    const shim = givenPrefix === 'fa' ? $2f7ebf3a194ce8e5$var$byOldName(iconName) : {};
    const aliasIconName = $2f7ebf3a194ce8e5$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$2f7ebf3a194ce8e5$var$styles['far'] && $2f7ebf3a194ce8e5$var$styles['fas'] && !$2f7ebf3a194ce8e5$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
const $2f7ebf3a194ce8e5$var$newCanonicalFamilies = $2f7ebf3a194ce8e5$var$L.filter((familyId)=>{
    return familyId !== $2f7ebf3a194ce8e5$var$s || familyId !== $2f7ebf3a194ce8e5$var$t;
});
const $2f7ebf3a194ce8e5$var$newCanonicalStyles = Object.keys($2f7ebf3a194ce8e5$var$ga).filter((key)=>key !== $2f7ebf3a194ce8e5$var$s).map((key)=>Object.keys($2f7ebf3a194ce8e5$var$ga[key])).flat();
function $2f7ebf3a194ce8e5$var$getDefaultCanonicalPrefix(prefixOptions) {
    const { values: values, family: family, canonical: canonical, givenPrefix: givenPrefix = '', styles: styles = {}, config: config$$1 = {} } = prefixOptions;
    const isDuotoneFamily = family === $2f7ebf3a194ce8e5$var$t;
    const valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    const defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    const canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $2f7ebf3a194ce8e5$var$newCanonicalFamilies.includes(family)) {
        const validPrefix = Object.keys(styles).find((key)=>$2f7ebf3a194ce8e5$var$newCanonicalStyles.includes(key));
        if (validPrefix || config$$1.autoFetchSvg) {
            const defaultPrefix = $2f7ebf3a194ce8e5$var$pt.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $2f7ebf3a194ce8e5$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
class $2f7ebf3a194ce8e5$var$Library {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
        const additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach((key)=>{
            this.definitions[key] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, this.definitions[key] || {}), additions[key]);
            $2f7ebf3a194ce8e5$var$defineIcons(key, additions[key]);
            // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
            const longPrefix = $2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE[$2f7ebf3a194ce8e5$var$s][key];
            if (longPrefix) $2f7ebf3a194ce8e5$var$defineIcons(longPrefix, additions[key]);
            $2f7ebf3a194ce8e5$var$build();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(additions, definition) {
        const normalized = definition.prefix && definition.iconName && definition.icon ? {
            0: definition
        } : definition;
        Object.keys(normalized).map((key)=>{
            const { prefix: prefix, iconName: iconName, icon: icon } = normalized[key];
            const aliases = icon[2];
            if (!additions[prefix]) additions[prefix] = {};
            if (aliases.length > 0) aliases.forEach((alias)=>{
                if (typeof alias === 'string') additions[prefix][alias] = icon;
            });
            additions[prefix][iconName] = icon;
        });
        return additions;
    }
}
let $2f7ebf3a194ce8e5$var$_plugins = [];
let $2f7ebf3a194ce8e5$var$_hooks = {};
const $2f7ebf3a194ce8e5$var$providers = {};
const $2f7ebf3a194ce8e5$var$defaultProviderKeys = Object.keys($2f7ebf3a194ce8e5$var$providers);
function $2f7ebf3a194ce8e5$var$registerPlugins(nextPlugins, _ref) {
    let { mixoutsTo: obj } = _ref;
    $2f7ebf3a194ce8e5$var$_plugins = nextPlugins;
    $2f7ebf3a194ce8e5$var$_hooks = {};
    Object.keys($2f7ebf3a194ce8e5$var$providers).forEach((k)=>{
        if ($2f7ebf3a194ce8e5$var$defaultProviderKeys.indexOf(k) === -1) delete $2f7ebf3a194ce8e5$var$providers[k];
    });
    $2f7ebf3a194ce8e5$var$_plugins.forEach((plugin)=>{
        const mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach((tk)=>{
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if (typeof mixout[tk] === 'object') Object.keys(mixout[tk]).forEach((sk)=>{
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            const hooks = plugin.hooks();
            Object.keys(hooks).forEach((hook)=>{
                if (!$2f7ebf3a194ce8e5$var$_hooks[hook]) $2f7ebf3a194ce8e5$var$_hooks[hook] = [];
                $2f7ebf3a194ce8e5$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($2f7ebf3a194ce8e5$var$providers);
    });
    return obj;
}
function $2f7ebf3a194ce8e5$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    const hookFns = $2f7ebf3a194ce8e5$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        accumulator = hookFn.apply(null, [
            accumulator,
            ...args
        ]); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $2f7ebf3a194ce8e5$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    const hookFns = $2f7ebf3a194ce8e5$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        hookFn.apply(null, args);
    });
    return undefined;
}
function $2f7ebf3a194ce8e5$var$callProvided() {
    const hook = arguments[0];
    const args = Array.prototype.slice.call(arguments, 1);
    return $2f7ebf3a194ce8e5$var$providers[hook] ? $2f7ebf3a194ce8e5$var$providers[hook].apply(null, args) : undefined;
}
function $2f7ebf3a194ce8e5$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    let { iconName: iconName } = iconLookup;
    const prefix = iconLookup.prefix || $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $2f7ebf3a194ce8e5$var$byAlias(prefix, iconName) || iconName;
    return $2f7ebf3a194ce8e5$var$iconFromMapping($2f7ebf3a194ce8e5$var$library.definitions, prefix, iconName) || $2f7ebf3a194ce8e5$var$iconFromMapping($2f7ebf3a194ce8e5$var$namespace.styles, prefix, iconName);
}
const $2f7ebf3a194ce8e5$var$library = new $2f7ebf3a194ce8e5$var$Library();
const $2f7ebf3a194ce8e5$var$noAuto = ()=>{
    $2f7ebf3a194ce8e5$var$config.autoReplaceSvg = false;
    $2f7ebf3a194ce8e5$var$config.observeMutations = false;
    $2f7ebf3a194ce8e5$var$callHooks('noAuto');
};
const $2f7ebf3a194ce8e5$var$dom = {
    i2svg: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($2f7ebf3a194ce8e5$var$IS_DOM) {
            $2f7ebf3a194ce8e5$var$callHooks('beforeI2svg', params);
            $2f7ebf3a194ce8e5$var$callProvided('pseudoElements2svg', params);
            return $2f7ebf3a194ce8e5$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { autoReplaceSvgRoot: autoReplaceSvgRoot } = params;
        if ($2f7ebf3a194ce8e5$var$config.autoReplaceSvg === false) $2f7ebf3a194ce8e5$var$config.autoReplaceSvg = true;
        $2f7ebf3a194ce8e5$var$config.observeMutations = true;
        $2f7ebf3a194ce8e5$var$domready(()=>{
            $2f7ebf3a194ce8e5$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $2f7ebf3a194ce8e5$var$callHooks('watch', params);
        });
    }
};
const $2f7ebf3a194ce8e5$var$parse = {
    icon: (icon)=>{
        if (icon === null) return null;
        if (typeof icon === 'object' && icon.prefix && icon.iconName) return {
            prefix: icon.prefix,
            iconName: $2f7ebf3a194ce8e5$var$byAlias(icon.prefix, icon.iconName) || icon.iconName
        };
        if (Array.isArray(icon) && icon.length === 2) {
            const iconName = icon[1].indexOf('fa-') === 0 ? icon[1].slice(3) : icon[1];
            const prefix = $2f7ebf3a194ce8e5$var$getCanonicalPrefix(icon[0]);
            return {
                prefix: prefix,
                iconName: $2f7ebf3a194ce8e5$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof icon === 'string' && (icon.indexOf("".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-")) > -1 || icon.match($2f7ebf3a194ce8e5$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            const canonicalIcon = $2f7ebf3a194ce8e5$var$getCanonicalIcon(icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix(),
                iconName: $2f7ebf3a194ce8e5$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof icon === 'string') {
            const prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
            return {
                prefix: prefix,
                iconName: $2f7ebf3a194ce8e5$var$byAlias(prefix, icon) || icon
            };
        }
    }
};
const $2f7ebf3a194ce8e5$export$644d8ea042df96a6 = {
    noAuto: $2f7ebf3a194ce8e5$var$noAuto,
    config: $2f7ebf3a194ce8e5$var$config,
    dom: $2f7ebf3a194ce8e5$var$dom,
    parse: $2f7ebf3a194ce8e5$var$parse,
    library: $2f7ebf3a194ce8e5$var$library,
    findIconDefinition: $2f7ebf3a194ce8e5$var$findIconDefinition,
    toHtml: $2f7ebf3a194ce8e5$var$toHtml
};
const $2f7ebf3a194ce8e5$var$autoReplace = function() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { autoReplaceSvgRoot: autoReplaceSvgRoot = $2f7ebf3a194ce8e5$var$DOCUMENT } = params;
    if ((Object.keys($2f7ebf3a194ce8e5$var$namespace.styles).length > 0 || $2f7ebf3a194ce8e5$var$config.autoFetchSvg) && $2f7ebf3a194ce8e5$var$IS_DOM && $2f7ebf3a194ce8e5$var$config.autoReplaceSvg) $2f7ebf3a194ce8e5$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $2f7ebf3a194ce8e5$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function() {
            return val.abstract.map((a)=>$2f7ebf3a194ce8e5$var$toHtml(a));
        }
    });
    Object.defineProperty(val, 'node', {
        get: function() {
            if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
            const container = $2f7ebf3a194ce8e5$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $2f7ebf3a194ce8e5$var$asIcon(_ref) {
    let { children: children, main: main, mask: mask, attributes: attributes, styles: styles, transform: transform } = _ref;
    if ($2f7ebf3a194ce8e5$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        const { width: width, height: height } = main;
        const offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $2f7ebf3a194ce8e5$var$joinStyles($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $2f7ebf3a194ce8e5$var$asSymbol(_ref) {
    let { prefix: prefix, iconName: iconName, children: children, attributes: attributes, symbol: symbol } = _ref;
    const id = symbol === true ? "".concat(prefix, "-").concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract(params) {
    const { icons: { main: main, mask: mask }, prefix: prefix, iconName: iconName, transform: transform, symbol: symbol, title: title, maskId: maskId, titleId: titleId, extra: extra, watchable: watchable = false } = params;
    const { width: width, height: height } = mask.found ? mask : main;
    const isUploadedIcon = $2f7ebf3a194ce8e5$var$Lt.includes(prefix);
    const attrClass = [
        $2f7ebf3a194ce8e5$var$config.replacementClass,
        iconName ? "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter((c$$1)=>extra.classes.indexOf(c$$1) === -1).filter((c$$1)=>c$$1 !== '' || !!c$$1).concat(extra.classes).join(' ');
    let content = {
        children: [],
        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$2f7ebf3a194ce8e5$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $2f7ebf3a194ce8e5$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    const args = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    const { children: children, attributes: attributes } = mask.found && main.found ? $2f7ebf3a194ce8e5$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $2f7ebf3a194ce8e5$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    };
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $2f7ebf3a194ce8e5$var$asSymbol(args);
    else return $2f7ebf3a194ce8e5$var$asIcon(args);
}
function $2f7ebf3a194ce8e5$var$makeLayersTextAbstract(params) {
    const { content: content, width: width, height: height, transform: transform, title: title, extra: extra, watchable: watchable = false } = params;
    const attributes = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$2f7ebf3a194ce8e5$var$DATA_FA_I2SVG] = '';
    const styles = $2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.styles);
    if ($2f7ebf3a194ce8e5$var$transformIsMeaningful(transform)) {
        styles['transform'] = $2f7ebf3a194ce8e5$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    const styleString = $2f7ebf3a194ce8e5$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $2f7ebf3a194ce8e5$var$makeLayersCounterAbstract(params) {
    const { content: content, title: title, extra: extra } = params;
    const attributes = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    const styleString = $2f7ebf3a194ce8e5$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
const { styles: $2f7ebf3a194ce8e5$var$styles$1 } = $2f7ebf3a194ce8e5$var$namespace;
function $2f7ebf3a194ce8e5$var$asFoundIcon(icon) {
    const width = icon[0];
    const height = icon[1];
    const [vectorData] = icon.slice(4);
    let element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat($2f7ebf3a194ce8e5$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat($2f7ebf3a194ce8e5$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat($2f7ebf3a194ce8e5$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
const $2f7ebf3a194ce8e5$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $2f7ebf3a194ce8e5$var$maybeNotifyMissing(iconName, prefix) {
    if (!$2f7ebf3a194ce8e5$var$PRODUCTION && !$2f7ebf3a194ce8e5$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $2f7ebf3a194ce8e5$var$findIcon(iconName, prefix) {
    let givenPrefix = prefix;
    if (prefix === 'fa' && $2f7ebf3a194ce8e5$var$config.styleDefault !== null) prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
    return new Promise((resolve, reject)=>{
        if (givenPrefix === 'fa') {
            const shim = $2f7ebf3a194ce8e5$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $2f7ebf3a194ce8e5$var$styles$1[prefix] && $2f7ebf3a194ce8e5$var$styles$1[prefix][iconName]) {
            const icon = $2f7ebf3a194ce8e5$var$styles$1[prefix][iconName];
            return resolve($2f7ebf3a194ce8e5$var$asFoundIcon(icon));
        }
        $2f7ebf3a194ce8e5$var$maybeNotifyMissing(iconName, prefix);
        resolve($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$missingIconResolutionMixin), {}, {
            icon: $2f7ebf3a194ce8e5$var$config.showMissingIcons && iconName ? $2f7ebf3a194ce8e5$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
const $2f7ebf3a194ce8e5$var$noop$1 = ()=>{};
const $2f7ebf3a194ce8e5$var$p$2 = $2f7ebf3a194ce8e5$var$config.measurePerformance && $2f7ebf3a194ce8e5$var$PERFORMANCE && $2f7ebf3a194ce8e5$var$PERFORMANCE.mark && $2f7ebf3a194ce8e5$var$PERFORMANCE.measure ? $2f7ebf3a194ce8e5$var$PERFORMANCE : {
    mark: $2f7ebf3a194ce8e5$var$noop$1,
    measure: $2f7ebf3a194ce8e5$var$noop$1
};
const $2f7ebf3a194ce8e5$var$preamble = "FA \"6.7.2\"";
const $2f7ebf3a194ce8e5$var$begin = (name)=>{
    $2f7ebf3a194ce8e5$var$p$2.mark("".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " begins"));
    return ()=>$2f7ebf3a194ce8e5$var$end(name);
};
const $2f7ebf3a194ce8e5$var$end = (name)=>{
    $2f7ebf3a194ce8e5$var$p$2.mark("".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " ends"));
    $2f7ebf3a194ce8e5$var$p$2.measure("".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name), "".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " begins"), "".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " ends"));
};
var $2f7ebf3a194ce8e5$var$perf = {
    begin: $2f7ebf3a194ce8e5$var$begin,
    end: $2f7ebf3a194ce8e5$var$end
};
const $2f7ebf3a194ce8e5$var$noop$2 = ()=>{};
function $2f7ebf3a194ce8e5$var$isWatched(node) {
    const i2svg = node.getAttribute ? node.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $2f7ebf3a194ce8e5$var$hasPrefixAndIcon(node) {
    const prefix = node.getAttribute ? node.getAttribute($2f7ebf3a194ce8e5$var$DATA_PREFIX) : null;
    const icon = node.getAttribute ? node.getAttribute($2f7ebf3a194ce8e5$var$DATA_ICON) : null;
    return prefix && icon;
}
function $2f7ebf3a194ce8e5$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($2f7ebf3a194ce8e5$var$config.replacementClass);
}
function $2f7ebf3a194ce8e5$var$getMutator() {
    if ($2f7ebf3a194ce8e5$var$config.autoReplaceSvg === true) return $2f7ebf3a194ce8e5$var$mutators.replace;
    const mutator = $2f7ebf3a194ce8e5$var$mutators[$2f7ebf3a194ce8e5$var$config.autoReplaceSvg];
    return mutator || $2f7ebf3a194ce8e5$var$mutators.replace;
}
function $2f7ebf3a194ce8e5$var$createElementNS(tag) {
    return $2f7ebf3a194ce8e5$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $2f7ebf3a194ce8e5$var$createElement(tag) {
    return $2f7ebf3a194ce8e5$var$DOCUMENT.createElement(tag);
}
function $2f7ebf3a194ce8e5$var$convertSVG(abstractObj) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { ceFn: ceFn = abstractObj.tag === 'svg' ? $2f7ebf3a194ce8e5$var$createElementNS : $2f7ebf3a194ce8e5$var$createElement } = params;
    if (typeof abstractObj === 'string') return $2f7ebf3a194ce8e5$var$DOCUMENT.createTextNode(abstractObj);
    const tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    const children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($2f7ebf3a194ce8e5$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $2f7ebf3a194ce8e5$var$nodeAsComment(node) {
    let comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
const $2f7ebf3a194ce8e5$var$mutators = {
    replace: function(mutation) {
        const node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach((abstract)=>{
                node.parentNode.insertBefore($2f7ebf3a194ce8e5$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG) === null && $2f7ebf3a194ce8e5$var$config.keepOriginalSource) {
                let comment = $2f7ebf3a194ce8e5$var$DOCUMENT.createComment($2f7ebf3a194ce8e5$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function(mutation) {
        const node = mutation[0];
        const abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$2f7ebf3a194ce8e5$var$classArray(node).indexOf($2f7ebf3a194ce8e5$var$config.replacementClass)) return $2f7ebf3a194ce8e5$var$mutators.replace(mutation);
        const forSvg = new RegExp("".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            const splitClasses = abstract[0].attributes.class.split(' ').reduce((acc, cls)=>{
                if (cls === $2f7ebf3a194ce8e5$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        const newInnerHTML = abstract.map((a)=>$2f7ebf3a194ce8e5$var$toHtml(a)).join('\n');
        node.setAttribute($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $2f7ebf3a194ce8e5$var$performOperationSync(op) {
    op();
}
function $2f7ebf3a194ce8e5$var$perform(mutations, callback) {
    const callbackFunction = typeof callback === 'function' ? callback : $2f7ebf3a194ce8e5$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        let frame = $2f7ebf3a194ce8e5$var$performOperationSync;
        if ($2f7ebf3a194ce8e5$var$config.mutateApproach === $2f7ebf3a194ce8e5$var$MUTATION_APPROACH_ASYNC) frame = $2f7ebf3a194ce8e5$var$WINDOW.requestAnimationFrame || $2f7ebf3a194ce8e5$var$performOperationSync;
        frame(()=>{
            const mutator = $2f7ebf3a194ce8e5$var$getMutator();
            const mark = $2f7ebf3a194ce8e5$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
let $2f7ebf3a194ce8e5$var$disabled = false;
function $2f7ebf3a194ce8e5$var$disableObservation() {
    $2f7ebf3a194ce8e5$var$disabled = true;
}
function $2f7ebf3a194ce8e5$var$enableObservation() {
    $2f7ebf3a194ce8e5$var$disabled = false;
}
let $2f7ebf3a194ce8e5$var$mo = null;
function $2f7ebf3a194ce8e5$var$observe(options) {
    if (!$2f7ebf3a194ce8e5$var$MUTATION_OBSERVER) return;
    if (!$2f7ebf3a194ce8e5$var$config.observeMutations) return;
    const { treeCallback: treeCallback = $2f7ebf3a194ce8e5$var$noop$2, nodeCallback: nodeCallback = $2f7ebf3a194ce8e5$var$noop$2, pseudoElementsCallback: pseudoElementsCallback = $2f7ebf3a194ce8e5$var$noop$2, observeMutationsRoot: observeMutationsRoot = $2f7ebf3a194ce8e5$var$DOCUMENT } = options;
    $2f7ebf3a194ce8e5$var$mo = new $2f7ebf3a194ce8e5$var$MUTATION_OBSERVER((objects)=>{
        if ($2f7ebf3a194ce8e5$var$disabled) return;
        const defaultPrefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
        $2f7ebf3a194ce8e5$var$toArray(objects).forEach((mutationRecord)=>{
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$2f7ebf3a194ce8e5$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($2f7ebf3a194ce8e5$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $2f7ebf3a194ce8e5$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $2f7ebf3a194ce8e5$var$isWatched(mutationRecord.target) && ~$2f7ebf3a194ce8e5$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $2f7ebf3a194ce8e5$var$hasPrefixAndIcon(mutationRecord.target)) {
                    const { prefix: prefix, iconName: iconName } = $2f7ebf3a194ce8e5$var$getCanonicalIcon($2f7ebf3a194ce8e5$var$classArray(mutationRecord.target));
                    mutationRecord.target.setAttribute($2f7ebf3a194ce8e5$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($2f7ebf3a194ce8e5$var$DATA_ICON, iconName);
                } else if ($2f7ebf3a194ce8e5$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
    $2f7ebf3a194ce8e5$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $2f7ebf3a194ce8e5$var$disconnect() {
    if (!$2f7ebf3a194ce8e5$var$mo) return;
    $2f7ebf3a194ce8e5$var$mo.disconnect();
}
function $2f7ebf3a194ce8e5$var$styleParser(node) {
    const style = node.getAttribute('style');
    let val = [];
    if (style) val = style.split(';').reduce((acc, style)=>{
        const styles = style.split(':');
        const prop = styles[0];
        const value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $2f7ebf3a194ce8e5$var$classParser(node) {
    const existingPrefix = node.getAttribute('data-prefix');
    const existingIconName = node.getAttribute('data-icon');
    const innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    let val = $2f7ebf3a194ce8e5$var$getCanonicalIcon($2f7ebf3a194ce8e5$var$classArray(node));
    if (!val.prefix) val.prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $2f7ebf3a194ce8e5$var$byLigature(val.prefix, node.innerText) || $2f7ebf3a194ce8e5$var$byUnicode(val.prefix, $2f7ebf3a194ce8e5$var$toHex(node.innerText));
    if (!val.iconName && $2f7ebf3a194ce8e5$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $2f7ebf3a194ce8e5$var$attributesParser(node) {
    const extraAttributes = $2f7ebf3a194ce8e5$var$toArray(node.attributes).reduce((acc, attr)=>{
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    const title = node.getAttribute('title');
    const titleId = node.getAttribute('data-fa-title-id');
    if ($2f7ebf3a194ce8e5$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($2f7ebf3a194ce8e5$var$config.replacementClass, "-title-").concat(titleId || $2f7ebf3a194ce8e5$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $2f7ebf3a194ce8e5$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $2f7ebf3a194ce8e5$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $2f7ebf3a194ce8e5$var$parseMeta(node) {
    let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    const { iconName: iconName, prefix: prefix, rest: extraClasses } = $2f7ebf3a194ce8e5$var$classParser(node);
    const extraAttributes = $2f7ebf3a194ce8e5$var$attributesParser(node);
    const pluginMeta = $2f7ebf3a194ce8e5$var$chainHooks('parseNodeAttributes', {}, node);
    let extraStyles = parser.styleParser ? $2f7ebf3a194ce8e5$var$styleParser(node) : [];
    return $2f7ebf3a194ce8e5$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $2f7ebf3a194ce8e5$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
const { styles: $2f7ebf3a194ce8e5$var$styles$2 } = $2f7ebf3a194ce8e5$var$namespace;
function $2f7ebf3a194ce8e5$var$generateMutation(node) {
    const nodeMeta = $2f7ebf3a194ce8e5$var$config.autoReplaceSvg === 'nest' ? $2f7ebf3a194ce8e5$var$parseMeta(node, {
        styleParser: false
    }) : $2f7ebf3a194ce8e5$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($2f7ebf3a194ce8e5$var$LAYERS_TEXT_CLASSNAME)) return $2f7ebf3a194ce8e5$var$callProvided('generateLayersText', node, nodeMeta);
    else return $2f7ebf3a194ce8e5$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $2f7ebf3a194ce8e5$var$getKnownPrefixes() {
    return [
        ...$2f7ebf3a194ce8e5$var$Ft,
        ...$2f7ebf3a194ce8e5$var$Ia
    ];
}
function $2f7ebf3a194ce8e5$var$onTree(root) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return Promise.resolve();
    const htmlClassList = $2f7ebf3a194ce8e5$var$DOCUMENT.documentElement.classList;
    const hclAdd = (suffix)=>htmlClassList.add("".concat($2f7ebf3a194ce8e5$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const hclRemove = (suffix)=>htmlClassList.remove("".concat($2f7ebf3a194ce8e5$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const prefixes = $2f7ebf3a194ce8e5$var$config.autoFetchSvg ? $2f7ebf3a194ce8e5$var$getKnownPrefixes() : $2f7ebf3a194ce8e5$var$P.concat(Object.keys($2f7ebf3a194ce8e5$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    const prefixesDomQuery = [
        ".".concat($2f7ebf3a194ce8e5$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map((p$$1)=>".".concat(p$$1, ":not([").concat($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG, "])"))).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    let candidates = [];
    try {
        candidates = $2f7ebf3a194ce8e5$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    const mark = $2f7ebf3a194ce8e5$var$perf.begin('onTree');
    const mutations = candidates.reduce((acc, node)=>{
        try {
            const mutation = $2f7ebf3a194ce8e5$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$2f7ebf3a194ce8e5$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise((resolve, reject)=>{
        Promise.all(mutations).then((resolvedMutations)=>{
            $2f7ebf3a194ce8e5$var$perform(resolvedMutations, ()=>{
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch((e$$1)=>{
            mark();
            reject(e$$1);
        });
    });
}
function $2f7ebf3a194ce8e5$var$onNode(node) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $2f7ebf3a194ce8e5$var$generateMutation(node).then((mutation)=>{
        if (mutation) $2f7ebf3a194ce8e5$var$perform([
            mutation
        ], callback);
    });
}
function $2f7ebf3a194ce8e5$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $2f7ebf3a194ce8e5$var$findIconDefinition(maybeIconDefinition || {});
        let { mask: mask } = params;
        if (mask) mask = (mask || {}).icon ? mask : $2f7ebf3a194ce8e5$var$findIconDefinition(mask || {});
        return next(iconDefinition, $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
const $2f7ebf3a194ce8e5$var$render = function(iconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { transform: transform = $2f7ebf3a194ce8e5$var$meaninglessTransform, symbol: symbol = false, mask: mask = null, maskId: maskId = null, title: title = null, titleId: titleId = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
    if (!iconDefinition) return;
    const { prefix: prefix, iconName: iconName, icon: icon } = iconDefinition;
    return $2f7ebf3a194ce8e5$var$domVariants($2f7ebf3a194ce8e5$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), ()=>{
        $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($2f7ebf3a194ce8e5$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($2f7ebf3a194ce8e5$var$config.replacementClass, "-title-").concat(titleId || $2f7ebf3a194ce8e5$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract({
            icons: {
                main: $2f7ebf3a194ce8e5$var$asFoundIcon(icon),
                mask: mask ? $2f7ebf3a194ce8e5$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $2f7ebf3a194ce8e5$var$ReplaceElements = {
    mixout () {
        return {
            icon: $2f7ebf3a194ce8e5$var$resolveIcons($2f7ebf3a194ce8e5$var$render)
        };
    },
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.treeCallback = $2f7ebf3a194ce8e5$var$onTree;
                accumulator.nodeCallback = $2f7ebf3a194ce8e5$var$onNode;
                return accumulator;
            }
        };
    },
    provides (providers$$1) {
        providers$$1.i2svg = function(params) {
            const { node: node = $2f7ebf3a194ce8e5$var$DOCUMENT, callback: callback = ()=>{} } = params;
            return $2f7ebf3a194ce8e5$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            const { iconName: iconName, title: title, titleId: titleId, prefix: prefix, transform: transform, symbol: symbol, mask: mask, maskId: maskId, extra: extra } = nodeMeta;
            return new Promise((resolve, reject)=>{
                Promise.all([
                    $2f7ebf3a194ce8e5$var$findIcon(iconName, prefix),
                    mask.iconName ? $2f7ebf3a194ce8e5$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((_ref)=>{
                    let [main, mask] = _ref;
                    resolve([
                        node,
                        $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref2) {
            let { children: children, attributes: attributes, main: main, transform: transform, styles: styles } = _ref2;
            const styleString = $2f7ebf3a194ce8e5$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            let nextChild;
            if ($2f7ebf3a194ce8e5$var$transformIsMeaningful(transform)) nextChild = $2f7ebf3a194ce8e5$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $2f7ebf3a194ce8e5$var$Layers = {
    mixout () {
        return {
            layer (assembler) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { classes: classes = [] } = params;
                return $2f7ebf3a194ce8e5$var$domVariants({
                    type: 'layer'
                }, ()=>{
                    $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    let children = [];
                    assembler((args)=>{
                        Array.isArray(args) ? args.map((a)=>{
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-layers"),
                                    ...classes
                                ].join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $2f7ebf3a194ce8e5$var$LayersCounter = {
    mixout () {
        return {
            counter (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $2f7ebf3a194ce8e5$var$domVariants({
                    type: 'counter',
                    content: content
                }, ()=>{
                    $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $2f7ebf3a194ce8e5$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-layers-counter"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    }
};
var $2f7ebf3a194ce8e5$var$LayersText = {
    mixout () {
        return {
            text (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { transform: transform = $2f7ebf3a194ce8e5$var$meaninglessTransform, title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $2f7ebf3a194ce8e5$var$domVariants({
                    type: 'text',
                    content: content
                }, ()=>{
                    $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $2f7ebf3a194ce8e5$var$makeLayersTextAbstract({
                        content: content,
                        transform: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-layers-text"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    },
    provides (providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            const { title: title, transform: transform, extra: extra } = nodeMeta;
            let width = null;
            let height = null;
            if ($2f7ebf3a194ce8e5$var$IS_IE) {
                const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                const boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($2f7ebf3a194ce8e5$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $2f7ebf3a194ce8e5$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
const $2f7ebf3a194ce8e5$var$CLEAN_CONTENT_PATTERN = new RegExp('"', 'ug');
const $2f7ebf3a194ce8e5$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
const $2f7ebf3a194ce8e5$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $2f7ebf3a194ce8e5$var$lt), $2f7ebf3a194ce8e5$var$wa), $2f7ebf3a194ce8e5$var$Yt);
const $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($2f7ebf3a194ce8e5$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key)=>{
    acc[key.toLowerCase()] = $2f7ebf3a194ce8e5$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
const $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily)=>{
    const weights = $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || [
        ...Object.entries(weights)
    ][0][1];
    return acc;
}, {});
function $2f7ebf3a194ce8e5$var$hexValueFromContent(content) {
    const cleaned = content.replace($2f7ebf3a194ce8e5$var$CLEAN_CONTENT_PATTERN, '');
    const codePoint = $2f7ebf3a194ce8e5$var$codePointAt(cleaned, 0);
    const isPrependTen = codePoint >= $2f7ebf3a194ce8e5$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $2f7ebf3a194ce8e5$var$SECONDARY_UNICODE_RANGE[1];
    const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $2f7ebf3a194ce8e5$var$toHex(cleaned[0]) : $2f7ebf3a194ce8e5$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $2f7ebf3a194ce8e5$var$getPrefix(fontFamily, fontWeight) {
    const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    const fontWeightInteger = parseInt(fontWeight);
    const fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $2f7ebf3a194ce8e5$var$replaceForPosition(node, position) {
    const pendingAttribute = "".concat($2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise((resolve, reject)=>{
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        const children = $2f7ebf3a194ce8e5$var$toArray(node.children);
        const alreadyProcessedPseudoElement = children.filter((c$$1)=>c$$1.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT) === position)[0];
        const styles = $2f7ebf3a194ce8e5$var$WINDOW.getComputedStyle(node, position);
        const fontFamily = styles.getPropertyValue('font-family');
        const fontFamilyMatch = fontFamily.match($2f7ebf3a194ce8e5$var$FONT_FAMILY_PATTERN);
        const fontWeight = styles.getPropertyValue('font-weight');
        const content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            const content = styles.getPropertyValue('content');
            let prefix = $2f7ebf3a194ce8e5$var$getPrefix(fontFamily, fontWeight);
            const { value: hexValue, isSecondary: isSecondary } = $2f7ebf3a194ce8e5$var$hexValueFromContent(content);
            const isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            let iconName = $2f7ebf3a194ce8e5$var$byUnicode(prefix, hexValue);
            let iconIdentifier = iconName;
            if (isV4) {
                const iconName4 = $2f7ebf3a194ce8e5$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($2f7ebf3a194ce8e5$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($2f7ebf3a194ce8e5$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                const meta = $2f7ebf3a194ce8e5$var$blankMeta();
                const { extra: extra } = meta;
                extra.attributes[$2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $2f7ebf3a194ce8e5$var$findIcon(iconName, prefix).then((main)=>{
                    const abstract = $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $2f7ebf3a194ce8e5$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    const element = $2f7ebf3a194ce8e5$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map((a$$1)=>$2f7ebf3a194ce8e5$var$toHtml(a$$1)).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $2f7ebf3a194ce8e5$var$replace(node) {
    return Promise.all([
        $2f7ebf3a194ce8e5$var$replaceForPosition(node, '::before'),
        $2f7ebf3a194ce8e5$var$replaceForPosition(node, '::after')
    ]);
}
function $2f7ebf3a194ce8e5$var$processable(node) {
    return node.parentNode !== document.head && !~$2f7ebf3a194ce8e5$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $2f7ebf3a194ce8e5$var$searchPseudoElements(root) {
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
    return new Promise((resolve, reject)=>{
        const operations = $2f7ebf3a194ce8e5$var$toArray(root.querySelectorAll('*')).filter($2f7ebf3a194ce8e5$var$processable).map($2f7ebf3a194ce8e5$var$replace);
        const end = $2f7ebf3a194ce8e5$var$perf.begin('searchPseudoElements');
        $2f7ebf3a194ce8e5$var$disableObservation();
        Promise.all(operations).then(()=>{
            end();
            $2f7ebf3a194ce8e5$var$enableObservation();
            resolve();
        }).catch(()=>{
            end();
            $2f7ebf3a194ce8e5$var$enableObservation();
            reject();
        });
    });
}
var $2f7ebf3a194ce8e5$var$PseudoElements = {
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.pseudoElementsCallback = $2f7ebf3a194ce8e5$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.pseudoElements2svg = function(params) {
            const { node: node = $2f7ebf3a194ce8e5$var$DOCUMENT } = params;
            if ($2f7ebf3a194ce8e5$var$config.searchPseudoElements) $2f7ebf3a194ce8e5$var$searchPseudoElements(node);
        };
    }
};
let $2f7ebf3a194ce8e5$var$_unwatched = false;
var $2f7ebf3a194ce8e5$var$MutationObserver$1 = {
    mixout () {
        return {
            dom: {
                unwatch () {
                    $2f7ebf3a194ce8e5$var$disableObservation();
                    $2f7ebf3a194ce8e5$var$_unwatched = true;
                }
            }
        };
    },
    hooks () {
        return {
            bootstrap () {
                $2f7ebf3a194ce8e5$var$observe($2f7ebf3a194ce8e5$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto () {
                $2f7ebf3a194ce8e5$var$disconnect();
            },
            watch (params) {
                const { observeMutationsRoot: observeMutationsRoot } = params;
                if ($2f7ebf3a194ce8e5$var$_unwatched) $2f7ebf3a194ce8e5$var$enableObservation();
                else $2f7ebf3a194ce8e5$var$observe($2f7ebf3a194ce8e5$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
const $2f7ebf3a194ce8e5$var$parseTransformString = (transformString)=>{
    let transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce((acc, n)=>{
        const parts = n.toLowerCase().split('-');
        const first = parts[0];
        let rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $2f7ebf3a194ce8e5$var$PowerTransforms = {
    mixout () {
        return {
            parse: {
                transform: (transformString)=>{
                    return $2f7ebf3a194ce8e5$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $2f7ebf3a194ce8e5$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            let { main: main, transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
            const outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            const inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            const path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            const operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $2f7ebf3a194ce8e5$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $2f7ebf3a194ce8e5$var$fillBlack(abstract) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $2f7ebf3a194ce8e5$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $2f7ebf3a194ce8e5$var$Masks = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const maskData = node.getAttribute('data-fa-mask');
                const mask = !maskData ? $2f7ebf3a194ce8e5$var$emptyCanonicalIcon() : $2f7ebf3a194ce8e5$var$getCanonicalIcon(maskData.split(' ').map((i)=>i.trim()));
                if (!mask.prefix) mask.prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractMask = function(_ref) {
            let { children: children, attributes: attributes, main: main, mask: mask, maskId: explicitMaskId, transform: transform } = _ref;
            const { width: mainWidth, icon: mainPath } = main;
            const { width: maskWidth, icon: maskPath } = mask;
            const trans = $2f7ebf3a194ce8e5$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            const maskRect = {
                tag: 'rect',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            const maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($2f7ebf3a194ce8e5$var$fillBlack)
            } : {};
            const maskInnerGroup = {
                tag: 'g',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, trans.inner),
                children: [
                    $2f7ebf3a194ce8e5$var$fillBlack($2f7ebf3a194ce8e5$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            const maskOuterGroup = {
                tag: 'g',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            const maskId = "mask-".concat(explicitMaskId || $2f7ebf3a194ce8e5$var$nextUniqueId());
            const clipId = "clip-".concat(explicitMaskId || $2f7ebf3a194ce8e5$var$nextUniqueId());
            const maskTag = {
                tag: 'mask',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            const defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $2f7ebf3a194ce8e5$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $2f7ebf3a194ce8e5$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $2f7ebf3a194ce8e5$var$MissingIconIndicator = {
    provides (providers) {
        let reduceMotion = false;
        if ($2f7ebf3a194ce8e5$var$WINDOW.matchMedia) reduceMotion = $2f7ebf3a194ce8e5$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            const gChildren = [];
            const FILL = {
                fill: 'currentColor'
            };
            const ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            const OPACITY_ANIMATE = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            const dot = {
                tag: 'circle',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $2f7ebf3a194ce8e5$var$SvgSymbols = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const symbolData = node.getAttribute('data-fa-symbol');
                const symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $2f7ebf3a194ce8e5$var$plugins = [
    $2f7ebf3a194ce8e5$var$InjectCSS,
    $2f7ebf3a194ce8e5$var$ReplaceElements,
    $2f7ebf3a194ce8e5$var$Layers,
    $2f7ebf3a194ce8e5$var$LayersCounter,
    $2f7ebf3a194ce8e5$var$LayersText,
    $2f7ebf3a194ce8e5$var$PseudoElements,
    $2f7ebf3a194ce8e5$var$MutationObserver$1,
    $2f7ebf3a194ce8e5$var$PowerTransforms,
    $2f7ebf3a194ce8e5$var$Masks,
    $2f7ebf3a194ce8e5$var$MissingIconIndicator,
    $2f7ebf3a194ce8e5$var$SvgSymbols
];
$2f7ebf3a194ce8e5$var$registerPlugins($2f7ebf3a194ce8e5$var$plugins, {
    mixoutsTo: $2f7ebf3a194ce8e5$export$644d8ea042df96a6
});
const $2f7ebf3a194ce8e5$export$4f8e844b2782642c = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.noAuto;
const $2f7ebf3a194ce8e5$export$e506a1d27d1eaa20 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.config;
const $2f7ebf3a194ce8e5$export$b839f963c7dc0e34 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.library;
const $2f7ebf3a194ce8e5$export$df3a06d6289f983e = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.dom;
const $2f7ebf3a194ce8e5$export$98e6a39c04603d36 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.parse;
const $2f7ebf3a194ce8e5$export$221fed4a47f597a5 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.findIconDefinition;
const $2f7ebf3a194ce8e5$export$a10125c086a4df16 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.toHtml;
const $2f7ebf3a194ce8e5$export$1ca1ec8b29a4ce27 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.icon;
const $2f7ebf3a194ce8e5$export$50a222d9023da98b = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.layer;
const $2f7ebf3a194ce8e5$export$6f093cfa640b7166 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.text;
const $2f7ebf3a194ce8e5$export$e575061ef2a070eb = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.counter;


var $98e875df216c54f4$exports = {};
'use strict';
Object.defineProperty($98e875df216c54f4$exports, '__esModule', {
    value: true
});
var $98e875df216c54f4$var$prefix = 'far';
var $98e875df216c54f4$var$iconName = 'angle-left';
var $98e875df216c54f4$var$width = 320;
var $98e875df216c54f4$var$height = 512;
var $98e875df216c54f4$var$aliases = [
    8249
];
var $98e875df216c54f4$var$unicode = 'f104';
var $98e875df216c54f4$var$svgPathData = 'M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z';
$98e875df216c54f4$exports.definition = {
    prefix: $98e875df216c54f4$var$prefix,
    iconName: $98e875df216c54f4$var$iconName,
    icon: [
        $98e875df216c54f4$var$width,
        $98e875df216c54f4$var$height,
        $98e875df216c54f4$var$aliases,
        $98e875df216c54f4$var$unicode,
        $98e875df216c54f4$var$svgPathData
    ]
};
$98e875df216c54f4$exports.faAngleLeft = $98e875df216c54f4$exports.definition;
$98e875df216c54f4$exports.prefix = $98e875df216c54f4$var$prefix;
$98e875df216c54f4$exports.iconName = $98e875df216c54f4$var$iconName;
$98e875df216c54f4$exports.width = $98e875df216c54f4$var$width;
$98e875df216c54f4$exports.height = $98e875df216c54f4$var$height;
$98e875df216c54f4$exports.ligatures = $98e875df216c54f4$var$aliases;
$98e875df216c54f4$exports.unicode = $98e875df216c54f4$var$unicode;
$98e875df216c54f4$exports.svgPathData = $98e875df216c54f4$var$svgPathData;
$98e875df216c54f4$exports.aliases = $98e875df216c54f4$var$aliases;


var $cedfc6bf94a82c24$exports = {};
'use strict';
Object.defineProperty($cedfc6bf94a82c24$exports, '__esModule', {
    value: true
});
var $cedfc6bf94a82c24$var$prefix = 'far';
var $cedfc6bf94a82c24$var$iconName = 'angle-right';
var $cedfc6bf94a82c24$var$width = 320;
var $cedfc6bf94a82c24$var$height = 512;
var $cedfc6bf94a82c24$var$aliases = [
    8250
];
var $cedfc6bf94a82c24$var$unicode = 'f105';
var $cedfc6bf94a82c24$var$svgPathData = 'M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z';
$cedfc6bf94a82c24$exports.definition = {
    prefix: $cedfc6bf94a82c24$var$prefix,
    iconName: $cedfc6bf94a82c24$var$iconName,
    icon: [
        $cedfc6bf94a82c24$var$width,
        $cedfc6bf94a82c24$var$height,
        $cedfc6bf94a82c24$var$aliases,
        $cedfc6bf94a82c24$var$unicode,
        $cedfc6bf94a82c24$var$svgPathData
    ]
};
$cedfc6bf94a82c24$exports.faAngleRight = $cedfc6bf94a82c24$exports.definition;
$cedfc6bf94a82c24$exports.prefix = $cedfc6bf94a82c24$var$prefix;
$cedfc6bf94a82c24$exports.iconName = $cedfc6bf94a82c24$var$iconName;
$cedfc6bf94a82c24$exports.width = $cedfc6bf94a82c24$var$width;
$cedfc6bf94a82c24$exports.height = $cedfc6bf94a82c24$var$height;
$cedfc6bf94a82c24$exports.ligatures = $cedfc6bf94a82c24$var$aliases;
$cedfc6bf94a82c24$exports.unicode = $cedfc6bf94a82c24$var$unicode;
$cedfc6bf94a82c24$exports.svgPathData = $cedfc6bf94a82c24$var$svgPathData;
$cedfc6bf94a82c24$exports.aliases = $cedfc6bf94a82c24$var$aliases;


var $c17b7e009c12ce7d$exports = {};
'use strict';
Object.defineProperty($c17b7e009c12ce7d$exports, '__esModule', {
    value: true
});
var $c30571851fe9e2b5$exports = {};
'use strict';
Object.defineProperty($c30571851fe9e2b5$exports, '__esModule', {
    value: true
});
var $c30571851fe9e2b5$var$prefix = 'far';
var $c30571851fe9e2b5$var$iconName = 'magnifying-glass';
var $c30571851fe9e2b5$var$width = 512;
var $c30571851fe9e2b5$var$height = 512;
var $c30571851fe9e2b5$var$aliases = [
    128269,
    "search"
];
var $c30571851fe9e2b5$var$unicode = 'f002';
var $c30571851fe9e2b5$var$svgPathData = 'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z';
$c30571851fe9e2b5$exports.definition = {
    prefix: $c30571851fe9e2b5$var$prefix,
    iconName: $c30571851fe9e2b5$var$iconName,
    icon: [
        $c30571851fe9e2b5$var$width,
        $c30571851fe9e2b5$var$height,
        $c30571851fe9e2b5$var$aliases,
        $c30571851fe9e2b5$var$unicode,
        $c30571851fe9e2b5$var$svgPathData
    ]
};
$c30571851fe9e2b5$exports.faMagnifyingGlass = $c30571851fe9e2b5$exports.definition;
$c30571851fe9e2b5$exports.prefix = $c30571851fe9e2b5$var$prefix;
$c30571851fe9e2b5$exports.iconName = $c30571851fe9e2b5$var$iconName;
$c30571851fe9e2b5$exports.width = $c30571851fe9e2b5$var$width;
$c30571851fe9e2b5$exports.height = $c30571851fe9e2b5$var$height;
$c30571851fe9e2b5$exports.ligatures = $c30571851fe9e2b5$var$aliases;
$c30571851fe9e2b5$exports.unicode = $c30571851fe9e2b5$var$unicode;
$c30571851fe9e2b5$exports.svgPathData = $c30571851fe9e2b5$var$svgPathData;
$c30571851fe9e2b5$exports.aliases = $c30571851fe9e2b5$var$aliases;


$c17b7e009c12ce7d$exports.definition = {
    prefix: $c30571851fe9e2b5$exports.prefix,
    iconName: $c30571851fe9e2b5$exports.iconName,
    icon: [
        $c30571851fe9e2b5$exports.width,
        $c30571851fe9e2b5$exports.height,
        $c30571851fe9e2b5$exports.aliases,
        $c30571851fe9e2b5$exports.unicode,
        $c30571851fe9e2b5$exports.svgPathData
    ]
};
$c17b7e009c12ce7d$exports.faSearch = $c17b7e009c12ce7d$exports.definition;
$c17b7e009c12ce7d$exports.prefix = $c30571851fe9e2b5$exports.prefix;
$c17b7e009c12ce7d$exports.iconName = $c30571851fe9e2b5$exports.iconName;
$c17b7e009c12ce7d$exports.width = $c30571851fe9e2b5$exports.width;
$c17b7e009c12ce7d$exports.height = $c30571851fe9e2b5$exports.height;
$c17b7e009c12ce7d$exports.ligatures = $c30571851fe9e2b5$exports.aliases;
$c17b7e009c12ce7d$exports.unicode = $c30571851fe9e2b5$exports.unicode;
$c17b7e009c12ce7d$exports.svgPathData = $c30571851fe9e2b5$exports.svgPathData;
$c17b7e009c12ce7d$exports.aliases = $c30571851fe9e2b5$exports.aliases;


var $099c87b3dd8df3c8$exports = {};
'use strict';
Object.defineProperty($099c87b3dd8df3c8$exports, '__esModule', {
    value: true
});
var $099c87b3dd8df3c8$var$prefix = 'far';
var $099c87b3dd8df3c8$var$iconName = 'bars';
var $099c87b3dd8df3c8$var$width = 448;
var $099c87b3dd8df3c8$var$height = 512;
var $099c87b3dd8df3c8$var$aliases = [
    "navicon"
];
var $099c87b3dd8df3c8$var$unicode = 'f0c9';
var $099c87b3dd8df3c8$var$svgPathData = 'M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 272c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z';
$099c87b3dd8df3c8$exports.definition = {
    prefix: $099c87b3dd8df3c8$var$prefix,
    iconName: $099c87b3dd8df3c8$var$iconName,
    icon: [
        $099c87b3dd8df3c8$var$width,
        $099c87b3dd8df3c8$var$height,
        $099c87b3dd8df3c8$var$aliases,
        $099c87b3dd8df3c8$var$unicode,
        $099c87b3dd8df3c8$var$svgPathData
    ]
};
$099c87b3dd8df3c8$exports.faBars = $099c87b3dd8df3c8$exports.definition;
$099c87b3dd8df3c8$exports.prefix = $099c87b3dd8df3c8$var$prefix;
$099c87b3dd8df3c8$exports.iconName = $099c87b3dd8df3c8$var$iconName;
$099c87b3dd8df3c8$exports.width = $099c87b3dd8df3c8$var$width;
$099c87b3dd8df3c8$exports.height = $099c87b3dd8df3c8$var$height;
$099c87b3dd8df3c8$exports.ligatures = $099c87b3dd8df3c8$var$aliases;
$099c87b3dd8df3c8$exports.unicode = $099c87b3dd8df3c8$var$unicode;
$099c87b3dd8df3c8$exports.svgPathData = $099c87b3dd8df3c8$var$svgPathData;
$099c87b3dd8df3c8$exports.aliases = $099c87b3dd8df3c8$var$aliases;


var $cac493d0ac84992c$exports = {};
'use strict';
Object.defineProperty($cac493d0ac84992c$exports, '__esModule', {
    value: true
});
var $cac493d0ac84992c$var$prefix = 'far';
var $cac493d0ac84992c$var$iconName = 'file';
var $cac493d0ac84992c$var$width = 384;
var $cac493d0ac84992c$var$height = 512;
var $cac493d0ac84992c$var$aliases = [
    128196,
    128459,
    61462
];
var $cac493d0ac84992c$var$unicode = 'f15b';
var $cac493d0ac84992c$var$svgPathData = 'M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z';
$cac493d0ac84992c$exports.definition = {
    prefix: $cac493d0ac84992c$var$prefix,
    iconName: $cac493d0ac84992c$var$iconName,
    icon: [
        $cac493d0ac84992c$var$width,
        $cac493d0ac84992c$var$height,
        $cac493d0ac84992c$var$aliases,
        $cac493d0ac84992c$var$unicode,
        $cac493d0ac84992c$var$svgPathData
    ]
};
$cac493d0ac84992c$exports.faFile = $cac493d0ac84992c$exports.definition;
$cac493d0ac84992c$exports.prefix = $cac493d0ac84992c$var$prefix;
$cac493d0ac84992c$exports.iconName = $cac493d0ac84992c$var$iconName;
$cac493d0ac84992c$exports.width = $cac493d0ac84992c$var$width;
$cac493d0ac84992c$exports.height = $cac493d0ac84992c$var$height;
$cac493d0ac84992c$exports.ligatures = $cac493d0ac84992c$var$aliases;
$cac493d0ac84992c$exports.unicode = $cac493d0ac84992c$var$unicode;
$cac493d0ac84992c$exports.svgPathData = $cac493d0ac84992c$var$svgPathData;
$cac493d0ac84992c$exports.aliases = $cac493d0ac84992c$var$aliases;


var $edb355c416917111$exports = {};
'use strict';
Object.defineProperty($edb355c416917111$exports, '__esModule', {
    value: true
});
var $edb355c416917111$var$prefix = 'far';
var $edb355c416917111$var$iconName = 'image';
var $edb355c416917111$var$width = 512;
var $edb355c416917111$var$height = 512;
var $edb355c416917111$var$aliases = [];
var $edb355c416917111$var$unicode = 'f03e';
var $edb355c416917111$var$svgPathData = 'M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z';
$edb355c416917111$exports.definition = {
    prefix: $edb355c416917111$var$prefix,
    iconName: $edb355c416917111$var$iconName,
    icon: [
        $edb355c416917111$var$width,
        $edb355c416917111$var$height,
        $edb355c416917111$var$aliases,
        $edb355c416917111$var$unicode,
        $edb355c416917111$var$svgPathData
    ]
};
$edb355c416917111$exports.faImage = $edb355c416917111$exports.definition;
$edb355c416917111$exports.prefix = $edb355c416917111$var$prefix;
$edb355c416917111$exports.iconName = $edb355c416917111$var$iconName;
$edb355c416917111$exports.width = $edb355c416917111$var$width;
$edb355c416917111$exports.height = $edb355c416917111$var$height;
$edb355c416917111$exports.ligatures = $edb355c416917111$var$aliases;
$edb355c416917111$exports.unicode = $edb355c416917111$var$unicode;
$edb355c416917111$exports.svgPathData = $edb355c416917111$var$svgPathData;
$edb355c416917111$exports.aliases = $edb355c416917111$var$aliases;


var $3a2bc56e455da4fe$exports = {};
'use strict';
Object.defineProperty($3a2bc56e455da4fe$exports, '__esModule', {
    value: true
});
var $95af186336132ee7$exports = {};
'use strict';
Object.defineProperty($95af186336132ee7$exports, '__esModule', {
    value: true
});
var $95af186336132ee7$var$prefix = 'fas';
var $95af186336132ee7$var$iconName = 'triangle-exclamation';
var $95af186336132ee7$var$width = 512;
var $95af186336132ee7$var$height = 512;
var $95af186336132ee7$var$aliases = [
    9888,
    "exclamation-triangle",
    "warning"
];
var $95af186336132ee7$var$unicode = 'f071';
var $95af186336132ee7$var$svgPathData = 'M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';
$95af186336132ee7$exports.definition = {
    prefix: $95af186336132ee7$var$prefix,
    iconName: $95af186336132ee7$var$iconName,
    icon: [
        $95af186336132ee7$var$width,
        $95af186336132ee7$var$height,
        $95af186336132ee7$var$aliases,
        $95af186336132ee7$var$unicode,
        $95af186336132ee7$var$svgPathData
    ]
};
$95af186336132ee7$exports.faTriangleExclamation = $95af186336132ee7$exports.definition;
$95af186336132ee7$exports.prefix = $95af186336132ee7$var$prefix;
$95af186336132ee7$exports.iconName = $95af186336132ee7$var$iconName;
$95af186336132ee7$exports.width = $95af186336132ee7$var$width;
$95af186336132ee7$exports.height = $95af186336132ee7$var$height;
$95af186336132ee7$exports.ligatures = $95af186336132ee7$var$aliases;
$95af186336132ee7$exports.unicode = $95af186336132ee7$var$unicode;
$95af186336132ee7$exports.svgPathData = $95af186336132ee7$var$svgPathData;
$95af186336132ee7$exports.aliases = $95af186336132ee7$var$aliases;


$3a2bc56e455da4fe$exports.definition = {
    prefix: $95af186336132ee7$exports.prefix,
    iconName: $95af186336132ee7$exports.iconName,
    icon: [
        $95af186336132ee7$exports.width,
        $95af186336132ee7$exports.height,
        $95af186336132ee7$exports.aliases,
        $95af186336132ee7$exports.unicode,
        $95af186336132ee7$exports.svgPathData
    ]
};
$3a2bc56e455da4fe$exports.faExclamationTriangle = $3a2bc56e455da4fe$exports.definition;
$3a2bc56e455da4fe$exports.prefix = $95af186336132ee7$exports.prefix;
$3a2bc56e455da4fe$exports.iconName = $95af186336132ee7$exports.iconName;
$3a2bc56e455da4fe$exports.width = $95af186336132ee7$exports.width;
$3a2bc56e455da4fe$exports.height = $95af186336132ee7$exports.height;
$3a2bc56e455da4fe$exports.ligatures = $95af186336132ee7$exports.aliases;
$3a2bc56e455da4fe$exports.unicode = $95af186336132ee7$exports.unicode;
$3a2bc56e455da4fe$exports.svgPathData = $95af186336132ee7$exports.svgPathData;
$3a2bc56e455da4fe$exports.aliases = $95af186336132ee7$exports.aliases;


var $60e51ca178edefdc$exports = {};
'use strict';
Object.defineProperty($60e51ca178edefdc$exports, '__esModule', {
    value: true
});
var $60e51ca178edefdc$var$prefix = 'fas';
var $60e51ca178edefdc$var$iconName = 'check';
var $60e51ca178edefdc$var$width = 448;
var $60e51ca178edefdc$var$height = 512;
var $60e51ca178edefdc$var$aliases = [
    10003,
    10004
];
var $60e51ca178edefdc$var$unicode = 'f00c';
var $60e51ca178edefdc$var$svgPathData = 'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z';
$60e51ca178edefdc$exports.definition = {
    prefix: $60e51ca178edefdc$var$prefix,
    iconName: $60e51ca178edefdc$var$iconName,
    icon: [
        $60e51ca178edefdc$var$width,
        $60e51ca178edefdc$var$height,
        $60e51ca178edefdc$var$aliases,
        $60e51ca178edefdc$var$unicode,
        $60e51ca178edefdc$var$svgPathData
    ]
};
$60e51ca178edefdc$exports.faCheck = $60e51ca178edefdc$exports.definition;
$60e51ca178edefdc$exports.prefix = $60e51ca178edefdc$var$prefix;
$60e51ca178edefdc$exports.iconName = $60e51ca178edefdc$var$iconName;
$60e51ca178edefdc$exports.width = $60e51ca178edefdc$var$width;
$60e51ca178edefdc$exports.height = $60e51ca178edefdc$var$height;
$60e51ca178edefdc$exports.ligatures = $60e51ca178edefdc$var$aliases;
$60e51ca178edefdc$exports.unicode = $60e51ca178edefdc$var$unicode;
$60e51ca178edefdc$exports.svgPathData = $60e51ca178edefdc$var$svgPathData;
$60e51ca178edefdc$exports.aliases = $60e51ca178edefdc$var$aliases;


var $6a570ce2b1ac1a0a$exports = {};
'use strict';
Object.defineProperty($6a570ce2b1ac1a0a$exports, '__esModule', {
    value: true
});
var $6a570ce2b1ac1a0a$var$prefix = 'fas';
var $6a570ce2b1ac1a0a$var$iconName = 'triangle';
var $6a570ce2b1ac1a0a$var$width = 512;
var $6a570ce2b1ac1a0a$var$height = 512;
var $6a570ce2b1ac1a0a$var$aliases = [
    9650
];
var $6a570ce2b1ac1a0a$var$unicode = 'f2ec';
var $6a570ce2b1ac1a0a$var$svgPathData = 'M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480l432 0c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z';
$6a570ce2b1ac1a0a$exports.definition = {
    prefix: $6a570ce2b1ac1a0a$var$prefix,
    iconName: $6a570ce2b1ac1a0a$var$iconName,
    icon: [
        $6a570ce2b1ac1a0a$var$width,
        $6a570ce2b1ac1a0a$var$height,
        $6a570ce2b1ac1a0a$var$aliases,
        $6a570ce2b1ac1a0a$var$unicode,
        $6a570ce2b1ac1a0a$var$svgPathData
    ]
};
$6a570ce2b1ac1a0a$exports.faTriangle = $6a570ce2b1ac1a0a$exports.definition;
$6a570ce2b1ac1a0a$exports.prefix = $6a570ce2b1ac1a0a$var$prefix;
$6a570ce2b1ac1a0a$exports.iconName = $6a570ce2b1ac1a0a$var$iconName;
$6a570ce2b1ac1a0a$exports.width = $6a570ce2b1ac1a0a$var$width;
$6a570ce2b1ac1a0a$exports.height = $6a570ce2b1ac1a0a$var$height;
$6a570ce2b1ac1a0a$exports.ligatures = $6a570ce2b1ac1a0a$var$aliases;
$6a570ce2b1ac1a0a$exports.unicode = $6a570ce2b1ac1a0a$var$unicode;
$6a570ce2b1ac1a0a$exports.svgPathData = $6a570ce2b1ac1a0a$var$svgPathData;
$6a570ce2b1ac1a0a$exports.aliases = $6a570ce2b1ac1a0a$var$aliases;


var $aedf8398cf1089ee$exports = {};
'use strict';
Object.defineProperty($aedf8398cf1089ee$exports, '__esModule', {
    value: true
});
var $aedf8398cf1089ee$var$prefix = 'fas';
var $aedf8398cf1089ee$var$iconName = 'square';
var $aedf8398cf1089ee$var$width = 448;
var $aedf8398cf1089ee$var$height = 512;
var $aedf8398cf1089ee$var$aliases = [
    9632,
    9723,
    9724,
    61590
];
var $aedf8398cf1089ee$var$unicode = 'f0c8';
var $aedf8398cf1089ee$var$svgPathData = 'M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z';
$aedf8398cf1089ee$exports.definition = {
    prefix: $aedf8398cf1089ee$var$prefix,
    iconName: $aedf8398cf1089ee$var$iconName,
    icon: [
        $aedf8398cf1089ee$var$width,
        $aedf8398cf1089ee$var$height,
        $aedf8398cf1089ee$var$aliases,
        $aedf8398cf1089ee$var$unicode,
        $aedf8398cf1089ee$var$svgPathData
    ]
};
$aedf8398cf1089ee$exports.faSquare = $aedf8398cf1089ee$exports.definition;
$aedf8398cf1089ee$exports.prefix = $aedf8398cf1089ee$var$prefix;
$aedf8398cf1089ee$exports.iconName = $aedf8398cf1089ee$var$iconName;
$aedf8398cf1089ee$exports.width = $aedf8398cf1089ee$var$width;
$aedf8398cf1089ee$exports.height = $aedf8398cf1089ee$var$height;
$aedf8398cf1089ee$exports.ligatures = $aedf8398cf1089ee$var$aliases;
$aedf8398cf1089ee$exports.unicode = $aedf8398cf1089ee$var$unicode;
$aedf8398cf1089ee$exports.svgPathData = $aedf8398cf1089ee$var$svgPathData;
$aedf8398cf1089ee$exports.aliases = $aedf8398cf1089ee$var$aliases;


var $9b0294e316990d10$exports = {};
'use strict';
Object.defineProperty($9b0294e316990d10$exports, '__esModule', {
    value: true
});
var $9b0294e316990d10$var$prefix = 'fas';
var $9b0294e316990d10$var$iconName = 'font';
var $9b0294e316990d10$var$width = 448;
var $9b0294e316990d10$var$height = 512;
var $9b0294e316990d10$var$aliases = [];
var $9b0294e316990d10$var$unicode = 'f031';
var $9b0294e316990d10$var$svgPathData = 'M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416 32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1.8 0 18-48 159.6 0 18 48-1.8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-25.8 0L254 52.8zM279.8 304l-111.6 0L224 155.1 279.8 304z';
$9b0294e316990d10$exports.definition = {
    prefix: $9b0294e316990d10$var$prefix,
    iconName: $9b0294e316990d10$var$iconName,
    icon: [
        $9b0294e316990d10$var$width,
        $9b0294e316990d10$var$height,
        $9b0294e316990d10$var$aliases,
        $9b0294e316990d10$var$unicode,
        $9b0294e316990d10$var$svgPathData
    ]
};
$9b0294e316990d10$exports.faFont = $9b0294e316990d10$exports.definition;
$9b0294e316990d10$exports.prefix = $9b0294e316990d10$var$prefix;
$9b0294e316990d10$exports.iconName = $9b0294e316990d10$var$iconName;
$9b0294e316990d10$exports.width = $9b0294e316990d10$var$width;
$9b0294e316990d10$exports.height = $9b0294e316990d10$var$height;
$9b0294e316990d10$exports.ligatures = $9b0294e316990d10$var$aliases;
$9b0294e316990d10$exports.unicode = $9b0294e316990d10$var$unicode;
$9b0294e316990d10$exports.svgPathData = $9b0294e316990d10$var$svgPathData;
$9b0294e316990d10$exports.aliases = $9b0294e316990d10$var$aliases;


var $f69362c36825a98f$exports = {};
'use strict';
Object.defineProperty($f69362c36825a98f$exports, '__esModule', {
    value: true
});
var $f69362c36825a98f$var$prefix = 'fas';
var $f69362c36825a98f$var$iconName = 'circle';
var $f69362c36825a98f$var$width = 512;
var $f69362c36825a98f$var$height = 512;
var $f69362c36825a98f$var$aliases = [
    128308,
    128309,
    128992,
    128993,
    128994,
    128995,
    128996,
    9679,
    9898,
    9899,
    11044,
    61708,
    61915
];
var $f69362c36825a98f$var$unicode = 'f111';
var $f69362c36825a98f$var$svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z';
$f69362c36825a98f$exports.definition = {
    prefix: $f69362c36825a98f$var$prefix,
    iconName: $f69362c36825a98f$var$iconName,
    icon: [
        $f69362c36825a98f$var$width,
        $f69362c36825a98f$var$height,
        $f69362c36825a98f$var$aliases,
        $f69362c36825a98f$var$unicode,
        $f69362c36825a98f$var$svgPathData
    ]
};
$f69362c36825a98f$exports.faCircle = $f69362c36825a98f$exports.definition;
$f69362c36825a98f$exports.prefix = $f69362c36825a98f$var$prefix;
$f69362c36825a98f$exports.iconName = $f69362c36825a98f$var$iconName;
$f69362c36825a98f$exports.width = $f69362c36825a98f$var$width;
$f69362c36825a98f$exports.height = $f69362c36825a98f$var$height;
$f69362c36825a98f$exports.ligatures = $f69362c36825a98f$var$aliases;
$f69362c36825a98f$exports.unicode = $f69362c36825a98f$var$unicode;
$f69362c36825a98f$exports.svgPathData = $f69362c36825a98f$var$svgPathData;
$f69362c36825a98f$exports.aliases = $f69362c36825a98f$var$aliases;


var $51fa0c8e62b7bd84$exports = {};
'use strict';
Object.defineProperty($51fa0c8e62b7bd84$exports, '__esModule', {
    value: true
});
var $51fa0c8e62b7bd84$var$prefix = 'fal';
var $51fa0c8e62b7bd84$var$iconName = 'angle-left';
var $51fa0c8e62b7bd84$var$width = 320;
var $51fa0c8e62b7bd84$var$height = 512;
var $51fa0c8e62b7bd84$var$aliases = [
    8249
];
var $51fa0c8e62b7bd84$var$unicode = 'f104';
var $51fa0c8e62b7bd84$var$svgPathData = 'M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256 235.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z';
$51fa0c8e62b7bd84$exports.definition = {
    prefix: $51fa0c8e62b7bd84$var$prefix,
    iconName: $51fa0c8e62b7bd84$var$iconName,
    icon: [
        $51fa0c8e62b7bd84$var$width,
        $51fa0c8e62b7bd84$var$height,
        $51fa0c8e62b7bd84$var$aliases,
        $51fa0c8e62b7bd84$var$unicode,
        $51fa0c8e62b7bd84$var$svgPathData
    ]
};
$51fa0c8e62b7bd84$exports.faAngleLeft = $51fa0c8e62b7bd84$exports.definition;
$51fa0c8e62b7bd84$exports.prefix = $51fa0c8e62b7bd84$var$prefix;
$51fa0c8e62b7bd84$exports.iconName = $51fa0c8e62b7bd84$var$iconName;
$51fa0c8e62b7bd84$exports.width = $51fa0c8e62b7bd84$var$width;
$51fa0c8e62b7bd84$exports.height = $51fa0c8e62b7bd84$var$height;
$51fa0c8e62b7bd84$exports.ligatures = $51fa0c8e62b7bd84$var$aliases;
$51fa0c8e62b7bd84$exports.unicode = $51fa0c8e62b7bd84$var$unicode;
$51fa0c8e62b7bd84$exports.svgPathData = $51fa0c8e62b7bd84$var$svgPathData;
$51fa0c8e62b7bd84$exports.aliases = $51fa0c8e62b7bd84$var$aliases;


var $90098deafd3a5ecf$exports = {};
'use strict';
Object.defineProperty($90098deafd3a5ecf$exports, '__esModule', {
    value: true
});
var $90098deafd3a5ecf$var$prefix = 'fal';
var $90098deafd3a5ecf$var$iconName = 'angle-right';
var $90098deafd3a5ecf$var$width = 320;
var $90098deafd3a5ecf$var$height = 512;
var $90098deafd3a5ecf$var$aliases = [
    8250
];
var $90098deafd3a5ecf$var$unicode = 'f105';
var $90098deafd3a5ecf$var$svgPathData = 'M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z';
$90098deafd3a5ecf$exports.definition = {
    prefix: $90098deafd3a5ecf$var$prefix,
    iconName: $90098deafd3a5ecf$var$iconName,
    icon: [
        $90098deafd3a5ecf$var$width,
        $90098deafd3a5ecf$var$height,
        $90098deafd3a5ecf$var$aliases,
        $90098deafd3a5ecf$var$unicode,
        $90098deafd3a5ecf$var$svgPathData
    ]
};
$90098deafd3a5ecf$exports.faAngleRight = $90098deafd3a5ecf$exports.definition;
$90098deafd3a5ecf$exports.prefix = $90098deafd3a5ecf$var$prefix;
$90098deafd3a5ecf$exports.iconName = $90098deafd3a5ecf$var$iconName;
$90098deafd3a5ecf$exports.width = $90098deafd3a5ecf$var$width;
$90098deafd3a5ecf$exports.height = $90098deafd3a5ecf$var$height;
$90098deafd3a5ecf$exports.ligatures = $90098deafd3a5ecf$var$aliases;
$90098deafd3a5ecf$exports.unicode = $90098deafd3a5ecf$var$unicode;
$90098deafd3a5ecf$exports.svgPathData = $90098deafd3a5ecf$var$svgPathData;
$90098deafd3a5ecf$exports.aliases = $90098deafd3a5ecf$var$aliases;


var $99f81b005a3776d9$exports = {};
'use strict';
Object.defineProperty($99f81b005a3776d9$exports, '__esModule', {
    value: true
});
var $99f81b005a3776d9$var$prefix = 'fal';
var $99f81b005a3776d9$var$iconName = 'angle-up';
var $99f81b005a3776d9$var$width = 448;
var $99f81b005a3776d9$var$height = 512;
var $99f81b005a3776d9$var$aliases = [
    8963
];
var $99f81b005a3776d9$var$unicode = 'f106';
var $99f81b005a3776d9$var$svgPathData = 'M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z';
$99f81b005a3776d9$exports.definition = {
    prefix: $99f81b005a3776d9$var$prefix,
    iconName: $99f81b005a3776d9$var$iconName,
    icon: [
        $99f81b005a3776d9$var$width,
        $99f81b005a3776d9$var$height,
        $99f81b005a3776d9$var$aliases,
        $99f81b005a3776d9$var$unicode,
        $99f81b005a3776d9$var$svgPathData
    ]
};
$99f81b005a3776d9$exports.faAngleUp = $99f81b005a3776d9$exports.definition;
$99f81b005a3776d9$exports.prefix = $99f81b005a3776d9$var$prefix;
$99f81b005a3776d9$exports.iconName = $99f81b005a3776d9$var$iconName;
$99f81b005a3776d9$exports.width = $99f81b005a3776d9$var$width;
$99f81b005a3776d9$exports.height = $99f81b005a3776d9$var$height;
$99f81b005a3776d9$exports.ligatures = $99f81b005a3776d9$var$aliases;
$99f81b005a3776d9$exports.unicode = $99f81b005a3776d9$var$unicode;
$99f81b005a3776d9$exports.svgPathData = $99f81b005a3776d9$var$svgPathData;
$99f81b005a3776d9$exports.aliases = $99f81b005a3776d9$var$aliases;


var $a26bb9e40d43ef12$exports = {};
'use strict';
Object.defineProperty($a26bb9e40d43ef12$exports, '__esModule', {
    value: true
});
var $a26bb9e40d43ef12$var$prefix = 'fal';
var $a26bb9e40d43ef12$var$iconName = 'angle-down';
var $a26bb9e40d43ef12$var$width = 448;
var $a26bb9e40d43ef12$var$height = 512;
var $a26bb9e40d43ef12$var$aliases = [
    8964
];
var $a26bb9e40d43ef12$var$unicode = 'f107';
var $a26bb9e40d43ef12$var$svgPathData = 'M212.7 363.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 329.4 75.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z';
$a26bb9e40d43ef12$exports.definition = {
    prefix: $a26bb9e40d43ef12$var$prefix,
    iconName: $a26bb9e40d43ef12$var$iconName,
    icon: [
        $a26bb9e40d43ef12$var$width,
        $a26bb9e40d43ef12$var$height,
        $a26bb9e40d43ef12$var$aliases,
        $a26bb9e40d43ef12$var$unicode,
        $a26bb9e40d43ef12$var$svgPathData
    ]
};
$a26bb9e40d43ef12$exports.faAngleDown = $a26bb9e40d43ef12$exports.definition;
$a26bb9e40d43ef12$exports.prefix = $a26bb9e40d43ef12$var$prefix;
$a26bb9e40d43ef12$exports.iconName = $a26bb9e40d43ef12$var$iconName;
$a26bb9e40d43ef12$exports.width = $a26bb9e40d43ef12$var$width;
$a26bb9e40d43ef12$exports.height = $a26bb9e40d43ef12$var$height;
$a26bb9e40d43ef12$exports.ligatures = $a26bb9e40d43ef12$var$aliases;
$a26bb9e40d43ef12$exports.unicode = $a26bb9e40d43ef12$var$unicode;
$a26bb9e40d43ef12$exports.svgPathData = $a26bb9e40d43ef12$var$svgPathData;
$a26bb9e40d43ef12$exports.aliases = $a26bb9e40d43ef12$var$aliases;


var $9d1000b76ec5ac40$exports = {};
'use strict';
Object.defineProperty($9d1000b76ec5ac40$exports, '__esModule', {
    value: true
});
var $42379b7c30e2da59$exports = {};
'use strict';
Object.defineProperty($42379b7c30e2da59$exports, '__esModule', {
    value: true
});
var $42379b7c30e2da59$var$prefix = 'fal';
var $42379b7c30e2da59$var$iconName = 'xmark';
var $42379b7c30e2da59$var$width = 384;
var $42379b7c30e2da59$var$height = 512;
var $42379b7c30e2da59$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $42379b7c30e2da59$var$unicode = 'f00d';
var $42379b7c30e2da59$var$svgPathData = 'M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.6 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z';
$42379b7c30e2da59$exports.definition = {
    prefix: $42379b7c30e2da59$var$prefix,
    iconName: $42379b7c30e2da59$var$iconName,
    icon: [
        $42379b7c30e2da59$var$width,
        $42379b7c30e2da59$var$height,
        $42379b7c30e2da59$var$aliases,
        $42379b7c30e2da59$var$unicode,
        $42379b7c30e2da59$var$svgPathData
    ]
};
$42379b7c30e2da59$exports.faXmark = $42379b7c30e2da59$exports.definition;
$42379b7c30e2da59$exports.prefix = $42379b7c30e2da59$var$prefix;
$42379b7c30e2da59$exports.iconName = $42379b7c30e2da59$var$iconName;
$42379b7c30e2da59$exports.width = $42379b7c30e2da59$var$width;
$42379b7c30e2da59$exports.height = $42379b7c30e2da59$var$height;
$42379b7c30e2da59$exports.ligatures = $42379b7c30e2da59$var$aliases;
$42379b7c30e2da59$exports.unicode = $42379b7c30e2da59$var$unicode;
$42379b7c30e2da59$exports.svgPathData = $42379b7c30e2da59$var$svgPathData;
$42379b7c30e2da59$exports.aliases = $42379b7c30e2da59$var$aliases;


$9d1000b76ec5ac40$exports.definition = {
    prefix: $42379b7c30e2da59$exports.prefix,
    iconName: $42379b7c30e2da59$exports.iconName,
    icon: [
        $42379b7c30e2da59$exports.width,
        $42379b7c30e2da59$exports.height,
        $42379b7c30e2da59$exports.aliases,
        $42379b7c30e2da59$exports.unicode,
        $42379b7c30e2da59$exports.svgPathData
    ]
};
$9d1000b76ec5ac40$exports.faTimes = $9d1000b76ec5ac40$exports.definition;
$9d1000b76ec5ac40$exports.prefix = $42379b7c30e2da59$exports.prefix;
$9d1000b76ec5ac40$exports.iconName = $42379b7c30e2da59$exports.iconName;
$9d1000b76ec5ac40$exports.width = $42379b7c30e2da59$exports.width;
$9d1000b76ec5ac40$exports.height = $42379b7c30e2da59$exports.height;
$9d1000b76ec5ac40$exports.ligatures = $42379b7c30e2da59$exports.aliases;
$9d1000b76ec5ac40$exports.unicode = $42379b7c30e2da59$exports.unicode;
$9d1000b76ec5ac40$exports.svgPathData = $42379b7c30e2da59$exports.svgPathData;
$9d1000b76ec5ac40$exports.aliases = $42379b7c30e2da59$exports.aliases;


var $a57135b183b842de$exports = {};
'use strict';
Object.defineProperty($a57135b183b842de$exports, '__esModule', {
    value: true
});
var $a57135b183b842de$var$prefix = 'fal';
var $a57135b183b842de$var$iconName = 'globe';
var $a57135b183b842de$var$width = 512;
var $a57135b183b842de$var$height = 512;
var $a57135b183b842de$var$aliases = [
    127760
];
var $a57135b183b842de$var$unicode = 'f0ac';
var $a57135b183b842de$var$svgPathData = 'M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7l-172 0c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320l183.4 0c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64l-183.4 0c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160l172 0c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64l90.8 0c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64L380 192zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3l83.8 0zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160l83.7 0zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64l90.8 0c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64l-90.8 0zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3l-83.8 0c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3l-83.7 0c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z';
$a57135b183b842de$exports.definition = {
    prefix: $a57135b183b842de$var$prefix,
    iconName: $a57135b183b842de$var$iconName,
    icon: [
        $a57135b183b842de$var$width,
        $a57135b183b842de$var$height,
        $a57135b183b842de$var$aliases,
        $a57135b183b842de$var$unicode,
        $a57135b183b842de$var$svgPathData
    ]
};
$a57135b183b842de$exports.faGlobe = $a57135b183b842de$exports.definition;
$a57135b183b842de$exports.prefix = $a57135b183b842de$var$prefix;
$a57135b183b842de$exports.iconName = $a57135b183b842de$var$iconName;
$a57135b183b842de$exports.width = $a57135b183b842de$var$width;
$a57135b183b842de$exports.height = $a57135b183b842de$var$height;
$a57135b183b842de$exports.ligatures = $a57135b183b842de$var$aliases;
$a57135b183b842de$exports.unicode = $a57135b183b842de$var$unicode;
$a57135b183b842de$exports.svgPathData = $a57135b183b842de$var$svgPathData;
$a57135b183b842de$exports.aliases = $a57135b183b842de$var$aliases;


var $8b2b3ed703859157$exports = {};
'use strict';
Object.defineProperty($8b2b3ed703859157$exports, '__esModule', {
    value: true
});
var $ad688dcf2d62fdcc$exports = {};
'use strict';
Object.defineProperty($ad688dcf2d62fdcc$exports, '__esModule', {
    value: true
});
var $ad688dcf2d62fdcc$var$prefix = 'fal';
var $ad688dcf2d62fdcc$var$iconName = 'location-dot';
var $ad688dcf2d62fdcc$var$width = 384;
var $ad688dcf2d62fdcc$var$height = 512;
var $ad688dcf2d62fdcc$var$aliases = [
    "map-marker-alt"
];
var $ad688dcf2d62fdcc$var$unicode = 'f3c5';
var $ad688dcf2d62fdcc$var$svgPathData = 'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z';
$ad688dcf2d62fdcc$exports.definition = {
    prefix: $ad688dcf2d62fdcc$var$prefix,
    iconName: $ad688dcf2d62fdcc$var$iconName,
    icon: [
        $ad688dcf2d62fdcc$var$width,
        $ad688dcf2d62fdcc$var$height,
        $ad688dcf2d62fdcc$var$aliases,
        $ad688dcf2d62fdcc$var$unicode,
        $ad688dcf2d62fdcc$var$svgPathData
    ]
};
$ad688dcf2d62fdcc$exports.faLocationDot = $ad688dcf2d62fdcc$exports.definition;
$ad688dcf2d62fdcc$exports.prefix = $ad688dcf2d62fdcc$var$prefix;
$ad688dcf2d62fdcc$exports.iconName = $ad688dcf2d62fdcc$var$iconName;
$ad688dcf2d62fdcc$exports.width = $ad688dcf2d62fdcc$var$width;
$ad688dcf2d62fdcc$exports.height = $ad688dcf2d62fdcc$var$height;
$ad688dcf2d62fdcc$exports.ligatures = $ad688dcf2d62fdcc$var$aliases;
$ad688dcf2d62fdcc$exports.unicode = $ad688dcf2d62fdcc$var$unicode;
$ad688dcf2d62fdcc$exports.svgPathData = $ad688dcf2d62fdcc$var$svgPathData;
$ad688dcf2d62fdcc$exports.aliases = $ad688dcf2d62fdcc$var$aliases;


$8b2b3ed703859157$exports.definition = {
    prefix: $ad688dcf2d62fdcc$exports.prefix,
    iconName: $ad688dcf2d62fdcc$exports.iconName,
    icon: [
        $ad688dcf2d62fdcc$exports.width,
        $ad688dcf2d62fdcc$exports.height,
        $ad688dcf2d62fdcc$exports.aliases,
        $ad688dcf2d62fdcc$exports.unicode,
        $ad688dcf2d62fdcc$exports.svgPathData
    ]
};
$8b2b3ed703859157$exports.faMapMarkerAlt = $8b2b3ed703859157$exports.definition;
$8b2b3ed703859157$exports.prefix = $ad688dcf2d62fdcc$exports.prefix;
$8b2b3ed703859157$exports.iconName = $ad688dcf2d62fdcc$exports.iconName;
$8b2b3ed703859157$exports.width = $ad688dcf2d62fdcc$exports.width;
$8b2b3ed703859157$exports.height = $ad688dcf2d62fdcc$exports.height;
$8b2b3ed703859157$exports.ligatures = $ad688dcf2d62fdcc$exports.aliases;
$8b2b3ed703859157$exports.unicode = $ad688dcf2d62fdcc$exports.unicode;
$8b2b3ed703859157$exports.svgPathData = $ad688dcf2d62fdcc$exports.svgPathData;
$8b2b3ed703859157$exports.aliases = $ad688dcf2d62fdcc$exports.aliases;


var $44acc92247d79ba3$exports = {};
'use strict';
Object.defineProperty($44acc92247d79ba3$exports, '__esModule', {
    value: true
});
var $44acc92247d79ba3$var$prefix = 'fal';
var $44acc92247d79ba3$var$iconName = 'download';
var $44acc92247d79ba3$var$width = 512;
var $44acc92247d79ba3$var$height = 512;
var $44acc92247d79ba3$var$aliases = [];
var $44acc92247d79ba3$var$unicode = 'f019';
var $44acc92247d79ba3$var$svgPathData = 'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 313.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4 272 16zM140.1 320L64 320c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-76.1 0-32 32L448 352c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l108.1 0-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z';
$44acc92247d79ba3$exports.definition = {
    prefix: $44acc92247d79ba3$var$prefix,
    iconName: $44acc92247d79ba3$var$iconName,
    icon: [
        $44acc92247d79ba3$var$width,
        $44acc92247d79ba3$var$height,
        $44acc92247d79ba3$var$aliases,
        $44acc92247d79ba3$var$unicode,
        $44acc92247d79ba3$var$svgPathData
    ]
};
$44acc92247d79ba3$exports.faDownload = $44acc92247d79ba3$exports.definition;
$44acc92247d79ba3$exports.prefix = $44acc92247d79ba3$var$prefix;
$44acc92247d79ba3$exports.iconName = $44acc92247d79ba3$var$iconName;
$44acc92247d79ba3$exports.width = $44acc92247d79ba3$var$width;
$44acc92247d79ba3$exports.height = $44acc92247d79ba3$var$height;
$44acc92247d79ba3$exports.ligatures = $44acc92247d79ba3$var$aliases;
$44acc92247d79ba3$exports.unicode = $44acc92247d79ba3$var$unicode;
$44acc92247d79ba3$exports.svgPathData = $44acc92247d79ba3$var$svgPathData;
$44acc92247d79ba3$exports.aliases = $44acc92247d79ba3$var$aliases;


var $57480e4e181595f3$exports = {};
'use strict';
Object.defineProperty($57480e4e181595f3$exports, '__esModule', {
    value: true
});
var $57480e4e181595f3$var$prefix = 'fal';
var $57480e4e181595f3$var$iconName = 'envelope';
var $57480e4e181595f3$var$width = 512;
var $57480e4e181595f3$var$height = 512;
var $57480e4e181595f3$var$aliases = [
    128386,
    9993,
    61443
];
var $57480e4e181595f3$var$unicode = 'f0e0';
var $57480e4e181595f3$var$svgPathData = 'M64 96c-17.7 0-32 14.3-32 32l0 39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9l0-39.9c0-17.7-14.3-32-32-32L64 96zM32 207.6L32 384c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-176.4L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z';
$57480e4e181595f3$exports.definition = {
    prefix: $57480e4e181595f3$var$prefix,
    iconName: $57480e4e181595f3$var$iconName,
    icon: [
        $57480e4e181595f3$var$width,
        $57480e4e181595f3$var$height,
        $57480e4e181595f3$var$aliases,
        $57480e4e181595f3$var$unicode,
        $57480e4e181595f3$var$svgPathData
    ]
};
$57480e4e181595f3$exports.faEnvelope = $57480e4e181595f3$exports.definition;
$57480e4e181595f3$exports.prefix = $57480e4e181595f3$var$prefix;
$57480e4e181595f3$exports.iconName = $57480e4e181595f3$var$iconName;
$57480e4e181595f3$exports.width = $57480e4e181595f3$var$width;
$57480e4e181595f3$exports.height = $57480e4e181595f3$var$height;
$57480e4e181595f3$exports.ligatures = $57480e4e181595f3$var$aliases;
$57480e4e181595f3$exports.unicode = $57480e4e181595f3$var$unicode;
$57480e4e181595f3$exports.svgPathData = $57480e4e181595f3$var$svgPathData;
$57480e4e181595f3$exports.aliases = $57480e4e181595f3$var$aliases;


var $72f6f96f0a4eb0ba$exports = {};
'use strict';
Object.defineProperty($72f6f96f0a4eb0ba$exports, '__esModule', {
    value: true
});
var $72f6f96f0a4eb0ba$var$prefix = 'fal';
var $72f6f96f0a4eb0ba$var$iconName = 'phone';
var $72f6f96f0a4eb0ba$var$width = 512;
var $72f6f96f0a4eb0ba$var$height = 512;
var $72f6f96f0a4eb0ba$var$aliases = [
    128222,
    128379
];
var $72f6f96f0a4eb0ba$var$unicode = 'f095';
var $72f6f96f0a4eb0ba$var$svgPathData = 'M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z';
$72f6f96f0a4eb0ba$exports.definition = {
    prefix: $72f6f96f0a4eb0ba$var$prefix,
    iconName: $72f6f96f0a4eb0ba$var$iconName,
    icon: [
        $72f6f96f0a4eb0ba$var$width,
        $72f6f96f0a4eb0ba$var$height,
        $72f6f96f0a4eb0ba$var$aliases,
        $72f6f96f0a4eb0ba$var$unicode,
        $72f6f96f0a4eb0ba$var$svgPathData
    ]
};
$72f6f96f0a4eb0ba$exports.faPhone = $72f6f96f0a4eb0ba$exports.definition;
$72f6f96f0a4eb0ba$exports.prefix = $72f6f96f0a4eb0ba$var$prefix;
$72f6f96f0a4eb0ba$exports.iconName = $72f6f96f0a4eb0ba$var$iconName;
$72f6f96f0a4eb0ba$exports.width = $72f6f96f0a4eb0ba$var$width;
$72f6f96f0a4eb0ba$exports.height = $72f6f96f0a4eb0ba$var$height;
$72f6f96f0a4eb0ba$exports.ligatures = $72f6f96f0a4eb0ba$var$aliases;
$72f6f96f0a4eb0ba$exports.unicode = $72f6f96f0a4eb0ba$var$unicode;
$72f6f96f0a4eb0ba$exports.svgPathData = $72f6f96f0a4eb0ba$var$svgPathData;
$72f6f96f0a4eb0ba$exports.aliases = $72f6f96f0a4eb0ba$var$aliases;


var $508795d014ac1555$exports = {};
'use strict';
Object.defineProperty($508795d014ac1555$exports, '__esModule', {
    value: true
});
var $261bebfb68771e82$exports = {};
'use strict';
Object.defineProperty($261bebfb68771e82$exports, '__esModule', {
    value: true
});
var $261bebfb68771e82$var$prefix = 'fal';
var $261bebfb68771e82$var$iconName = 'arrow-up-right-from-square';
var $261bebfb68771e82$var$width = 512;
var $261bebfb68771e82$var$height = 512;
var $261bebfb68771e82$var$aliases = [
    "external-link"
];
var $261bebfb68771e82$var$unicode = 'f08e';
var $261bebfb68771e82$var$svgPathData = 'M336 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l121.4 0L212.7 276.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6 480 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L336 0zM64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32z';
$261bebfb68771e82$exports.definition = {
    prefix: $261bebfb68771e82$var$prefix,
    iconName: $261bebfb68771e82$var$iconName,
    icon: [
        $261bebfb68771e82$var$width,
        $261bebfb68771e82$var$height,
        $261bebfb68771e82$var$aliases,
        $261bebfb68771e82$var$unicode,
        $261bebfb68771e82$var$svgPathData
    ]
};
$261bebfb68771e82$exports.faArrowUpRightFromSquare = $261bebfb68771e82$exports.definition;
$261bebfb68771e82$exports.prefix = $261bebfb68771e82$var$prefix;
$261bebfb68771e82$exports.iconName = $261bebfb68771e82$var$iconName;
$261bebfb68771e82$exports.width = $261bebfb68771e82$var$width;
$261bebfb68771e82$exports.height = $261bebfb68771e82$var$height;
$261bebfb68771e82$exports.ligatures = $261bebfb68771e82$var$aliases;
$261bebfb68771e82$exports.unicode = $261bebfb68771e82$var$unicode;
$261bebfb68771e82$exports.svgPathData = $261bebfb68771e82$var$svgPathData;
$261bebfb68771e82$exports.aliases = $261bebfb68771e82$var$aliases;


$508795d014ac1555$exports.definition = {
    prefix: $261bebfb68771e82$exports.prefix,
    iconName: $261bebfb68771e82$exports.iconName,
    icon: [
        $261bebfb68771e82$exports.width,
        $261bebfb68771e82$exports.height,
        $261bebfb68771e82$exports.aliases,
        $261bebfb68771e82$exports.unicode,
        $261bebfb68771e82$exports.svgPathData
    ]
};
$508795d014ac1555$exports.faExternalLink = $508795d014ac1555$exports.definition;
$508795d014ac1555$exports.prefix = $261bebfb68771e82$exports.prefix;
$508795d014ac1555$exports.iconName = $261bebfb68771e82$exports.iconName;
$508795d014ac1555$exports.width = $261bebfb68771e82$exports.width;
$508795d014ac1555$exports.height = $261bebfb68771e82$exports.height;
$508795d014ac1555$exports.ligatures = $261bebfb68771e82$exports.aliases;
$508795d014ac1555$exports.unicode = $261bebfb68771e82$exports.unicode;
$508795d014ac1555$exports.svgPathData = $261bebfb68771e82$exports.svgPathData;
$508795d014ac1555$exports.aliases = $261bebfb68771e82$exports.aliases;


var $257742f4a8891061$exports = {};
'use strict';
Object.defineProperty($257742f4a8891061$exports, '__esModule', {
    value: true
});
var $979aa6ef0706c0a4$exports = {};
'use strict';
Object.defineProperty($979aa6ef0706c0a4$exports, '__esModule', {
    value: true
});
var $979aa6ef0706c0a4$var$prefix = 'fal';
var $979aa6ef0706c0a4$var$iconName = 'circle-info';
var $979aa6ef0706c0a4$var$width = 512;
var $979aa6ef0706c0a4$var$height = 512;
var $979aa6ef0706c0a4$var$aliases = [
    "info-circle"
];
var $979aa6ef0706c0a4$var$unicode = 'f05a';
var $979aa6ef0706c0a4$var$svgPathData = 'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-112c0-8.8-7.2-16-16-16l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 96-32 0zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';
$979aa6ef0706c0a4$exports.definition = {
    prefix: $979aa6ef0706c0a4$var$prefix,
    iconName: $979aa6ef0706c0a4$var$iconName,
    icon: [
        $979aa6ef0706c0a4$var$width,
        $979aa6ef0706c0a4$var$height,
        $979aa6ef0706c0a4$var$aliases,
        $979aa6ef0706c0a4$var$unicode,
        $979aa6ef0706c0a4$var$svgPathData
    ]
};
$979aa6ef0706c0a4$exports.faCircleInfo = $979aa6ef0706c0a4$exports.definition;
$979aa6ef0706c0a4$exports.prefix = $979aa6ef0706c0a4$var$prefix;
$979aa6ef0706c0a4$exports.iconName = $979aa6ef0706c0a4$var$iconName;
$979aa6ef0706c0a4$exports.width = $979aa6ef0706c0a4$var$width;
$979aa6ef0706c0a4$exports.height = $979aa6ef0706c0a4$var$height;
$979aa6ef0706c0a4$exports.ligatures = $979aa6ef0706c0a4$var$aliases;
$979aa6ef0706c0a4$exports.unicode = $979aa6ef0706c0a4$var$unicode;
$979aa6ef0706c0a4$exports.svgPathData = $979aa6ef0706c0a4$var$svgPathData;
$979aa6ef0706c0a4$exports.aliases = $979aa6ef0706c0a4$var$aliases;


$257742f4a8891061$exports.definition = {
    prefix: $979aa6ef0706c0a4$exports.prefix,
    iconName: $979aa6ef0706c0a4$exports.iconName,
    icon: [
        $979aa6ef0706c0a4$exports.width,
        $979aa6ef0706c0a4$exports.height,
        $979aa6ef0706c0a4$exports.aliases,
        $979aa6ef0706c0a4$exports.unicode,
        $979aa6ef0706c0a4$exports.svgPathData
    ]
};
$257742f4a8891061$exports.faInfoCircle = $257742f4a8891061$exports.definition;
$257742f4a8891061$exports.prefix = $979aa6ef0706c0a4$exports.prefix;
$257742f4a8891061$exports.iconName = $979aa6ef0706c0a4$exports.iconName;
$257742f4a8891061$exports.width = $979aa6ef0706c0a4$exports.width;
$257742f4a8891061$exports.height = $979aa6ef0706c0a4$exports.height;
$257742f4a8891061$exports.ligatures = $979aa6ef0706c0a4$exports.aliases;
$257742f4a8891061$exports.unicode = $979aa6ef0706c0a4$exports.unicode;
$257742f4a8891061$exports.svgPathData = $979aa6ef0706c0a4$exports.svgPathData;
$257742f4a8891061$exports.aliases = $979aa6ef0706c0a4$exports.aliases;


var $137a0f42acd21719$exports = {};
'use strict';
Object.defineProperty($137a0f42acd21719$exports, '__esModule', {
    value: true
});
var $2594ce33520d0ffb$exports = {};
'use strict';
Object.defineProperty($2594ce33520d0ffb$exports, '__esModule', {
    value: true
});
var $2594ce33520d0ffb$var$prefix = 'fal';
var $2594ce33520d0ffb$var$iconName = 'file-lines';
var $2594ce33520d0ffb$var$width = 384;
var $2594ce33520d0ffb$var$height = 512;
var $2594ce33520d0ffb$var$aliases = [
    128441,
    128462,
    61686,
    "file-alt",
    "file-text"
];
var $2594ce33520d0ffb$var$unicode = 'f15c';
var $2594ce33520d0ffb$var$svgPathData = 'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z';
$2594ce33520d0ffb$exports.definition = {
    prefix: $2594ce33520d0ffb$var$prefix,
    iconName: $2594ce33520d0ffb$var$iconName,
    icon: [
        $2594ce33520d0ffb$var$width,
        $2594ce33520d0ffb$var$height,
        $2594ce33520d0ffb$var$aliases,
        $2594ce33520d0ffb$var$unicode,
        $2594ce33520d0ffb$var$svgPathData
    ]
};
$2594ce33520d0ffb$exports.faFileLines = $2594ce33520d0ffb$exports.definition;
$2594ce33520d0ffb$exports.prefix = $2594ce33520d0ffb$var$prefix;
$2594ce33520d0ffb$exports.iconName = $2594ce33520d0ffb$var$iconName;
$2594ce33520d0ffb$exports.width = $2594ce33520d0ffb$var$width;
$2594ce33520d0ffb$exports.height = $2594ce33520d0ffb$var$height;
$2594ce33520d0ffb$exports.ligatures = $2594ce33520d0ffb$var$aliases;
$2594ce33520d0ffb$exports.unicode = $2594ce33520d0ffb$var$unicode;
$2594ce33520d0ffb$exports.svgPathData = $2594ce33520d0ffb$var$svgPathData;
$2594ce33520d0ffb$exports.aliases = $2594ce33520d0ffb$var$aliases;


$137a0f42acd21719$exports.definition = {
    prefix: $2594ce33520d0ffb$exports.prefix,
    iconName: $2594ce33520d0ffb$exports.iconName,
    icon: [
        $2594ce33520d0ffb$exports.width,
        $2594ce33520d0ffb$exports.height,
        $2594ce33520d0ffb$exports.aliases,
        $2594ce33520d0ffb$exports.unicode,
        $2594ce33520d0ffb$exports.svgPathData
    ]
};
$137a0f42acd21719$exports.faFileAlt = $137a0f42acd21719$exports.definition;
$137a0f42acd21719$exports.prefix = $2594ce33520d0ffb$exports.prefix;
$137a0f42acd21719$exports.iconName = $2594ce33520d0ffb$exports.iconName;
$137a0f42acd21719$exports.width = $2594ce33520d0ffb$exports.width;
$137a0f42acd21719$exports.height = $2594ce33520d0ffb$exports.height;
$137a0f42acd21719$exports.ligatures = $2594ce33520d0ffb$exports.aliases;
$137a0f42acd21719$exports.unicode = $2594ce33520d0ffb$exports.unicode;
$137a0f42acd21719$exports.svgPathData = $2594ce33520d0ffb$exports.svgPathData;
$137a0f42acd21719$exports.aliases = $2594ce33520d0ffb$exports.aliases;


var $2abdd8614c9084f8$exports = {};
'use strict';
Object.defineProperty($2abdd8614c9084f8$exports, '__esModule', {
    value: true
});
var $2abdd8614c9084f8$var$prefix = 'fal';
var $2abdd8614c9084f8$var$iconName = 'file-pdf';
var $2abdd8614c9084f8$var$width = 512;
var $2abdd8614c9084f8$var$height = 512;
var $2abdd8614c9084f8$var$aliases = [];
var $2abdd8614c9084f8$var$unicode = 'f1c1';
var $2abdd8614c9084f8$var$svgPathData = 'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z';
$2abdd8614c9084f8$exports.definition = {
    prefix: $2abdd8614c9084f8$var$prefix,
    iconName: $2abdd8614c9084f8$var$iconName,
    icon: [
        $2abdd8614c9084f8$var$width,
        $2abdd8614c9084f8$var$height,
        $2abdd8614c9084f8$var$aliases,
        $2abdd8614c9084f8$var$unicode,
        $2abdd8614c9084f8$var$svgPathData
    ]
};
$2abdd8614c9084f8$exports.faFilePdf = $2abdd8614c9084f8$exports.definition;
$2abdd8614c9084f8$exports.prefix = $2abdd8614c9084f8$var$prefix;
$2abdd8614c9084f8$exports.iconName = $2abdd8614c9084f8$var$iconName;
$2abdd8614c9084f8$exports.width = $2abdd8614c9084f8$var$width;
$2abdd8614c9084f8$exports.height = $2abdd8614c9084f8$var$height;
$2abdd8614c9084f8$exports.ligatures = $2abdd8614c9084f8$var$aliases;
$2abdd8614c9084f8$exports.unicode = $2abdd8614c9084f8$var$unicode;
$2abdd8614c9084f8$exports.svgPathData = $2abdd8614c9084f8$var$svgPathData;
$2abdd8614c9084f8$exports.aliases = $2abdd8614c9084f8$var$aliases;


var $dbe9b20997b54e98$exports = {};
'use strict';
Object.defineProperty($dbe9b20997b54e98$exports, '__esModule', {
    value: true
});
var $f52097544e6a427e$exports = {};
'use strict';
Object.defineProperty($f52097544e6a427e$exports, '__esModule', {
    value: true
});
var $f52097544e6a427e$var$prefix = 'fal';
var $f52097544e6a427e$var$iconName = 'circle-check';
var $f52097544e6a427e$var$width = 512;
var $f52097544e6a427e$var$height = 512;
var $f52097544e6a427e$var$aliases = [
    61533,
    "check-circle"
];
var $f52097544e6a427e$var$unicode = 'f058';
var $f52097544e6a427e$var$svgPathData = 'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z';
$f52097544e6a427e$exports.definition = {
    prefix: $f52097544e6a427e$var$prefix,
    iconName: $f52097544e6a427e$var$iconName,
    icon: [
        $f52097544e6a427e$var$width,
        $f52097544e6a427e$var$height,
        $f52097544e6a427e$var$aliases,
        $f52097544e6a427e$var$unicode,
        $f52097544e6a427e$var$svgPathData
    ]
};
$f52097544e6a427e$exports.faCircleCheck = $f52097544e6a427e$exports.definition;
$f52097544e6a427e$exports.prefix = $f52097544e6a427e$var$prefix;
$f52097544e6a427e$exports.iconName = $f52097544e6a427e$var$iconName;
$f52097544e6a427e$exports.width = $f52097544e6a427e$var$width;
$f52097544e6a427e$exports.height = $f52097544e6a427e$var$height;
$f52097544e6a427e$exports.ligatures = $f52097544e6a427e$var$aliases;
$f52097544e6a427e$exports.unicode = $f52097544e6a427e$var$unicode;
$f52097544e6a427e$exports.svgPathData = $f52097544e6a427e$var$svgPathData;
$f52097544e6a427e$exports.aliases = $f52097544e6a427e$var$aliases;


$dbe9b20997b54e98$exports.definition = {
    prefix: $f52097544e6a427e$exports.prefix,
    iconName: $f52097544e6a427e$exports.iconName,
    icon: [
        $f52097544e6a427e$exports.width,
        $f52097544e6a427e$exports.height,
        $f52097544e6a427e$exports.aliases,
        $f52097544e6a427e$exports.unicode,
        $f52097544e6a427e$exports.svgPathData
    ]
};
$dbe9b20997b54e98$exports.faCheckCircle = $dbe9b20997b54e98$exports.definition;
$dbe9b20997b54e98$exports.prefix = $f52097544e6a427e$exports.prefix;
$dbe9b20997b54e98$exports.iconName = $f52097544e6a427e$exports.iconName;
$dbe9b20997b54e98$exports.width = $f52097544e6a427e$exports.width;
$dbe9b20997b54e98$exports.height = $f52097544e6a427e$exports.height;
$dbe9b20997b54e98$exports.ligatures = $f52097544e6a427e$exports.aliases;
$dbe9b20997b54e98$exports.unicode = $f52097544e6a427e$exports.unicode;
$dbe9b20997b54e98$exports.svgPathData = $f52097544e6a427e$exports.svgPathData;
$dbe9b20997b54e98$exports.aliases = $f52097544e6a427e$exports.aliases;


var $e0766fee15389c84$exports = {};
'use strict';
Object.defineProperty($e0766fee15389c84$exports, '__esModule', {
    value: true
});
var $e63d7fcf04425ba1$exports = {};
'use strict';
Object.defineProperty($e63d7fcf04425ba1$exports, '__esModule', {
    value: true
});
var $e63d7fcf04425ba1$var$prefix = 'fal';
var $e63d7fcf04425ba1$var$iconName = 'house';
var $e63d7fcf04425ba1$var$width = 576;
var $e63d7fcf04425ba1$var$height = 512;
var $e63d7fcf04425ba1$var$aliases = [
    127968,
    63498,
    63500,
    "home",
    "home-alt",
    "home-lg-alt"
];
var $e63d7fcf04425ba1$var$unicode = 'f015';
var $e63d7fcf04425ba1$var$svgPathData = 'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-64 0 0-160c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 160-64 0c-26.5 0-48-21.5-48-48zm144 48l0-160 96 0 0 160-96 0z';
$e63d7fcf04425ba1$exports.definition = {
    prefix: $e63d7fcf04425ba1$var$prefix,
    iconName: $e63d7fcf04425ba1$var$iconName,
    icon: [
        $e63d7fcf04425ba1$var$width,
        $e63d7fcf04425ba1$var$height,
        $e63d7fcf04425ba1$var$aliases,
        $e63d7fcf04425ba1$var$unicode,
        $e63d7fcf04425ba1$var$svgPathData
    ]
};
$e63d7fcf04425ba1$exports.faHouse = $e63d7fcf04425ba1$exports.definition;
$e63d7fcf04425ba1$exports.prefix = $e63d7fcf04425ba1$var$prefix;
$e63d7fcf04425ba1$exports.iconName = $e63d7fcf04425ba1$var$iconName;
$e63d7fcf04425ba1$exports.width = $e63d7fcf04425ba1$var$width;
$e63d7fcf04425ba1$exports.height = $e63d7fcf04425ba1$var$height;
$e63d7fcf04425ba1$exports.ligatures = $e63d7fcf04425ba1$var$aliases;
$e63d7fcf04425ba1$exports.unicode = $e63d7fcf04425ba1$var$unicode;
$e63d7fcf04425ba1$exports.svgPathData = $e63d7fcf04425ba1$var$svgPathData;
$e63d7fcf04425ba1$exports.aliases = $e63d7fcf04425ba1$var$aliases;


$e0766fee15389c84$exports.definition = {
    prefix: $e63d7fcf04425ba1$exports.prefix,
    iconName: $e63d7fcf04425ba1$exports.iconName,
    icon: [
        $e63d7fcf04425ba1$exports.width,
        $e63d7fcf04425ba1$exports.height,
        $e63d7fcf04425ba1$exports.aliases,
        $e63d7fcf04425ba1$exports.unicode,
        $e63d7fcf04425ba1$exports.svgPathData
    ]
};
$e0766fee15389c84$exports.faHome = $e0766fee15389c84$exports.definition;
$e0766fee15389c84$exports.prefix = $e63d7fcf04425ba1$exports.prefix;
$e0766fee15389c84$exports.iconName = $e63d7fcf04425ba1$exports.iconName;
$e0766fee15389c84$exports.width = $e63d7fcf04425ba1$exports.width;
$e0766fee15389c84$exports.height = $e63d7fcf04425ba1$exports.height;
$e0766fee15389c84$exports.ligatures = $e63d7fcf04425ba1$exports.aliases;
$e0766fee15389c84$exports.unicode = $e63d7fcf04425ba1$exports.unicode;
$e0766fee15389c84$exports.svgPathData = $e63d7fcf04425ba1$exports.svgPathData;
$e0766fee15389c84$exports.aliases = $e63d7fcf04425ba1$exports.aliases;


var $2f9636cc813f210b$exports = {};
'use strict';
Object.defineProperty($2f9636cc813f210b$exports, '__esModule', {
    value: true
});
var $2f9636cc813f210b$var$prefix = 'fal';
var $2f9636cc813f210b$var$iconName = 'fax';
var $2f9636cc813f210b$var$width = 512;
var $2f9636cc813f210b$var$height = 512;
var $2f9636cc813f210b$var$aliases = [
    128224,
    128439
];
var $2f9636cc813f210b$var$unicode = 'f1ac';
var $2f9636cc813f210b$var$svgPathData = 'M160 64c0-17.7 14.3-32 32-32l196.1 0c8.5 0 16.6 3.4 22.6 9.4l27.9 27.9c6 6 9.4 14.1 9.4 22.6l0 68.1 32 0 0-68.1c0-17-6.7-33.3-18.7-45.3L433.4 18.7C421.4 6.7 405.1 0 388.1 0L192 0c-35.3 0-64 28.7-64 64l0 72.6c-9.4-5.4-20.3-8.6-32-8.6l-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l32 0c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7l256 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-288 0 0-128zm0 160l288 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-224zm-32-32l0 16 0 240c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32zM296 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';
$2f9636cc813f210b$exports.definition = {
    prefix: $2f9636cc813f210b$var$prefix,
    iconName: $2f9636cc813f210b$var$iconName,
    icon: [
        $2f9636cc813f210b$var$width,
        $2f9636cc813f210b$var$height,
        $2f9636cc813f210b$var$aliases,
        $2f9636cc813f210b$var$unicode,
        $2f9636cc813f210b$var$svgPathData
    ]
};
$2f9636cc813f210b$exports.faFax = $2f9636cc813f210b$exports.definition;
$2f9636cc813f210b$exports.prefix = $2f9636cc813f210b$var$prefix;
$2f9636cc813f210b$exports.iconName = $2f9636cc813f210b$var$iconName;
$2f9636cc813f210b$exports.width = $2f9636cc813f210b$var$width;
$2f9636cc813f210b$exports.height = $2f9636cc813f210b$var$height;
$2f9636cc813f210b$exports.ligatures = $2f9636cc813f210b$var$aliases;
$2f9636cc813f210b$exports.unicode = $2f9636cc813f210b$var$unicode;
$2f9636cc813f210b$exports.svgPathData = $2f9636cc813f210b$var$svgPathData;
$2f9636cc813f210b$exports.aliases = $2f9636cc813f210b$var$aliases;


var $1c0cb0b5e243b4e5$exports = {};
'use strict';
Object.defineProperty($1c0cb0b5e243b4e5$exports, '__esModule', {
    value: true
});
var $3b7dd5a9d981dc4a$exports = {};
'use strict';
Object.defineProperty($3b7dd5a9d981dc4a$exports, '__esModule', {
    value: true
});
var $3b7dd5a9d981dc4a$var$prefix = 'fal';
var $3b7dd5a9d981dc4a$var$iconName = 'ellipsis';
var $3b7dd5a9d981dc4a$var$width = 448;
var $3b7dd5a9d981dc4a$var$height = 512;
var $3b7dd5a9d981dc4a$var$aliases = [
    "ellipsis-h"
];
var $3b7dd5a9d981dc4a$var$unicode = 'f141';
var $3b7dd5a9d981dc4a$var$svgPathData = 'M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z';
$3b7dd5a9d981dc4a$exports.definition = {
    prefix: $3b7dd5a9d981dc4a$var$prefix,
    iconName: $3b7dd5a9d981dc4a$var$iconName,
    icon: [
        $3b7dd5a9d981dc4a$var$width,
        $3b7dd5a9d981dc4a$var$height,
        $3b7dd5a9d981dc4a$var$aliases,
        $3b7dd5a9d981dc4a$var$unicode,
        $3b7dd5a9d981dc4a$var$svgPathData
    ]
};
$3b7dd5a9d981dc4a$exports.faEllipsis = $3b7dd5a9d981dc4a$exports.definition;
$3b7dd5a9d981dc4a$exports.prefix = $3b7dd5a9d981dc4a$var$prefix;
$3b7dd5a9d981dc4a$exports.iconName = $3b7dd5a9d981dc4a$var$iconName;
$3b7dd5a9d981dc4a$exports.width = $3b7dd5a9d981dc4a$var$width;
$3b7dd5a9d981dc4a$exports.height = $3b7dd5a9d981dc4a$var$height;
$3b7dd5a9d981dc4a$exports.ligatures = $3b7dd5a9d981dc4a$var$aliases;
$3b7dd5a9d981dc4a$exports.unicode = $3b7dd5a9d981dc4a$var$unicode;
$3b7dd5a9d981dc4a$exports.svgPathData = $3b7dd5a9d981dc4a$var$svgPathData;
$3b7dd5a9d981dc4a$exports.aliases = $3b7dd5a9d981dc4a$var$aliases;


$1c0cb0b5e243b4e5$exports.definition = {
    prefix: $3b7dd5a9d981dc4a$exports.prefix,
    iconName: $3b7dd5a9d981dc4a$exports.iconName,
    icon: [
        $3b7dd5a9d981dc4a$exports.width,
        $3b7dd5a9d981dc4a$exports.height,
        $3b7dd5a9d981dc4a$exports.aliases,
        $3b7dd5a9d981dc4a$exports.unicode,
        $3b7dd5a9d981dc4a$exports.svgPathData
    ]
};
$1c0cb0b5e243b4e5$exports.faEllipsisH = $1c0cb0b5e243b4e5$exports.definition;
$1c0cb0b5e243b4e5$exports.prefix = $3b7dd5a9d981dc4a$exports.prefix;
$1c0cb0b5e243b4e5$exports.iconName = $3b7dd5a9d981dc4a$exports.iconName;
$1c0cb0b5e243b4e5$exports.width = $3b7dd5a9d981dc4a$exports.width;
$1c0cb0b5e243b4e5$exports.height = $3b7dd5a9d981dc4a$exports.height;
$1c0cb0b5e243b4e5$exports.ligatures = $3b7dd5a9d981dc4a$exports.aliases;
$1c0cb0b5e243b4e5$exports.unicode = $3b7dd5a9d981dc4a$exports.unicode;
$1c0cb0b5e243b4e5$exports.svgPathData = $3b7dd5a9d981dc4a$exports.svgPathData;
$1c0cb0b5e243b4e5$exports.aliases = $3b7dd5a9d981dc4a$exports.aliases;


var $5caaa4f8edf0e64d$exports = {};
'use strict';
Object.defineProperty($5caaa4f8edf0e64d$exports, '__esModule', {
    value: true
});
var $5caaa4f8edf0e64d$var$prefix = 'fal';
var $5caaa4f8edf0e64d$var$iconName = 'newspaper';
var $5caaa4f8edf0e64d$var$width = 512;
var $5caaa4f8edf0e64d$var$height = 512;
var $5caaa4f8edf0e64d$var$aliases = [
    128240
];
var $5caaa4f8edf0e64d$var$unicode = 'f1ea';
var $5caaa4f8edf0e64d$var$svgPathData = 'M160 64c-17.7 0-32 14.3-32 32l0 320c0 11.7-3.1 22.6-8.6 32L432 448c26.5 0 48-21.5 48-48l0-304c0-17.7-14.3-32-32-32L160 64zM64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l0 32c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32L96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 304c0 44.2-35.8 80-80 80L64 480zM384 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM160 304c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm32-144l128 0 0-96-128 0 0 96zM160 120c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-112z';
$5caaa4f8edf0e64d$exports.definition = {
    prefix: $5caaa4f8edf0e64d$var$prefix,
    iconName: $5caaa4f8edf0e64d$var$iconName,
    icon: [
        $5caaa4f8edf0e64d$var$width,
        $5caaa4f8edf0e64d$var$height,
        $5caaa4f8edf0e64d$var$aliases,
        $5caaa4f8edf0e64d$var$unicode,
        $5caaa4f8edf0e64d$var$svgPathData
    ]
};
$5caaa4f8edf0e64d$exports.faNewspaper = $5caaa4f8edf0e64d$exports.definition;
$5caaa4f8edf0e64d$exports.prefix = $5caaa4f8edf0e64d$var$prefix;
$5caaa4f8edf0e64d$exports.iconName = $5caaa4f8edf0e64d$var$iconName;
$5caaa4f8edf0e64d$exports.width = $5caaa4f8edf0e64d$var$width;
$5caaa4f8edf0e64d$exports.height = $5caaa4f8edf0e64d$var$height;
$5caaa4f8edf0e64d$exports.ligatures = $5caaa4f8edf0e64d$var$aliases;
$5caaa4f8edf0e64d$exports.unicode = $5caaa4f8edf0e64d$var$unicode;
$5caaa4f8edf0e64d$exports.svgPathData = $5caaa4f8edf0e64d$var$svgPathData;
$5caaa4f8edf0e64d$exports.aliases = $5caaa4f8edf0e64d$var$aliases;


var $f895e3606e4776ba$exports = {};
'use strict';
Object.defineProperty($f895e3606e4776ba$exports, '__esModule', {
    value: true
});
var $f895e3606e4776ba$var$prefix = 'fal';
var $f895e3606e4776ba$var$iconName = 'circle-notch';
var $f895e3606e4776ba$var$width = 512;
var $f895e3606e4776ba$var$height = 512;
var $f895e3606e4776ba$var$aliases = [];
var $f895e3606e4776ba$var$unicode = 'f1ce';
var $f895e3606e4776ba$var$svgPathData = 'M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9c-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z';
$f895e3606e4776ba$exports.definition = {
    prefix: $f895e3606e4776ba$var$prefix,
    iconName: $f895e3606e4776ba$var$iconName,
    icon: [
        $f895e3606e4776ba$var$width,
        $f895e3606e4776ba$var$height,
        $f895e3606e4776ba$var$aliases,
        $f895e3606e4776ba$var$unicode,
        $f895e3606e4776ba$var$svgPathData
    ]
};
$f895e3606e4776ba$exports.faCircleNotch = $f895e3606e4776ba$exports.definition;
$f895e3606e4776ba$exports.prefix = $f895e3606e4776ba$var$prefix;
$f895e3606e4776ba$exports.iconName = $f895e3606e4776ba$var$iconName;
$f895e3606e4776ba$exports.width = $f895e3606e4776ba$var$width;
$f895e3606e4776ba$exports.height = $f895e3606e4776ba$var$height;
$f895e3606e4776ba$exports.ligatures = $f895e3606e4776ba$var$aliases;
$f895e3606e4776ba$exports.unicode = $f895e3606e4776ba$var$unicode;
$f895e3606e4776ba$exports.svgPathData = $f895e3606e4776ba$var$svgPathData;
$f895e3606e4776ba$exports.aliases = $f895e3606e4776ba$var$aliases;


var $fb966d401638ecef$exports = {};
'use strict';
Object.defineProperty($fb966d401638ecef$exports, '__esModule', {
    value: true
});
var $fb966d401638ecef$var$prefix = 'fal';
var $fb966d401638ecef$var$iconName = 'industry';
var $fb966d401638ecef$var$width = 576;
var $fb966d401638ecef$var$height = 512;
var $fb966d401638ecef$var$aliases = [];
var $fb966d401638ecef$var$unicode = 'f275';
var $fb966d401638ecef$var$svgPathData = 'M80 64c-8.8 0-16 7.2-16 16l0 224 0 48 0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-96 0-16 0-145.1c0-6.5-7.4-10.3-12.7-6.5l-138 99.3c-4.9 3.5-11.3 4-16.6 1.3s-8.7-8.2-8.7-14.2l0-81.9c0-6.4-7.1-10.2-12.4-6.7L184.9 242.6c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1L160 80c0-8.8-7.2-16-16-16L80 64zM32 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 119.4 113.8-75.9c26.6-17.7 62.2 1.3 62.2 33.3l0 50.6 112.6-81.1c26.5-19.1 63.4-.1 63.4 32.5L544 304l0 16 0 96c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-64 0-48L32 80z';
$fb966d401638ecef$exports.definition = {
    prefix: $fb966d401638ecef$var$prefix,
    iconName: $fb966d401638ecef$var$iconName,
    icon: [
        $fb966d401638ecef$var$width,
        $fb966d401638ecef$var$height,
        $fb966d401638ecef$var$aliases,
        $fb966d401638ecef$var$unicode,
        $fb966d401638ecef$var$svgPathData
    ]
};
$fb966d401638ecef$exports.faIndustry = $fb966d401638ecef$exports.definition;
$fb966d401638ecef$exports.prefix = $fb966d401638ecef$var$prefix;
$fb966d401638ecef$exports.iconName = $fb966d401638ecef$var$iconName;
$fb966d401638ecef$exports.width = $fb966d401638ecef$var$width;
$fb966d401638ecef$exports.height = $fb966d401638ecef$var$height;
$fb966d401638ecef$exports.ligatures = $fb966d401638ecef$var$aliases;
$fb966d401638ecef$exports.unicode = $fb966d401638ecef$var$unicode;
$fb966d401638ecef$exports.svgPathData = $fb966d401638ecef$var$svgPathData;
$fb966d401638ecef$exports.aliases = $fb966d401638ecef$var$aliases;


var $9170c7788b1dff30$exports = {};
'use strict';
Object.defineProperty($9170c7788b1dff30$exports, '__esModule', {
    value: true
});
var $9170c7788b1dff30$var$prefix = 'fal';
var $9170c7788b1dff30$var$iconName = 'award';
var $9170c7788b1dff30$var$width = 384;
var $9170c7788b1dff30$var$height = 512;
var $9170c7788b1dff30$var$aliases = [];
var $9170c7788b1dff30$var$unicode = 'f559';
var $9170c7788b1dff30$var$svgPathData = 'M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM1.3 441.8l41.2-97.9c1.5 1.8 3.6 4.8 6.9 10.8c4 7.4 9.1 14 15 19.6L41.8 428l38.1-5.7c6.2-.9 12.3 1.8 15.7 7.1L116.9 462l26-61.8c1.8 .9 4.1 2.2 6.9 3.9c7 4.3 14.5 7.4 22.2 9.3l-37.3 88.7c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4l-37.3-88.7c7.7-2 15.2-5.1 22.2-9.3c2.8-1.7 5.1-3 6.9-3.9l26 61.8 21.3-32.6c3.4-5.2 9.6-8 15.7-7.1l38.1 5.7-22.6-53.7c5.9-5.6 11-12.2 15-19.6c3.3-6 5.4-9 6.9-10.8l41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z';
$9170c7788b1dff30$exports.definition = {
    prefix: $9170c7788b1dff30$var$prefix,
    iconName: $9170c7788b1dff30$var$iconName,
    icon: [
        $9170c7788b1dff30$var$width,
        $9170c7788b1dff30$var$height,
        $9170c7788b1dff30$var$aliases,
        $9170c7788b1dff30$var$unicode,
        $9170c7788b1dff30$var$svgPathData
    ]
};
$9170c7788b1dff30$exports.faAward = $9170c7788b1dff30$exports.definition;
$9170c7788b1dff30$exports.prefix = $9170c7788b1dff30$var$prefix;
$9170c7788b1dff30$exports.iconName = $9170c7788b1dff30$var$iconName;
$9170c7788b1dff30$exports.width = $9170c7788b1dff30$var$width;
$9170c7788b1dff30$exports.height = $9170c7788b1dff30$var$height;
$9170c7788b1dff30$exports.ligatures = $9170c7788b1dff30$var$aliases;
$9170c7788b1dff30$exports.unicode = $9170c7788b1dff30$var$unicode;
$9170c7788b1dff30$exports.svgPathData = $9170c7788b1dff30$var$svgPathData;
$9170c7788b1dff30$exports.aliases = $9170c7788b1dff30$var$aliases;


var $353f53b33bd05a97$exports = {};
'use strict';
Object.defineProperty($353f53b33bd05a97$exports, '__esModule', {
    value: true
});
var $353f53b33bd05a97$var$prefix = 'fal';
var $353f53b33bd05a97$var$iconName = 'certificate';
var $353f53b33bd05a97$var$width = 512;
var $353f53b33bd05a97$var$height = 512;
var $353f53b33bd05a97$var$aliases = [];
var $353f53b33bd05a97$var$unicode = 'f0a3';
var $353f53b33bd05a97$var$svgPathData = 'M170.7 108.3c7.5-4.3 12.9-11.5 15-19.8l12.3-48.6 35 36c6 6.2 14.3 9.7 22.9 9.7s16.9-3.5 22.9-9.7l35-36 12.3 48.6c2.1 8.4 7.5 15.5 15 19.8s16.4 5.4 24.7 3.1l48.3-13.6L400.6 146c-2.3 8.3-1.2 17.2 3.1 24.7s11.5 12.9 19.8 15l48.6 12.3-36 35c-6.2 6-9.7 14.3-9.7 22.9s3.5 16.9 9.7 22.9l36 35-48.6 12.3c-8.4 2.1-15.5 7.5-19.8 15s-5.4 16.4-3.1 24.7l13.6 48.3L366 400.6c-8.3-2.3-17.2-1.2-24.7 3.1s-12.9 11.5-15 19.8l-12.3 48.6-35-36c-6-6.2-14.3-9.7-22.9-9.7s-16.9 3.5-22.9 9.7l-35 36-12.3-48.6c-2.1-8.4-7.5-15.5-15-19.8s-16.4-5.4-24.7-3.1L97.8 414.2 111.4 366c2.3-8.3 1.2-17.2-3.1-24.7s-11.5-12.9-19.8-15L39.8 313.9l36-35c6.2-6 9.7-14.3 9.7-22.9s-3.5-16.9-9.7-22.9l-36-35 48.6-12.3c8.4-2.1 15.5-7.5 19.8-15s5.4-16.4 3.1-24.7L97.8 97.8 146 111.4c8.3 2.3 17.2 1.2 24.7-3.1zM49.6 162.6l-31.5 8c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l23.3 22.6L53.5 256 30.5 278.3 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l31.5 8 31 7.9-8.7 30.8-8.8 31.2c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l31.2-8.8 30.8-8.7 7.9 31 8 31.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l22.6-23.3L256 458.5l22.3 22.9L301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l8-31.5 7.9-31 30.8 8.7 31.2 8.8c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-8.8-31.2-8.7-30.8 31-7.9 31.5-8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-23.3-22.6L458.5 256l22.9-22.3L504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-31.5-8-31-7.9 8.7-30.8 8.8-31.2c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-31.2 8.8-30.8 8.7-7.9-31-8-31.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L278.3 30.5 256 53.5 233.7 30.5 211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-8 31.5-7.9 31-30.8-8.7L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l8.8 31.2 8.7 30.8-31 7.9z';
$353f53b33bd05a97$exports.definition = {
    prefix: $353f53b33bd05a97$var$prefix,
    iconName: $353f53b33bd05a97$var$iconName,
    icon: [
        $353f53b33bd05a97$var$width,
        $353f53b33bd05a97$var$height,
        $353f53b33bd05a97$var$aliases,
        $353f53b33bd05a97$var$unicode,
        $353f53b33bd05a97$var$svgPathData
    ]
};
$353f53b33bd05a97$exports.faCertificate = $353f53b33bd05a97$exports.definition;
$353f53b33bd05a97$exports.prefix = $353f53b33bd05a97$var$prefix;
$353f53b33bd05a97$exports.iconName = $353f53b33bd05a97$var$iconName;
$353f53b33bd05a97$exports.width = $353f53b33bd05a97$var$width;
$353f53b33bd05a97$exports.height = $353f53b33bd05a97$var$height;
$353f53b33bd05a97$exports.ligatures = $353f53b33bd05a97$var$aliases;
$353f53b33bd05a97$exports.unicode = $353f53b33bd05a97$var$unicode;
$353f53b33bd05a97$exports.svgPathData = $353f53b33bd05a97$var$svgPathData;
$353f53b33bd05a97$exports.aliases = $353f53b33bd05a97$var$aliases;


var $ffa87db8a7694886$exports = {};
'use strict';
Object.defineProperty($ffa87db8a7694886$exports, '__esModule', {
    value: true
});
var $ffa87db8a7694886$var$prefix = 'fal';
var $ffa87db8a7694886$var$iconName = 'flask';
var $ffa87db8a7694886$var$width = 448;
var $ffa87db8a7694886$var$height = 512;
var $ffa87db8a7694886$var$aliases = [];
var $ffa87db8a7694886$var$unicode = 'f0c3';
var $ffa87db8a7694886$var$svgPathData = 'M288 196.8L288 32 160 32l0 164.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320l246.2 0-44.8-72.9C292.9 232 288 214.6 288 196.8zM128 32l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0L288 0l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 164.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 32zM37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480l309.2 0c20.7 0 37.4-16.7 37.4-37.4c0-6.9-1.9-13.7-5.5-19.6l-43.7-71L81.2 352 37.5 423z';
$ffa87db8a7694886$exports.definition = {
    prefix: $ffa87db8a7694886$var$prefix,
    iconName: $ffa87db8a7694886$var$iconName,
    icon: [
        $ffa87db8a7694886$var$width,
        $ffa87db8a7694886$var$height,
        $ffa87db8a7694886$var$aliases,
        $ffa87db8a7694886$var$unicode,
        $ffa87db8a7694886$var$svgPathData
    ]
};
$ffa87db8a7694886$exports.faFlask = $ffa87db8a7694886$exports.definition;
$ffa87db8a7694886$exports.prefix = $ffa87db8a7694886$var$prefix;
$ffa87db8a7694886$exports.iconName = $ffa87db8a7694886$var$iconName;
$ffa87db8a7694886$exports.width = $ffa87db8a7694886$var$width;
$ffa87db8a7694886$exports.height = $ffa87db8a7694886$var$height;
$ffa87db8a7694886$exports.ligatures = $ffa87db8a7694886$var$aliases;
$ffa87db8a7694886$exports.unicode = $ffa87db8a7694886$var$unicode;
$ffa87db8a7694886$exports.svgPathData = $ffa87db8a7694886$var$svgPathData;
$ffa87db8a7694886$exports.aliases = $ffa87db8a7694886$var$aliases;


var $6b1ffeea6a7afe84$exports = {};
'use strict';
Object.defineProperty($6b1ffeea6a7afe84$exports, '__esModule', {
    value: true
});
var $6b1ffeea6a7afe84$var$prefix = 'fal';
var $6b1ffeea6a7afe84$var$iconName = 'leaf';
var $6b1ffeea6a7afe84$var$width = 512;
var $6b1ffeea6a7afe84$var$height = 512;
var $6b1ffeea6a7afe84$var$aliases = [];
var $6b1ffeea6a7afe84$var$unicode = 'f06c';
var $6b1ffeea6a7afe84$var$svgPathData = 'M132 238.3c23.6-9.3 49.2-14.3 76-14.3l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-28.8 0-56 6.9-80 19.2C129.7 353.2 193.5 416 272 416c0 0 0 0 0 0l.8 0c109-.5 207.2-110.5 207.2-259.4c0-23-2.4-45.2-6.9-66.3C447.5 113.7 413.4 128 376 128l-104 0c-67.9 0-124.9 47-140 110.3zM96.7 256.3C104.7 166.4 180.1 96 272 96l104 0c35.2 0 66.6-16.2 87.2-41.7l.6-.8c2.3-2.9 4.4-5.8 6.4-8.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6s2.3 7.1 3.4 10.8l.4 1.5c8.8 30.3 13.5 62.8 13.5 96.8C512 317.1 405.1 447.3 273 448l-1 0c-89.4 0-163.2-66.7-174.5-153C57.5 327.3 32 376.7 32 432l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-73.9 38.6-138.9 96.7-175.7z';
$6b1ffeea6a7afe84$exports.definition = {
    prefix: $6b1ffeea6a7afe84$var$prefix,
    iconName: $6b1ffeea6a7afe84$var$iconName,
    icon: [
        $6b1ffeea6a7afe84$var$width,
        $6b1ffeea6a7afe84$var$height,
        $6b1ffeea6a7afe84$var$aliases,
        $6b1ffeea6a7afe84$var$unicode,
        $6b1ffeea6a7afe84$var$svgPathData
    ]
};
$6b1ffeea6a7afe84$exports.faLeaf = $6b1ffeea6a7afe84$exports.definition;
$6b1ffeea6a7afe84$exports.prefix = $6b1ffeea6a7afe84$var$prefix;
$6b1ffeea6a7afe84$exports.iconName = $6b1ffeea6a7afe84$var$iconName;
$6b1ffeea6a7afe84$exports.width = $6b1ffeea6a7afe84$var$width;
$6b1ffeea6a7afe84$exports.height = $6b1ffeea6a7afe84$var$height;
$6b1ffeea6a7afe84$exports.ligatures = $6b1ffeea6a7afe84$var$aliases;
$6b1ffeea6a7afe84$exports.unicode = $6b1ffeea6a7afe84$var$unicode;
$6b1ffeea6a7afe84$exports.svgPathData = $6b1ffeea6a7afe84$var$svgPathData;
$6b1ffeea6a7afe84$exports.aliases = $6b1ffeea6a7afe84$var$aliases;


var $9e51484bffff5392$exports = {};
'use strict';
Object.defineProperty($9e51484bffff5392$exports, '__esModule', {
    value: true
});
var $9e51484bffff5392$var$prefix = 'fab';
var $9e51484bffff5392$var$iconName = 'facebook-f';
var $9e51484bffff5392$var$width = 320;
var $9e51484bffff5392$var$height = 512;
var $9e51484bffff5392$var$aliases = [];
var $9e51484bffff5392$var$unicode = 'f39e';
var $9e51484bffff5392$var$svgPathData = 'M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z';
$9e51484bffff5392$exports.definition = {
    prefix: $9e51484bffff5392$var$prefix,
    iconName: $9e51484bffff5392$var$iconName,
    icon: [
        $9e51484bffff5392$var$width,
        $9e51484bffff5392$var$height,
        $9e51484bffff5392$var$aliases,
        $9e51484bffff5392$var$unicode,
        $9e51484bffff5392$var$svgPathData
    ]
};
$9e51484bffff5392$exports.faFacebookF = $9e51484bffff5392$exports.definition;
$9e51484bffff5392$exports.prefix = $9e51484bffff5392$var$prefix;
$9e51484bffff5392$exports.iconName = $9e51484bffff5392$var$iconName;
$9e51484bffff5392$exports.width = $9e51484bffff5392$var$width;
$9e51484bffff5392$exports.height = $9e51484bffff5392$var$height;
$9e51484bffff5392$exports.ligatures = $9e51484bffff5392$var$aliases;
$9e51484bffff5392$exports.unicode = $9e51484bffff5392$var$unicode;
$9e51484bffff5392$exports.svgPathData = $9e51484bffff5392$var$svgPathData;
$9e51484bffff5392$exports.aliases = $9e51484bffff5392$var$aliases;


var $0c29c32ac8432756$exports = {};
'use strict';
Object.defineProperty($0c29c32ac8432756$exports, '__esModule', {
    value: true
});
var $0c29c32ac8432756$var$prefix = 'fab';
var $0c29c32ac8432756$var$iconName = 'instagram';
var $0c29c32ac8432756$var$width = 448;
var $0c29c32ac8432756$var$height = 512;
var $0c29c32ac8432756$var$aliases = [];
var $0c29c32ac8432756$var$unicode = 'f16d';
var $0c29c32ac8432756$var$svgPathData = 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z';
$0c29c32ac8432756$exports.definition = {
    prefix: $0c29c32ac8432756$var$prefix,
    iconName: $0c29c32ac8432756$var$iconName,
    icon: [
        $0c29c32ac8432756$var$width,
        $0c29c32ac8432756$var$height,
        $0c29c32ac8432756$var$aliases,
        $0c29c32ac8432756$var$unicode,
        $0c29c32ac8432756$var$svgPathData
    ]
};
$0c29c32ac8432756$exports.faInstagram = $0c29c32ac8432756$exports.definition;
$0c29c32ac8432756$exports.prefix = $0c29c32ac8432756$var$prefix;
$0c29c32ac8432756$exports.iconName = $0c29c32ac8432756$var$iconName;
$0c29c32ac8432756$exports.width = $0c29c32ac8432756$var$width;
$0c29c32ac8432756$exports.height = $0c29c32ac8432756$var$height;
$0c29c32ac8432756$exports.ligatures = $0c29c32ac8432756$var$aliases;
$0c29c32ac8432756$exports.unicode = $0c29c32ac8432756$var$unicode;
$0c29c32ac8432756$exports.svgPathData = $0c29c32ac8432756$var$svgPathData;
$0c29c32ac8432756$exports.aliases = $0c29c32ac8432756$var$aliases;


var $b79bf6e309d792ff$exports = {};
'use strict';
Object.defineProperty($b79bf6e309d792ff$exports, '__esModule', {
    value: true
});
var $b79bf6e309d792ff$var$prefix = 'fab';
var $b79bf6e309d792ff$var$iconName = 'youtube';
var $b79bf6e309d792ff$var$width = 576;
var $b79bf6e309d792ff$var$height = 512;
var $b79bf6e309d792ff$var$aliases = [
    61802
];
var $b79bf6e309d792ff$var$unicode = 'f167';
var $b79bf6e309d792ff$var$svgPathData = 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z';
$b79bf6e309d792ff$exports.definition = {
    prefix: $b79bf6e309d792ff$var$prefix,
    iconName: $b79bf6e309d792ff$var$iconName,
    icon: [
        $b79bf6e309d792ff$var$width,
        $b79bf6e309d792ff$var$height,
        $b79bf6e309d792ff$var$aliases,
        $b79bf6e309d792ff$var$unicode,
        $b79bf6e309d792ff$var$svgPathData
    ]
};
$b79bf6e309d792ff$exports.faYoutube = $b79bf6e309d792ff$exports.definition;
$b79bf6e309d792ff$exports.prefix = $b79bf6e309d792ff$var$prefix;
$b79bf6e309d792ff$exports.iconName = $b79bf6e309d792ff$var$iconName;
$b79bf6e309d792ff$exports.width = $b79bf6e309d792ff$var$width;
$b79bf6e309d792ff$exports.height = $b79bf6e309d792ff$var$height;
$b79bf6e309d792ff$exports.ligatures = $b79bf6e309d792ff$var$aliases;
$b79bf6e309d792ff$exports.unicode = $b79bf6e309d792ff$var$unicode;
$b79bf6e309d792ff$exports.svgPathData = $b79bf6e309d792ff$var$svgPathData;
$b79bf6e309d792ff$exports.aliases = $b79bf6e309d792ff$var$aliases;


var $4249215276a820c2$exports = {};
'use strict';
Object.defineProperty($4249215276a820c2$exports, '__esModule', {
    value: true
});
var $4249215276a820c2$var$prefix = 'fab';
var $4249215276a820c2$var$iconName = 'twitter';
var $4249215276a820c2$var$width = 512;
var $4249215276a820c2$var$height = 512;
var $4249215276a820c2$var$aliases = [];
var $4249215276a820c2$var$unicode = 'f099';
var $4249215276a820c2$var$svgPathData = 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z';
$4249215276a820c2$exports.definition = {
    prefix: $4249215276a820c2$var$prefix,
    iconName: $4249215276a820c2$var$iconName,
    icon: [
        $4249215276a820c2$var$width,
        $4249215276a820c2$var$height,
        $4249215276a820c2$var$aliases,
        $4249215276a820c2$var$unicode,
        $4249215276a820c2$var$svgPathData
    ]
};
$4249215276a820c2$exports.faTwitter = $4249215276a820c2$exports.definition;
$4249215276a820c2$exports.prefix = $4249215276a820c2$var$prefix;
$4249215276a820c2$exports.iconName = $4249215276a820c2$var$iconName;
$4249215276a820c2$exports.width = $4249215276a820c2$var$width;
$4249215276a820c2$exports.height = $4249215276a820c2$var$height;
$4249215276a820c2$exports.ligatures = $4249215276a820c2$var$aliases;
$4249215276a820c2$exports.unicode = $4249215276a820c2$var$unicode;
$4249215276a820c2$exports.svgPathData = $4249215276a820c2$var$svgPathData;
$4249215276a820c2$exports.aliases = $4249215276a820c2$var$aliases;


var $8e1fd11806c205a6$exports = {};
'use strict';
Object.defineProperty($8e1fd11806c205a6$exports, '__esModule', {
    value: true
});
var $8e1fd11806c205a6$var$prefix = 'fab';
var $8e1fd11806c205a6$var$iconName = 'linkedin-in';
var $8e1fd11806c205a6$var$width = 448;
var $8e1fd11806c205a6$var$height = 512;
var $8e1fd11806c205a6$var$aliases = [];
var $8e1fd11806c205a6$var$unicode = 'f0e1';
var $8e1fd11806c205a6$var$svgPathData = 'M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z';
$8e1fd11806c205a6$exports.definition = {
    prefix: $8e1fd11806c205a6$var$prefix,
    iconName: $8e1fd11806c205a6$var$iconName,
    icon: [
        $8e1fd11806c205a6$var$width,
        $8e1fd11806c205a6$var$height,
        $8e1fd11806c205a6$var$aliases,
        $8e1fd11806c205a6$var$unicode,
        $8e1fd11806c205a6$var$svgPathData
    ]
};
$8e1fd11806c205a6$exports.faLinkedinIn = $8e1fd11806c205a6$exports.definition;
$8e1fd11806c205a6$exports.prefix = $8e1fd11806c205a6$var$prefix;
$8e1fd11806c205a6$exports.iconName = $8e1fd11806c205a6$var$iconName;
$8e1fd11806c205a6$exports.width = $8e1fd11806c205a6$var$width;
$8e1fd11806c205a6$exports.height = $8e1fd11806c205a6$var$height;
$8e1fd11806c205a6$exports.ligatures = $8e1fd11806c205a6$var$aliases;
$8e1fd11806c205a6$exports.unicode = $8e1fd11806c205a6$var$unicode;
$8e1fd11806c205a6$exports.svgPathData = $8e1fd11806c205a6$var$svgPathData;
$8e1fd11806c205a6$exports.aliases = $8e1fd11806c205a6$var$aliases;


var $58a550529339bff3$exports = {};
'use strict';
Object.defineProperty($58a550529339bff3$exports, '__esModule', {
    value: true
});
var $58a550529339bff3$var$prefix = 'fab';
var $58a550529339bff3$var$iconName = 'vimeo-v';
var $58a550529339bff3$var$width = 448;
var $58a550529339bff3$var$height = 512;
var $58a550529339bff3$var$aliases = [];
var $58a550529339bff3$var$unicode = 'f27d';
var $58a550529339bff3$var$svgPathData = 'M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z';
$58a550529339bff3$exports.definition = {
    prefix: $58a550529339bff3$var$prefix,
    iconName: $58a550529339bff3$var$iconName,
    icon: [
        $58a550529339bff3$var$width,
        $58a550529339bff3$var$height,
        $58a550529339bff3$var$aliases,
        $58a550529339bff3$var$unicode,
        $58a550529339bff3$var$svgPathData
    ]
};
$58a550529339bff3$exports.faVimeoV = $58a550529339bff3$exports.definition;
$58a550529339bff3$exports.prefix = $58a550529339bff3$var$prefix;
$58a550529339bff3$exports.iconName = $58a550529339bff3$var$iconName;
$58a550529339bff3$exports.width = $58a550529339bff3$var$width;
$58a550529339bff3$exports.height = $58a550529339bff3$var$height;
$58a550529339bff3$exports.ligatures = $58a550529339bff3$var$aliases;
$58a550529339bff3$exports.unicode = $58a550529339bff3$var$unicode;
$58a550529339bff3$exports.svgPathData = $58a550529339bff3$var$svgPathData;
$58a550529339bff3$exports.aliases = $58a550529339bff3$var$aliases;


// Add imported icons to the library
(0, $2f7ebf3a194ce8e5$export$b839f963c7dc0e34).add((0, $98e875df216c54f4$exports.faAngleLeft), (0, $cedfc6bf94a82c24$exports.faAngleRight), (0, $c17b7e009c12ce7d$exports.faSearch), (0, $099c87b3dd8df3c8$exports.faBars), (0, $cac493d0ac84992c$exports.faFile), (0, $edb355c416917111$exports.faImage), (0, $3a2bc56e455da4fe$exports.faExclamationTriangle), (0, $60e51ca178edefdc$exports.faCheck), (0, $6a570ce2b1ac1a0a$exports.faTriangle), (0, $aedf8398cf1089ee$exports.faSquare), (0, $9b0294e316990d10$exports.faFont), (0, $f69362c36825a98f$exports.faCircle), (0, $51fa0c8e62b7bd84$exports.faAngleLeft), (0, $90098deafd3a5ecf$exports.faAngleRight), (0, $99f81b005a3776d9$exports.faAngleUp), (0, $a26bb9e40d43ef12$exports.faAngleDown), (0, $9d1000b76ec5ac40$exports.faTimes), (0, $a57135b183b842de$exports.faGlobe), (0, $8b2b3ed703859157$exports.faMapMarkerAlt), (0, $44acc92247d79ba3$exports.faDownload), (0, $57480e4e181595f3$exports.faEnvelope), (0, $72f6f96f0a4eb0ba$exports.faPhone), (0, $508795d014ac1555$exports.faExternalLink), (0, $257742f4a8891061$exports.faInfoCircle), (0, $137a0f42acd21719$exports.faFileAlt), (0, $2abdd8614c9084f8$exports.faFilePdf), (0, $dbe9b20997b54e98$exports.faCheckCircle), (0, $e0766fee15389c84$exports.faHome), (0, $2f9636cc813f210b$exports.faFax), (0, $1c0cb0b5e243b4e5$exports.faEllipsisH), (0, $5caaa4f8edf0e64d$exports.faNewspaper), (0, $f895e3606e4776ba$exports.faCircleNotch), (0, $508795d014ac1555$exports.faExternalLink), (0, $fb966d401638ecef$exports.faIndustry), (0, $9170c7788b1dff30$exports.faAward), (0, $353f53b33bd05a97$exports.faCertificate), (0, $ffa87db8a7694886$exports.faFlask), (0, $6b1ffeea6a7afe84$exports.faLeaf), (0, $9e51484bffff5392$exports.faFacebookF), (0, $0c29c32ac8432756$exports.faInstagram), (0, $b79bf6e309d792ff$exports.faYoutube), (0, $4249215276a820c2$exports.faTwitter), (0, $8e1fd11806c205a6$exports.faLinkedinIn), (0, $58a550529339bff3$exports.faVimeoV));
// Kicks off the process of finding <i> tags and replacing with <svg>
(0, $2f7ebf3a194ce8e5$export$df3a06d6289f983e).watch();


// Import slick-carousel
var $0996168b56443dd0$exports = {};
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */ /* global window, document, define, jQuery, setInterval, clearInterval */ 
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([
        'jquery'
    ], factory);
    else $0996168b56443dd0$exports = factory((parcelRequire("9qak9")));
})(function($) {
    'use strict';
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data('slick') || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    }();
    Slick.prototype.activateADA = function() {
        var _ = this;
        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) return false;
        _.unload();
        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) $(markup).appendTo(_.$slideTrack);
            else if (addBefore) $(markup).insertBefore(_.$slides.eq(index));
            else $(markup).insertAfter(_.$slides.eq(index));
        } else if (addBefore === true) $(markup).prependTo(_.$slideTrack);
        else $(markup).appendTo(_.$slideTrack);
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) targetLeft = -targetLeft;
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) _.$slideTrack.animate({
                left: targetLeft
            }, _.options.speed, _.options.easing, callback);
            else _.$slideTrack.animate({
                top: targetLeft
            }, _.options.speed, _.options.easing, callback);
        } else if (_.cssTransitions === false) {
            if (_.options.rtl === true) _.currentLeft = -_.currentLeft;
            $({
                animStart: _.currentLeft
            }).animate({
                animStart: targetLeft
            }, {
                duration: _.options.speed,
                easing: _.options.easing,
                step: function(now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                        animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                        _.$slideTrack.css(animProps);
                    } else {
                        animProps[_.animType] = 'translate(0px,' + now + 'px)';
                        _.$slideTrack.css(animProps);
                    }
                },
                complete: function() {
                    if (callback) callback.call();
                }
            });
        } else {
            _.applyTransition();
            targetLeft = Math.ceil(targetLeft);
            if (_.options.vertical === false) animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
            else animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
            _.$slideTrack.css(animProps);
            if (callback) setTimeout(function() {
                _.disableTransition();
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.getNavTarget = function() {
        var _ = this, asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) asNavFor = $(asNavFor).not(_.$slider);
        return asNavFor;
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.getNavTarget();
        if (asNavFor !== null && typeof asNavFor === 'object') asNavFor.each(function() {
            var target = $(this).slick('getSlick');
            if (!target.unslicked) target.slideHandler(index, true);
        });
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        else transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) clearInterval(_.autoPlayTimer);
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this, slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) _.direction = 0;
                else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) _.direction = 1;
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.prependTo(_.options.appendArrows);
                if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.appendTo(_.options.appendArrows);
                if (_.options.infinite !== true) _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
            } else _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                'aria-disabled': 'true',
                'tabindex': '-1'
            });
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass('slick-dotted');
            dot = $('<ul />').addClass(_.options.dotsClass);
            for(i = 0; i <= _.getDotCount(); i += 1)dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find('li').first().addClass('slick-active');
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });
        _.$slider.addClass('slick-slider');
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) _.options.slidesToScroll = 1;
        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        if (_.options.draggable === true) _.$list.addClass('draggable');
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++){
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++){
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) row.appendChild(originalSlides.get(target));
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === 'window') respondToWidth = windowWidth;
        else if (_.respondTo === 'slider') respondToWidth = sliderWidth;
        else if (_.respondTo === 'min') respondToWidth = Math.min(windowWidth, sliderWidth);
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for(breakpoint in _.breakpoints)if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
                } else if (respondToWidth > _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                        else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                    else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) _.currentSlide = _.options.initialSlide;
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
            }
            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) _.$slider.trigger('breakpoint', [
                _,
                triggerBreakpoint
            ]);
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.currentTarget), indexOffset, slideOffset, unevenOffset;
        // If target is a link, prevent default action.
        if ($target.is('a')) event.preventDefault();
        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) $target = $target.closest('li');
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch(event.data.message){
            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                break;
            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                break;
            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
        else for(var n in navigables){
            if (index < navigables[n]) {
                index = prevNavigable;
                break;
            }
            prevNavigable = navigables[n];
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) _.$dots.off('keydown.slick', _.keyHandler);
        }
        _.$slider.off('focus.slick blur.slick');
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }
        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
        _.$list.off('click.slick', _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) _.$list.off('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function() {
        var _ = this;
        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function(refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $('.slick-cloned', _.$slider).detach();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
                $(this).attr('style', $(this).data('originalStyling'));
            });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');
        _.unslicked = true;
        if (!refresh) _.$slider.trigger('destroy', [
            _
        ]);
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = '';
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });
            if (callback) setTimeout(function() {
                _.disableTransition(slideIndex);
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.fadeSlideOut = function(slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) _.$slides.eq(slideIndex).animate({
            opacity: 0,
            zIndex: _.options.zIndex - 2
        }, _.options.speed, _.options.easing);
        else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
            event.stopImmediatePropagation();
            var $sf = $(this);
            setTimeout(function() {
                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
            else while(breakPoint < _.slideCount){
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) pagerQty = _.slideCount;
        else if (!_.options.asNavFor) pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        else while(breakPoint < _.slideCount){
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide, coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) coef = -1.5;
                    else if (_.options.slidesToShow === 1) coef = -2;
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else if (slideIndex + _.options.slidesToShow > _.slideCount) {
            _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
            verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        else if (_.options.centerMode === true && _.options.infinite === true) _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        else targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            if (_.options.rtl === true) {
                if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                else targetLeft = 0;
            } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                if (_.options.rtl === true) {
                    if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    else targetLeft = 0;
                } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) max = _.slideCount;
        else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while(breakPoint < max){
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
            return slidesTraversed;
        } else return _.options.slidesToScroll;
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function(creation) {
        var _ = this;
        if (!$(_.$slider).hasClass('slick-initialized')) {
            $(_.$slider).addClass('slick-initialized');
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) _.$slider.trigger('init', [
            _
        ]);
        if (_.options.accessibility === true) _.initADA();
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function() {
        var _ = this, numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow), tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
            return val >= 0 && val < _.slideCount;
        });
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                    if ($('#' + ariaButtonControl).length) $(this).attr({
                        'aria-describedby': ariaButtonControl
                    });
                }
            });
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
                $(this).attr({
                    'role': 'presentation'
                });
                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }
        for(var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)if (_.options.focusOnChange) _.$slides.eq(i).attr({
            'tabindex': '0'
        });
        else _.$slides.eq(i).removeAttr('tabindex');
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
            if (_.options.accessibility === true) _.$dots.on('keydown.slick', _.keyHandler);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.initSlideEvents = function() {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('click.slick', _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) _.$list.on('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.show();
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'next' : 'previous'
                }
            });
            else if (event.keyCode === 39 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'previous' : 'next'
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr('data-lazy'), imageSrcSet = $(this).attr('data-srcset'), imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'), imageToLoad = document.createElement('img');
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 0
                    }, 100, function() {
                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);
                            if (imageSizes) image.attr('sizes', imageSizes);
                        }
                        image.attr('src', imageSource).animate({
                            opacity: 1
                        }, 200, function() {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [
                            _,
                            image,
                            imageSource
                        ]);
                    });
                };
                imageToLoad.onerror = function() {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1, nextSlide = rangeEnd, $slides = _.$slider.find('.slick-slide');
            for(var i = 0; i < _.options.slidesToScroll; i++){
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass('slick-loading');
        _.initUI();
        if (_.options.lazyLoad === 'progressive') _.progressiveLazyLoad();
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger('afterChange', [
                _,
                index
            ]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) _.setPosition();
            _.swipeLeft = null;
            if (_.options.autoplay) _.autoPlay();
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };
    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function(tryCount) {
        tryCount = tryCount || 1;
        var _ = this, $imgsToLoad = $('img[data-lazy]', _.$slider), image, imageSource, imageSrcSet, imageSizes, imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');
            imageToLoad.onload = function() {
                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);
                    if (imageSizes) image.attr('sizes', imageSizes);
                }
                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                if (_.options.adaptiveHeight === true) _.setPosition();
                _.$slider.trigger('lazyLoaded', [
                    _,
                    image,
                    imageSource
                ]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function() {
                if (tryCount < 3) /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */ setTimeout(function() {
                    _.progressiveLazyLoad(tryCount + 1);
                }, 500);
                else {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else _.$slider.trigger('allImagesLoaded', [
            _
        ]);
    };
    Slick.prototype.refresh = function(initializing) {
        var _ = this, currentSlide, lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) _.currentSlide = lastVisibleIndex;
        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, {
            currentSlide: currentSlide
        });
        _.init();
        if (!initializing) _.changeSlide({
            data: {
                message: 'index',
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.registerBreakpoints = function() {
        var _ = this, breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || 'window';
            for(breakpoint in responsiveSettings){
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while(l >= 0){
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) _.breakpoints.splice(l, 1);
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function(a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger('reInit', [
            _
        ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else index = removeBefore === true ? --index : index;
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) return false;
        _.unload();
        if (removeAll === true) _.$slideTrack.children().remove();
        else _.$slideTrack.children(this.options.slide).eq(index).remove();
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) position = -position;
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) _.$slideTrack.css(positionProps);
        else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) _.$list.css({
                padding: '0px ' + _.options.centerPadding
            });
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) _.$list.css({
                padding: _.options.centerPadding + ' 0px'
            });
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) _.$slideTrack.width(5000 * _.slideCount);
        else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) $(element).css({
                position: 'relative',
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
            else $(element).css({
                position: 'relative',
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */ var _ = this, l, item, option, value, refresh = false, type;
        if ($.type(arguments[0]) === 'object') {
            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') type = 'responsive';
            else if (typeof arguments[1] !== 'undefined') type = 'single';
        }
        if (type === 'single') _.options[option] = value;
        else if (type === 'multiple') $.each(option, function(opt, val) {
            _.options[opt] = val;
        });
        else if (type === 'responsive') {
            for(item in value)if ($.type(_.options.responsive) !== 'array') _.options.responsive = [
                value[item]
            ];
            else {
                l = _.options.responsive.length - 1;
                // loop through the responsive object and splice out duplicates.
                while(l >= 0){
                    if (_.options.responsive[l].breakpoint === value[item].breakpoint) _.options.responsive.splice(l, 1);
                    l--;
                }
                _.options.responsive.push(value[item]);
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) _.setCSS(_.getLeft(_.currentSlide));
        else _.setFade();
        _.$slider.trigger('setPosition', [
            _
        ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? 'top' : 'left';
        if (_.positionProp === 'top') _.$slider.addClass('slick-vertical');
        else _.$slider.removeClass('slick-vertical');
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) _.cssTransitions = true;
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) _.options.zIndex = 3;
            } else _.options.zIndex = _.defaults.zIndex;
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
        _.$slides.eq(index).addClass('slick-current');
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }
                if (index === 0) allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                else if (index === _.slideCount - 1) allSlides.eq(_.options.slidesToShow).addClass('slick-center');
            }
            _.$slides.eq(index).addClass('slick-center');
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            else if (allSlides.length <= _.options.slidesToShow) allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                else allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            }
        }
        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') _.lazyLoad();
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) _.options.centerMode = false;
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) infiniteCount = _.options.slidesToShow + 1;
                else infiniteCount = _.options.slidesToShow;
                for(i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1){
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for(i = 0; i < infiniteCount + _.slideCount; i += 1){
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });
            }
        }
    };
    Slick.prototype.interrupt = function(toggle) {
        var _ = this;
        if (!toggle) _.autoPlay();
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
        var index = parseInt(targetElement.attr('data-slick-index'));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this, navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) return;
        if (_.options.fade === true && _.currentSlide === index) return;
        if (sync === false) _.asNavFor(index);
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        }
        if (_.options.autoplay) clearInterval(_.autoPlayTimer);
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            else animSlide = _.slideCount + targetSlide;
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = 0;
            else animSlide = targetSlide - _.slideCount;
        } else animSlide = targetSlide;
        _.animating = true;
        _.$slider.trigger('beforeChange', [
            _,
            _.currentSlide,
            animSlide
        ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');
            if (navTarget.slideCount <= navTarget.options.slidesToShow) navTarget.setSlideClasses(_.currentSlide);
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else _.postSlide(animSlide);
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(targetLeft, function() {
            _.postSlide(animSlide);
        });
        else _.postSlide(animSlide);
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.hide();
        _.$slider.addClass('slick-loading');
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
        if (swipeAngle <= 45 && swipeAngle >= 0) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle <= 360 && swipeAngle >= 315) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle >= 135 && swipeAngle <= 225) return _.options.rtl === false ? 'right' : 'left';
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) return 'down';
            else return 'up';
        }
        return 'vertical';
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount, direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) return false;
        if (_.touchObject.edgeHit === true) _.$slider.trigger('edge', [
            _,
            _.swipeDirection()
        ]);
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch(direction){
                case 'left':
                case 'down':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case 'right':
                case 'up':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != 'vertical') {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [
                    _,
                    direction
                ]);
            }
        } else if (_.touchObject.startX !== _.touchObject.curX) {
            _.slideHandler(_.currentSlide);
            _.touchObject = {};
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) return;
        else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) return;
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        switch(event.data.action){
            case 'start':
                _.swipeStart(event);
                break;
            case 'move':
                _.swipeMove(event);
                break;
            case 'end':
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || touches && touches.length !== 1) return false;
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) _.touchObject.swipeLength = verticalSwipeLength;
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) _.swipeLeft = curLeft + swipeLength * positionOffset;
        else _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        if (_.options.verticalSwiping === true) _.swipeLeft = curLeft + swipeLength * positionOffset;
        if (_.options.fade === true || _.options.touchMove === false) return false;
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) touches = event.originalEvent.touches[0];
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $('.slick-cloned', _.$slider).remove();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };
    Slick.prototype.unslick = function(fromBreakpoint) {
        var _ = this;
        _.$slider.trigger('unslick', [
            _,
            fromBreakpoint
        ]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find('li').removeClass('slick-active').end();
            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) _.interrupted = true;
            else _.interrupted = false;
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i, ret;
        for(i = 0; i < l; i++){
            if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});





// Import and initialize medium-zoom
/*! medium-zoom 1.1.0 | MIT License | https://github.com/francoischalifour/medium-zoom */ var $3131d07846902da0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3131d07846902da0$var$isSupported = function isSupported(node) {
    return node.tagName === 'IMG';
};
/* eslint-disable-next-line no-prototype-builtins */ var $3131d07846902da0$var$isNodeList = function isNodeList(selector) {
    return NodeList.prototype.isPrototypeOf(selector);
};
var $3131d07846902da0$var$isNode = function isNode(selector) {
    return selector && selector.nodeType === 1;
};
var $3131d07846902da0$var$isSvg = function isSvg(image) {
    var source = image.currentSrc || image.src;
    return source.substr(-4).toLowerCase() === '.svg';
};
var $3131d07846902da0$var$getImagesFromSelector = function getImagesFromSelector(selector) {
    try {
        if (Array.isArray(selector)) return selector.filter($3131d07846902da0$var$isSupported);
        if ($3131d07846902da0$var$isNodeList(selector)) // Do not use spread operator or Array.from() for IE support
        return [].slice.call(selector).filter($3131d07846902da0$var$isSupported);
        if ($3131d07846902da0$var$isNode(selector)) return [
            selector
        ].filter($3131d07846902da0$var$isSupported);
        if (typeof selector === 'string') // Do not use spread operator or Array.from() for IE support
        return [].slice.call(document.querySelectorAll(selector)).filter($3131d07846902da0$var$isSupported);
        return [];
    } catch (err) {
        throw new TypeError("The provided selector is invalid.\nExpects a CSS selector, a Node element, a NodeList or an array.\nSee: https://github.com/francoischalifour/medium-zoom");
    }
};
var $3131d07846902da0$var$createOverlay = function createOverlay(background) {
    var overlay = document.createElement('div');
    overlay.classList.add('medium-zoom-overlay');
    overlay.style.background = background;
    return overlay;
};
var $3131d07846902da0$var$cloneTarget = function cloneTarget(template) {
    var _template$getBounding = template.getBoundingClientRect(), top = _template$getBounding.top, left = _template$getBounding.left, width = _template$getBounding.width, height = _template$getBounding.height;
    var clone = template.cloneNode();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    clone.removeAttribute('id');
    clone.style.position = 'absolute';
    clone.style.top = top + scrollTop + 'px';
    clone.style.left = left + scrollLeft + 'px';
    clone.style.width = width + 'px';
    clone.style.height = height + 'px';
    clone.style.transform = '';
    return clone;
};
var $3131d07846902da0$var$createCustomEvent = function createCustomEvent(type, params) {
    var eventParams = $3131d07846902da0$var$_extends({
        bubbles: false,
        cancelable: false,
        detail: undefined
    }, params);
    if (typeof window.CustomEvent === 'function') return new CustomEvent(type, eventParams);
    var customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(type, eventParams.bubbles, eventParams.cancelable, eventParams.detail);
    return customEvent;
};
var $3131d07846902da0$var$mediumZoom = function mediumZoom(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    /**
   * Ensure the compatibility with IE11 if no Promise polyfill are used.
   */ var Promise = window.Promise || function Promise(fn) {
        function noop() {}
        fn(noop, noop);
    };
    var _handleClick = function _handleClick(event) {
        var target = event.target;
        if (target === overlay) {
            close();
            return;
        }
        if (images.indexOf(target) === -1) return;
        toggle({
            target: target
        });
    };
    var _handleScroll = function _handleScroll() {
        if (isAnimating || !active.original) return;
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (Math.abs(scrollTop - currentScroll) > zoomOptions.scrollOffset) setTimeout(close, 150);
    };
    var _handleKeyUp = function _handleKeyUp(event) {
        var key = event.key || event.keyCode;
        // Close if escape key is pressed
        if (key === 'Escape' || key === 'Esc' || key === 27) close();
    };
    var update = function update() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var newOptions = options;
        if (options.background) overlay.style.background = options.background;
        if (options.container && options.container instanceof Object) newOptions.container = $3131d07846902da0$var$_extends({}, zoomOptions.container, options.container);
        if (options.template) {
            var template = $3131d07846902da0$var$isNode(options.template) ? options.template : document.querySelector(options.template);
            newOptions.template = template;
        }
        zoomOptions = $3131d07846902da0$var$_extends({}, zoomOptions, newOptions);
        images.forEach(function(image) {
            image.dispatchEvent($3131d07846902da0$var$createCustomEvent('medium-zoom:update', {
                detail: {
                    zoom: zoom
                }
            }));
        });
        return zoom;
    };
    var clone = function clone() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return mediumZoom($3131d07846902da0$var$_extends({}, zoomOptions, options));
    };
    var attach = function attach() {
        for(var _len = arguments.length, selectors = Array(_len), _key = 0; _key < _len; _key++)selectors[_key] = arguments[_key];
        var newImages = selectors.reduce(function(imagesAccumulator, currentSelector) {
            return [].concat(imagesAccumulator, $3131d07846902da0$var$getImagesFromSelector(currentSelector));
        }, []);
        newImages.filter(function(newImage) {
            return images.indexOf(newImage) === -1;
        }).forEach(function(newImage) {
            images.push(newImage);
            newImage.classList.add('medium-zoom-image');
        });
        eventListeners.forEach(function(_ref) {
            var type = _ref.type, listener = _ref.listener, options = _ref.options;
            newImages.forEach(function(image) {
                image.addEventListener(type, listener, options);
            });
        });
        return zoom;
    };
    var detach = function detach() {
        for(var _len2 = arguments.length, selectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)selectors[_key2] = arguments[_key2];
        if (active.zoomed) close();
        var imagesToDetach = selectors.length > 0 ? selectors.reduce(function(imagesAccumulator, currentSelector) {
            return [].concat(imagesAccumulator, $3131d07846902da0$var$getImagesFromSelector(currentSelector));
        }, []) : images;
        imagesToDetach.forEach(function(image) {
            image.classList.remove('medium-zoom-image');
            image.dispatchEvent($3131d07846902da0$var$createCustomEvent('medium-zoom:detach', {
                detail: {
                    zoom: zoom
                }
            }));
        });
        images = images.filter(function(image) {
            return imagesToDetach.indexOf(image) === -1;
        });
        return zoom;
    };
    var on = function on(type, listener) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        images.forEach(function(image) {
            image.addEventListener('medium-zoom:' + type, listener, options);
        });
        eventListeners.push({
            type: 'medium-zoom:' + type,
            listener: listener,
            options: options
        });
        return zoom;
    };
    var off = function off(type, listener) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        images.forEach(function(image) {
            image.removeEventListener('medium-zoom:' + type, listener, options);
        });
        eventListeners = eventListeners.filter(function(eventListener) {
            return !(eventListener.type === 'medium-zoom:' + type && eventListener.listener.toString() === listener.toString());
        });
        return zoom;
    };
    var open = function open() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, target = _ref2.target;
        var _animate = function _animate() {
            var container = {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            var viewportWidth = void 0;
            var viewportHeight = void 0;
            if (zoomOptions.container) {
                if (zoomOptions.container instanceof Object) {
                    // The container is given as an object with properties like width, height, left, top
                    container = $3131d07846902da0$var$_extends({}, container, zoomOptions.container);
                    // We need to adjust custom options like container.right or container.bottom
                    viewportWidth = container.width - container.left - container.right - zoomOptions.margin * 2;
                    viewportHeight = container.height - container.top - container.bottom - zoomOptions.margin * 2;
                } else {
                    // The container is given as an element
                    var zoomContainer = $3131d07846902da0$var$isNode(zoomOptions.container) ? zoomOptions.container : document.querySelector(zoomOptions.container);
                    var _zoomContainer$getBou = zoomContainer.getBoundingClientRect(), _width = _zoomContainer$getBou.width, _height = _zoomContainer$getBou.height, _left = _zoomContainer$getBou.left, _top = _zoomContainer$getBou.top;
                    container = $3131d07846902da0$var$_extends({}, container, {
                        width: _width,
                        height: _height,
                        left: _left,
                        top: _top
                    });
                }
            }
            viewportWidth = viewportWidth || container.width - zoomOptions.margin * 2;
            viewportHeight = viewportHeight || container.height - zoomOptions.margin * 2;
            var zoomTarget = active.zoomedHd || active.original;
            var naturalWidth = $3131d07846902da0$var$isSvg(zoomTarget) ? viewportWidth : zoomTarget.naturalWidth || viewportWidth;
            var naturalHeight = $3131d07846902da0$var$isSvg(zoomTarget) ? viewportHeight : zoomTarget.naturalHeight || viewportHeight;
            var _zoomTarget$getBoundi = zoomTarget.getBoundingClientRect(), top = _zoomTarget$getBoundi.top, left = _zoomTarget$getBoundi.left, width = _zoomTarget$getBoundi.width, height = _zoomTarget$getBoundi.height;
            var scaleX = Math.min(Math.max(width, naturalWidth), viewportWidth) / width;
            var scaleY = Math.min(Math.max(height, naturalHeight), viewportHeight) / height;
            var scale = Math.min(scaleX, scaleY);
            var translateX = (-left + (viewportWidth - width) / 2 + zoomOptions.margin + container.left) / scale;
            var translateY = (-top + (viewportHeight - height) / 2 + zoomOptions.margin + container.top) / scale;
            var transform = 'scale(' + scale + ') translate3d(' + translateX + 'px, ' + translateY + 'px, 0)';
            active.zoomed.style.transform = transform;
            if (active.zoomedHd) active.zoomedHd.style.transform = transform;
        };
        return new Promise(function(resolve) {
            if (target && images.indexOf(target) === -1) {
                resolve(zoom);
                return;
            }
            var _handleOpenEnd = function _handleOpenEnd() {
                isAnimating = false;
                active.zoomed.removeEventListener('transitionend', _handleOpenEnd);
                active.original.dispatchEvent($3131d07846902da0$var$createCustomEvent('medium-zoom:opened', {
                    detail: {
                        zoom: zoom
                    }
                }));
                resolve(zoom);
            };
            if (active.zoomed) {
                resolve(zoom);
                return;
            }
            if (target) // The zoom was triggered manually via a click
            active.original = target;
            else if (images.length > 0) {
                var _images = images;
                active.original = _images[0];
            } else {
                resolve(zoom);
                return;
            }
            active.original.dispatchEvent($3131d07846902da0$var$createCustomEvent('medium-zoom:open', {
                detail: {
                    zoom: zoom
                }
            }));
            scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            isAnimating = true;
            active.zoomed = $3131d07846902da0$var$cloneTarget(active.original);
            document.body.appendChild(overlay);
            if (zoomOptions.template) {
                var template = $3131d07846902da0$var$isNode(zoomOptions.template) ? zoomOptions.template : document.querySelector(zoomOptions.template);
                active.template = document.createElement('div');
                active.template.appendChild(template.content.cloneNode(true));
                document.body.appendChild(active.template);
            }
            // If the selected <img> tag is inside a <picture> tag, set the
            // currently-applied source as the cloned `src=` attribute.
            // (as these might differ, or src= might be unset in some cases)
            if (active.original.parentElement && active.original.parentElement.tagName === 'PICTURE' && active.original.currentSrc) active.zoomed.src = active.original.currentSrc;
            document.body.appendChild(active.zoomed);
            window.requestAnimationFrame(function() {
                document.body.classList.add('medium-zoom--opened');
            });
            active.original.classList.add('medium-zoom-image--hidden');
            active.zoomed.classList.add('medium-zoom-image--opened');
            active.zoomed.addEventListener('click', close);
            active.zoomed.addEventListener('transitionend', _handleOpenEnd);
            if (active.original.getAttribute('data-zoom-src')) {
                active.zoomedHd = active.zoomed.cloneNode();
                // Reset the `scrset` property or the HD image won't load.
                active.zoomedHd.removeAttribute('srcset');
                active.zoomedHd.removeAttribute('sizes');
                // Remove loading attribute so the browser can load the image normally
                active.zoomedHd.removeAttribute('loading');
                active.zoomedHd.src = active.zoomed.getAttribute('data-zoom-src');
                active.zoomedHd.onerror = function() {
                    clearInterval(getZoomTargetSize);
                    console.warn('Unable to reach the zoom image target ' + active.zoomedHd.src);
                    active.zoomedHd = null;
                    _animate();
                };
                // We need to access the natural size of the full HD
                // target as fast as possible to compute the animation.
                var getZoomTargetSize = setInterval(function() {
                    if (active.zoomedHd.complete) {
                        clearInterval(getZoomTargetSize);
                        active.zoomedHd.classList.add('medium-zoom-image--opened');
                        active.zoomedHd.addEventListener('click', close);
                        document.body.appendChild(active.zoomedHd);
                        _animate();
                    }
                }, 10);
            } else if (active.original.hasAttribute('srcset')) {
                // If an image has a `srcset` attribuet, we don't know the dimensions of the
                // zoomed (HD) image (like when `data-zoom-src` is specified).
                // Therefore the approach is quite similar.
                active.zoomedHd = active.zoomed.cloneNode();
                // Resetting the sizes attribute tells the browser to load the
                // image best fitting the current viewport size, respecting the `srcset`.
                active.zoomedHd.removeAttribute('sizes');
                // In Firefox, the `loading` attribute needs to be set to `eager` (default
                // value) for the load event to be fired.
                active.zoomedHd.removeAttribute('loading');
                // Wait for the load event of the hd image. This will fire if the image
                // is already cached.
                var loadEventListener = active.zoomedHd.addEventListener('load', function() {
                    active.zoomedHd.removeEventListener('load', loadEventListener);
                    active.zoomedHd.classList.add('medium-zoom-image--opened');
                    active.zoomedHd.addEventListener('click', close);
                    document.body.appendChild(active.zoomedHd);
                    _animate();
                });
            } else _animate();
        });
    };
    var close = function close() {
        return new Promise(function(resolve) {
            if (isAnimating || !active.original) {
                resolve(zoom);
                return;
            }
            var _handleCloseEnd = function _handleCloseEnd() {
                active.original.classList.remove('medium-zoom-image--hidden');
                document.body.removeChild(active.zoomed);
                if (active.zoomedHd) document.body.removeChild(active.zoomedHd);
                document.body.removeChild(overlay);
                active.zoomed.classList.remove('medium-zoom-image--opened');
                if (active.template) document.body.removeChild(active.template);
                isAnimating = false;
                active.zoomed.removeEventListener('transitionend', _handleCloseEnd);
                active.original.dispatchEvent($3131d07846902da0$var$createCustomEvent('medium-zoom:closed', {
                    detail: {
                        zoom: zoom
                    }
                }));
                active.original = null;
                active.zoomed = null;
                active.zoomedHd = null;
                active.template = null;
                resolve(zoom);
            };
            isAnimating = true;
            document.body.classList.remove('medium-zoom--opened');
            active.zoomed.style.transform = '';
            if (active.zoomedHd) active.zoomedHd.style.transform = '';
            // Fade out the template so it's not too abrupt
            if (active.template) {
                active.template.style.transition = 'opacity 150ms';
                active.template.style.opacity = 0;
            }
            active.original.dispatchEvent($3131d07846902da0$var$createCustomEvent('medium-zoom:close', {
                detail: {
                    zoom: zoom
                }
            }));
            active.zoomed.addEventListener('transitionend', _handleCloseEnd);
        });
    };
    var toggle = function toggle() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, target = _ref3.target;
        if (active.original) return close();
        return open({
            target: target
        });
    };
    var getOptions = function getOptions() {
        return zoomOptions;
    };
    var getImages = function getImages() {
        return images;
    };
    var getZoomedImage = function getZoomedImage() {
        return active.original;
    };
    var images = [];
    var eventListeners = [];
    var isAnimating = false;
    var scrollTop = 0;
    var zoomOptions = options;
    var active = {
        original: null,
        zoomed: null,
        zoomedHd: null,
        template: null
    };
    if (Object.prototype.toString.call(selector) === '[object Object]') zoomOptions = selector;
    else if (selector || typeof selector === 'string' // to process empty string as a selector
    ) attach(selector);
    // Apply the default option values
    zoomOptions = $3131d07846902da0$var$_extends({
        margin: 0,
        background: '#fff',
        scrollOffset: 40,
        container: null,
        template: null
    }, zoomOptions);
    var overlay = $3131d07846902da0$var$createOverlay(zoomOptions.background);
    document.addEventListener('click', _handleClick);
    document.addEventListener('keyup', _handleKeyUp);
    document.addEventListener('scroll', _handleScroll);
    window.addEventListener('resize', close);
    var zoom = {
        open: open,
        close: close,
        toggle: toggle,
        update: update,
        clone: clone,
        attach: attach,
        detach: detach,
        on: on,
        off: off,
        getOptions: getOptions,
        getImages: getImages,
        getZoomedImage: getZoomedImage
    };
    return zoom;
};
function $3131d07846902da0$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $3131d07846902da0$var$css = ".medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)!important}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}";
$3131d07846902da0$var$styleInject($3131d07846902da0$var$css);
var $3131d07846902da0$export$2e2bcd8739ae039 = $3131d07846902da0$var$mediumZoom;


(0, $3131d07846902da0$export$2e2bcd8739ae039)('[data-action="zoom"]');


// Use tooltip and popover components everywhere
$(function() {
    $(document).tooltip({
        selector: '[data-toggle=tooltip]',
        trigger: 'hover'
    });
    $(document).popover({
        selector: '[data-toggle=popover]'
    });
    $(document).mouseup(function(e) {
        var container = $('.popover');
        if (!container.is(e.target) && container.has(e.target).length === 0) container.popover('hide');
    });
});


//
// Smooth Scroll to Anchor
//
$('a.scrollto[href^="#"]').on('click', function(e) {
    'use strict';
    // prevent default anchor click behavior
    e.preventDefault();
    // store hash
    var hash = this.hash;
    // animate
    $('html, body').animate({
        scrollTop: $(hash).offset().top
    }, 300, function() {
        // when done, add hash to url
        // (default click behaviour)
        window.location.hash = hash;
    });
});


//
// Back-to-top
//
$(document).ready(function() {
    var offset = 600;
    var duration = 300;
    $(window).scroll(function() {
        if ($(this).scrollTop() > offset) $('.back-to-top').fadeIn(duration);
        else $('.back-to-top').fadeOut(duration);
    });
    $('.back-to-top').click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, duration);
        return false;
    });
});


//
// Sticky Contact
// Switch button content when sticky contact is open
//
$('#stickyContact').on('shown.bs.collapse', function() {
    $(this).prev('button').find('span').toggleClass('d-block');
});
$('#stickyContact').on('hidden.bs.collapse', function() {
    $(this).prev('button').find('span').toggleClass('d-block');
});


// Initialize slick-carousel
$('.slick-carousel-initialize').slick({
    nextArrow: '<button type="button" class="slick-next"><span class="fa-layers"><i class="fal fa-angle-right slick-next-shadow" data-fa-transform="left-1"></i><i class="fal fa-angle-right"></i></span></button>',
    prevArrow: '<button type="button" class="slick-prev"><span class="fa-layers"><i class="fal fa-angle-left slick-prev-shadow" data-fa-transform="right-1"></i><i class="fal fa-angle-left"></i></span></button>',
    dots: true,
    adaptiveHeight: true
});
// This is a workaround to enable gradient layers with correct slide width
$('.slick-carousel-initialize').on('setPosition', function(event, slick) {
    $('.slick-slider-gradient').each(function() {
        $(this).remove();
    });
    // 'slick.listWidth' is only possible if one slide is shown, if there are multible slides shown we would need the width of each
    $('head').append('<style class="slick-slider-gradient">.slick-carousel-initialize .slide.gradient::before{width:' + slick.listWidth + 'px !important;}</style>');
});


//
// Main Navigation
// Snap navbar dropdown menu to the right (calculate margin-right on window resize)
//
$(window).resize(function() {
    $('.dropdown-menu-snap-right').each(function(index, item) {
        if ($(window).width() >= 992) {
            var navbarItem = $(item).prev();
            var navbar = $(navbarItem).closest('.navbar-nav');
            var navbarItemOffsetRight = $(window).width() - ($(navbarItem).offset().left + $(navbarItem).outerWidth());
            var navbarOffsetRight = $(window).width() - ($(navbar).offset().left + $(navbar).outerWidth());
            var calculatedMarginRight = navbarOffsetRight - navbarItemOffsetRight;
            $(item).css('margin-right', calculatedMarginRight);
        } else $(item).css('margin-right', 0);
    });
}).resize();


/**
 * Keep track of the acceptance rate
 */ function $a716446d3f93f88c$var$klaroAcceptanceRate() {
    let manager = klaro.getManager();
    // We are only interested in new users / first interactions (no consent updates)
    if (manager.confirmed === true) return;
    manager.watch({
        update: function(manager, eventType, data) {
            if (eventType === 'saveConsents') switch(data.type){
                case 'accept':
                    plausible('Consent Manager', {
                        props: {
                            action: 'Accepted'
                        }
                    });
                    break;
                case 'decline':
                    plausible('Consent Manager', {
                        props: {
                            action: 'Declined'
                        }
                    });
                    break;
                case 'save':
                    const ordered = Object.keys(data.consents).sort().reduce((obj, key)=>{
                        obj[key] = data.consents[key];
                        return obj;
                    }, {});
                    const accepted = Object.keys(ordered).filter((key)=>{
                        return ordered[key];
                    });
                    let details = 'Customized/Accepted[' + accepted.join() + ']';
                    plausible('Consent Manager', {
                        props: {
                            action: 'Customized',
                            details: details
                        }
                    });
                    break;
            }
        }
    });
}
document.addEventListener("DOMContentLoaded", $a716446d3f93f88c$var$klaroAcceptanceRate);


//
// Components
//
$('.scroll-on-change').on('change', function() {
    // Get selected identifier
    let hash = '#' + this.value;
    // If identifier exists
    if ($(hash)[0]) // Scroll to identifier
    $('html, body').animate({
        scrollTop: $(hash).offset().top
    }, 300, function() {
        // when done, add hash to url
        // (default click behaviour)
        window.location.hash = hash;
    });
});




//
// Components
//

/**
 *  Ajax Autocomplete for jQuery, version 1.5.0
 *  (c) 2017 Tomas Kirda
 *
 *  Ajax Autocomplete for jQuery is freely distributable under the terms of an MIT-style license.
 *  For details, see the web site: https://github.com/devbridge/jQuery-Autocomplete
 */ // Expose plugin as an AMD module if AMD loader is present:
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else // Browserify
    factory((parcelRequire("9qak9")));
})(/**
     * @param {jQuery} $
     */ function($) {
    "use strict";
    var utils = {
        escapeRegExChars: function(value) {
            return value.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
        },
        createNode: function(containerClass) {
            var div = document.createElement("div");
            div.className = containerClass;
            div.style.position = "absolute";
            div.style.display = "none";
            return div;
        }
    }, keys = {
        ESC: 27,
        TAB: 9,
        RETURN: 13,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    }, noop = $.noop;
    function Autocomplete(el, options) {
        var that = this;
        // Shared variables:
        that.element = el;
        that.el = $(el);
        that.suggestions = [];
        that.badQueries = [];
        that.selectedIndex = -1;
        that.currentValue = that.element.value;
        that.timeoutId = null;
        that.cachedResponse = {};
        that.onChangeTimeout = null;
        that.onChange = null;
        that.isLocal = false;
        that.suggestionsContainer = null;
        that.noSuggestionsContainer = null;
        that.options = $.extend(true, {}, Autocomplete.defaults, options);
        that.classes = {
            selected: "autocomplete-selected",
            suggestion: "autocomplete-suggestion"
        };
        that.hint = null;
        that.hintValue = "";
        that.selection = null;
        // Initialize and set options:
        that.initialize();
        that.setOptions(options);
    }
    Autocomplete.utils = utils;
    $.Autocomplete = Autocomplete;
    Autocomplete.defaults = {
        ajaxSettings: {},
        autoSelectFirst: false,
        appendTo: "body",
        serviceUrl: null,
        lookup: null,
        onSelect: null,
        onHint: null,
        width: "auto",
        minChars: 1,
        maxHeight: 300,
        deferRequestBy: 0,
        params: {},
        formatResult: _formatResult,
        formatGroup: _formatGroup,
        delimiter: null,
        zIndex: 9999,
        type: "GET",
        noCache: false,
        onSearchStart: noop,
        onSearchComplete: noop,
        onSearchError: noop,
        preserveInput: false,
        containerClass: "autocomplete-suggestions",
        tabDisabled: false,
        dataType: "text",
        currentRequest: null,
        triggerSelectOnValidInput: true,
        preventBadQueries: true,
        lookupFilter: _lookupFilter,
        paramName: "query",
        transformResult: _transformResult,
        showNoSuggestionNotice: false,
        noSuggestionNotice: "No results",
        orientation: "bottom",
        forceFixPosition: false
    };
    function _lookupFilter(suggestion, originalQuery, queryLowerCase) {
        return suggestion.value.toLowerCase().indexOf(queryLowerCase) !== -1;
    }
    function _transformResult(response) {
        return typeof response === "string" ? JSON.parse(response) : response;
    }
    function _formatResult(suggestion, currentValue) {
        // Do not replace anything if the current value is empty
        if (!currentValue) return suggestion.value;
        var pattern = "(" + utils.escapeRegExChars(currentValue) + ")";
        return suggestion.value.replace(new RegExp(pattern, "gi"), "<strong>$1</strong>").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/&lt;(\/?strong)&gt;/g, "<$1>");
    }
    function _formatGroup(suggestion, category) {
        return '<div class="autocomplete-group">' + category + "</div>";
    }
    Autocomplete.prototype = {
        initialize: function() {
            var that = this, suggestionSelector = "." + that.classes.suggestion, selected = that.classes.selected, options = that.options, container;
            that.element.setAttribute("autocomplete", "off");
            // html() deals with many types: htmlString or Element or Array or jQuery
            that.noSuggestionsContainer = $('<div class="autocomplete-no-suggestion"></div>').html(this.options.noSuggestionNotice).get(0);
            that.suggestionsContainer = Autocomplete.utils.createNode(options.containerClass);
            container = $(that.suggestionsContainer);
            container.appendTo(options.appendTo || "body");
            // Only set width if it was provided:
            if (options.width !== "auto") container.css("width", options.width);
            // Listen for mouse over event on suggestions list:
            container.on("mouseover.autocomplete", suggestionSelector, function() {
                that.activate($(this).data("index"));
            });
            // Deselect active element when mouse leaves suggestions container:
            container.on("mouseout.autocomplete", function() {
                that.selectedIndex = -1;
                container.children("." + selected).removeClass(selected);
            });
            // Listen for click event on suggestions list:
            container.on("click.autocomplete", suggestionSelector, function() {
                that.select($(this).data("index"));
            });
            container.on("click.autocomplete", function() {
                clearTimeout(that.blurTimeoutId);
            });
            that.fixPositionCapture = function() {
                if (that.visible) that.fixPosition();
            };
            $(window).on("resize.autocomplete", that.fixPositionCapture);
            that.el.on("keydown.autocomplete", function(e) {
                that.onKeyPress(e);
            });
            that.el.on("keyup.autocomplete", function(e) {
                that.onKeyUp(e);
            });
            that.el.on("blur.autocomplete", function() {
                that.onBlur();
            });
            that.el.on("focus.autocomplete", function() {
                that.onFocus();
            });
            that.el.on("change.autocomplete", function(e) {
                that.onKeyUp(e);
            });
            that.el.on("input.autocomplete", function(e) {
                that.onKeyUp(e);
            });
        },
        onFocus: function() {
            var that = this;
            if (that.disabled) return;
            that.fixPosition();
            if (that.el.val().length >= that.options.minChars) that.onValueChange();
        },
        onBlur: function() {
            var that = this, options = that.options, value = that.el.val(), query = that.getQuery(value);
            // If user clicked on a suggestion, hide() will
            // be canceled, otherwise close suggestions
            that.blurTimeoutId = setTimeout(function() {
                that.hide();
                if (that.selection && that.currentValue !== query) (options.onInvalidateSelection || $.noop).call(that.element);
            }, 200);
        },
        abortAjax: function() {
            var that = this;
            if (that.currentRequest) {
                that.currentRequest.abort();
                that.currentRequest = null;
            }
        },
        setOptions: function(suppliedOptions) {
            var that = this, options = $.extend({}, that.options, suppliedOptions);
            that.isLocal = Array.isArray(options.lookup);
            if (that.isLocal) options.lookup = that.verifySuggestionsFormat(options.lookup);
            options.orientation = that.validateOrientation(options.orientation, "bottom");
            // Adjust height, width and z-index:
            $(that.suggestionsContainer).css({
                "max-height": options.maxHeight + "px",
                width: options.width + "px",
                "z-index": options.zIndex
            });
            this.options = options;
        },
        clearCache: function() {
            this.cachedResponse = {};
            this.badQueries = [];
        },
        clear: function() {
            this.clearCache();
            this.currentValue = "";
            this.suggestions = [];
        },
        disable: function() {
            var that = this;
            that.disabled = true;
            clearTimeout(that.onChangeTimeout);
            that.abortAjax();
        },
        enable: function() {
            this.disabled = false;
        },
        fixPosition: function() {
            // Use only when container has already its content
            var that = this, $container = $(that.suggestionsContainer), containerParent = $container.parent().get(0);
            // Fix position automatically when appended to body.
            // In other cases force parameter must be given.
            if (containerParent !== document.body && !that.options.forceFixPosition) return;
            // Choose orientation
            var orientation = that.options.orientation, containerHeight = $container.outerHeight(), height = that.el.outerHeight(), offset = that.el.offset(), styles = {
                top: offset.top,
                left: offset.left
            };
            if (orientation === "auto") {
                var viewPortHeight = $(window).height(), scrollTop = $(window).scrollTop(), topOverflow = -scrollTop + offset.top - containerHeight, bottomOverflow = scrollTop + viewPortHeight - (offset.top + height + containerHeight);
                orientation = Math.max(topOverflow, bottomOverflow) === topOverflow ? "top" : "bottom";
            }
            if (orientation === "top") styles.top += -containerHeight;
            else styles.top += height;
            // If container is not positioned to body,
            // correct its position using offset parent offset
            if (containerParent !== document.body) {
                var opacity = $container.css("opacity"), parentOffsetDiff;
                if (!that.visible) $container.css("opacity", 0).show();
                parentOffsetDiff = $container.offsetParent().offset();
                styles.top -= parentOffsetDiff.top;
                styles.top += containerParent.scrollTop;
                styles.left -= parentOffsetDiff.left;
                if (!that.visible) $container.css("opacity", opacity).hide();
            }
            if (that.options.width === "auto") styles.width = that.el.outerWidth() + "px";
            $container.css(styles);
        },
        isCursorAtEnd: function() {
            var that = this, valLength = that.el.val().length, selectionStart = that.element.selectionStart, range;
            if (typeof selectionStart === "number") return selectionStart === valLength;
            if (document.selection) {
                range = document.selection.createRange();
                range.moveStart("character", -valLength);
                return valLength === range.text.length;
            }
            return true;
        },
        onKeyPress: function(e) {
            var that = this;
            // If suggestions are hidden and user presses arrow down, display suggestions:
            if (!that.disabled && !that.visible && e.which === keys.DOWN && that.currentValue) {
                that.suggest();
                return;
            }
            if (that.disabled || !that.visible) return;
            switch(e.which){
                case keys.ESC:
                    that.el.val(that.currentValue);
                    that.hide();
                    break;
                case keys.RIGHT:
                    if (that.hint && that.options.onHint && that.isCursorAtEnd()) {
                        that.selectHint();
                        break;
                    }
                    return;
                case keys.TAB:
                    if (that.hint && that.options.onHint) {
                        that.selectHint();
                        return;
                    }
                    if (that.selectedIndex === -1) {
                        that.hide();
                        return;
                    }
                    that.select(that.selectedIndex);
                    if (that.options.tabDisabled === false) return;
                    break;
                case keys.RETURN:
                    if (that.selectedIndex === -1) {
                        that.hide();
                        return;
                    }
                    that.select(that.selectedIndex);
                    break;
                case keys.UP:
                    that.moveUp();
                    break;
                case keys.DOWN:
                    that.moveDown();
                    break;
                default:
                    return;
            }
            // Cancel event if function did not return:
            e.stopImmediatePropagation();
            e.preventDefault();
        },
        onKeyUp: function(e) {
            var that = this;
            if (that.disabled) return;
            switch(e.which){
                case keys.UP:
                case keys.DOWN:
                    return;
            }
            clearTimeout(that.onChangeTimeout);
            if (that.currentValue !== that.el.val()) {
                that.findBestHint();
                if (that.options.deferRequestBy > 0) // Defer lookup in case when value changes very quickly:
                that.onChangeTimeout = setTimeout(function() {
                    that.onValueChange();
                }, that.options.deferRequestBy);
                else that.onValueChange();
            }
        },
        onValueChange: function() {
            if (this.ignoreValueChange) {
                this.ignoreValueChange = false;
                return;
            }
            var that = this, options = that.options, value = that.el.val(), query = that.getQuery(value);
            if (that.selection && that.currentValue !== query) {
                that.selection = null;
                (options.onInvalidateSelection || $.noop).call(that.element);
            }
            clearTimeout(that.onChangeTimeout);
            that.currentValue = value;
            that.selectedIndex = -1;
            // Check existing suggestion for the match before proceeding:
            if (options.triggerSelectOnValidInput && that.isExactMatch(query)) {
                that.select(0);
                return;
            }
            if (query.length < options.minChars) that.hide();
            else that.getSuggestions(query);
        },
        isExactMatch: function(query) {
            var suggestions = this.suggestions;
            return suggestions.length === 1 && suggestions[0].value.toLowerCase() === query.toLowerCase();
        },
        getQuery: function(value) {
            var delimiter = this.options.delimiter, parts;
            if (!delimiter) return value;
            parts = value.split(delimiter);
            return parts[parts.length - 1].trim();
        },
        getSuggestionsLocal: function(query) {
            var that = this, options = that.options, queryLowerCase = query.toLowerCase(), filter = options.lookupFilter, limit = parseInt(options.lookupLimit, 10), data;
            data = {
                suggestions: $.grep(options.lookup, function(suggestion) {
                    return filter(suggestion, query, queryLowerCase);
                })
            };
            if (limit && data.suggestions.length > limit) data.suggestions = data.suggestions.slice(0, limit);
            return data;
        },
        getSuggestions: function(q) {
            var response, that = this, options = that.options, serviceUrl = options.serviceUrl, params, cacheKey, ajaxSettings;
            options.params[options.paramName] = q;
            if (options.onSearchStart.call(that.element, options.params) === false) return;
            params = options.ignoreParams ? null : options.params;
            if (typeof options.lookup === "function") {
                options.lookup(q, function(data) {
                    that.suggestions = data.suggestions;
                    that.suggest();
                    options.onSearchComplete.call(that.element, q, data.suggestions);
                });
                return;
            }
            if (that.isLocal) response = that.getSuggestionsLocal(q);
            else {
                if (typeof serviceUrl === "function") serviceUrl = serviceUrl.call(that.element, q);
                cacheKey = serviceUrl + "?" + $.param(params || {});
                response = that.cachedResponse[cacheKey];
            }
            if (response && Array.isArray(response.suggestions)) {
                that.suggestions = response.suggestions;
                that.suggest();
                options.onSearchComplete.call(that.element, q, response.suggestions);
            } else if (!that.isBadQuery(q)) {
                that.abortAjax();
                ajaxSettings = {
                    url: serviceUrl,
                    data: params,
                    type: options.type,
                    dataType: options.dataType
                };
                $.extend(ajaxSettings, options.ajaxSettings);
                that.currentRequest = $.ajax(ajaxSettings).done(function(data) {
                    var result;
                    that.currentRequest = null;
                    result = options.transformResult(data, q);
                    that.processResponse(result, q, cacheKey);
                    options.onSearchComplete.call(that.element, q, result.suggestions);
                }).fail(function(jqXHR, textStatus, errorThrown) {
                    options.onSearchError.call(that.element, q, jqXHR, textStatus, errorThrown);
                });
            } else options.onSearchComplete.call(that.element, q, []);
        },
        isBadQuery: function(q) {
            if (!this.options.preventBadQueries) return false;
            var badQueries = this.badQueries, i = badQueries.length;
            while(i--){
                if (q.indexOf(badQueries[i]) === 0) return true;
            }
            return false;
        },
        hide: function() {
            var that = this, container = $(that.suggestionsContainer);
            if (typeof that.options.onHide === "function" && that.visible) that.options.onHide.call(that.element, container);
            that.visible = false;
            that.selectedIndex = -1;
            clearTimeout(that.onChangeTimeout);
            $(that.suggestionsContainer).hide();
            that.onHint(null);
        },
        suggest: function() {
            if (!this.suggestions.length) {
                if (this.options.showNoSuggestionNotice) this.noSuggestions();
                else this.hide();
                return;
            }
            var that = this, options = that.options, groupBy = options.groupBy, formatResult = options.formatResult, value = that.getQuery(that.currentValue), className = that.classes.suggestion, classSelected = that.classes.selected, container = $(that.suggestionsContainer), noSuggestionsContainer = $(that.noSuggestionsContainer), beforeRender = options.beforeRender, html = "", category, formatGroup = function(suggestion) {
                var currentCategory = suggestion.data[groupBy];
                if (category === currentCategory) return "";
                category = currentCategory;
                return options.formatGroup(suggestion, category);
            };
            if (options.triggerSelectOnValidInput && that.isExactMatch(value)) {
                that.select(0);
                return;
            }
            // Build suggestions inner HTML:
            $.each(that.suggestions, function(i, suggestion) {
                if (groupBy) html += formatGroup(suggestion, value, i);
                html += '<div class="' + className + '" data-index="' + i + '">' + formatResult(suggestion, value, i) + "</div>";
            });
            this.adjustContainerWidth();
            noSuggestionsContainer.detach();
            container.html(html);
            if (typeof beforeRender === "function") beforeRender.call(that.element, container, that.suggestions);
            that.fixPosition();
            container.show();
            // Select first value by default:
            if (options.autoSelectFirst) {
                that.selectedIndex = 0;
                container.scrollTop(0);
                container.children("." + className).first().addClass(classSelected);
            }
            that.visible = true;
            that.findBestHint();
        },
        noSuggestions: function() {
            var that = this, beforeRender = that.options.beforeRender, container = $(that.suggestionsContainer), noSuggestionsContainer = $(that.noSuggestionsContainer);
            this.adjustContainerWidth();
            // Some explicit steps. Be careful here as it easy to get
            // noSuggestionsContainer removed from DOM if not detached properly.
            noSuggestionsContainer.detach();
            // clean suggestions if any
            container.empty();
            container.append(noSuggestionsContainer);
            if (typeof beforeRender === "function") beforeRender.call(that.element, container, that.suggestions);
            that.fixPosition();
            container.show();
            that.visible = true;
        },
        adjustContainerWidth: function() {
            var that = this, options = that.options, width, container = $(that.suggestionsContainer);
            // If width is auto, adjust width before displaying suggestions,
            // because if instance was created before input had width, it will be zero.
            // Also it adjusts if input width has changed.
            if (options.width === "auto") {
                width = that.el.outerWidth();
                container.css("width", width > 0 ? width : 300);
            } else if (options.width === "flex") // Trust the source! Unset the width property so it will be the max length
            // the containing elements.
            container.css("width", "");
        },
        findBestHint: function() {
            var that = this, value = that.el.val().toLowerCase(), bestMatch = null;
            if (!value) return;
            $.each(that.suggestions, function(i, suggestion) {
                var foundMatch = suggestion.value.toLowerCase().indexOf(value) === 0;
                if (foundMatch) bestMatch = suggestion;
                return !foundMatch;
            });
            that.onHint(bestMatch);
        },
        onHint: function(suggestion) {
            var that = this, onHintCallback = that.options.onHint, hintValue = "";
            if (suggestion) hintValue = that.currentValue + suggestion.value.substr(that.currentValue.length);
            if (that.hintValue !== hintValue) {
                that.hintValue = hintValue;
                that.hint = suggestion;
                if (typeof onHintCallback === "function") onHintCallback.call(that.element, hintValue);
            }
        },
        verifySuggestionsFormat: function(suggestions) {
            // If suggestions is string array, convert them to supported format:
            if (suggestions.length && typeof suggestions[0] === "string") return $.map(suggestions, function(value) {
                return {
                    value: value,
                    data: null
                };
            });
            return suggestions;
        },
        validateOrientation: function(orientation, fallback) {
            orientation = (orientation || "").trim().toLowerCase();
            if ($.inArray(orientation, [
                "auto",
                "bottom",
                "top"
            ]) === -1) orientation = fallback;
            return orientation;
        },
        processResponse: function(result, originalQuery, cacheKey) {
            var that = this, options = that.options;
            result.suggestions = that.verifySuggestionsFormat(result.suggestions);
            // Cache results if cache is not disabled:
            if (!options.noCache) {
                that.cachedResponse[cacheKey] = result;
                if (options.preventBadQueries && !result.suggestions.length) that.badQueries.push(originalQuery);
            }
            // Return if originalQuery is not matching current query:
            if (originalQuery !== that.getQuery(that.currentValue)) return;
            that.suggestions = result.suggestions;
            that.suggest();
        },
        activate: function(index) {
            var that = this, activeItem, selected = that.classes.selected, container = $(that.suggestionsContainer), children = container.find("." + that.classes.suggestion);
            container.find("." + selected).removeClass(selected);
            that.selectedIndex = index;
            if (that.selectedIndex !== -1 && children.length > that.selectedIndex) {
                activeItem = children.get(that.selectedIndex);
                $(activeItem).addClass(selected);
                return activeItem;
            }
            return null;
        },
        selectHint: function() {
            var that = this, i = $.inArray(that.hint, that.suggestions);
            that.select(i);
        },
        select: function(i) {
            var that = this;
            that.hide();
            that.onSelect(i);
        },
        moveUp: function() {
            var that = this;
            if (that.selectedIndex === -1) return;
            if (that.selectedIndex === 0) {
                $(that.suggestionsContainer).children("." + that.classes.suggestion).first().removeClass(that.classes.selected);
                that.selectedIndex = -1;
                that.ignoreValueChange = false;
                that.el.val(that.currentValue);
                that.findBestHint();
                return;
            }
            that.adjustScroll(that.selectedIndex - 1);
        },
        moveDown: function() {
            var that = this;
            if (that.selectedIndex === that.suggestions.length - 1) return;
            that.adjustScroll(that.selectedIndex + 1);
        },
        adjustScroll: function(index) {
            var that = this, activeItem = that.activate(index);
            if (!activeItem) return;
            var offsetTop, upperBound, lowerBound, heightDelta = $(activeItem).outerHeight();
            offsetTop = activeItem.offsetTop;
            upperBound = $(that.suggestionsContainer).scrollTop();
            lowerBound = upperBound + that.options.maxHeight - heightDelta;
            if (offsetTop < upperBound) $(that.suggestionsContainer).scrollTop(offsetTop);
            else if (offsetTop > lowerBound) $(that.suggestionsContainer).scrollTop(offsetTop - that.options.maxHeight + heightDelta);
            if (!that.options.preserveInput) {
                // During onBlur event, browser will trigger "change" event,
                // because value has changed, to avoid side effect ignore,
                // that event, so that correct suggestion can be selected
                // when clicking on suggestion with a mouse
                that.ignoreValueChange = true;
                that.el.val(that.getValue(that.suggestions[index].value));
            }
            that.onHint(null);
        },
        onSelect: function(index) {
            var that = this, onSelectCallback = that.options.onSelect, suggestion = that.suggestions[index];
            that.currentValue = that.getValue(suggestion.value);
            if (that.currentValue !== that.el.val() && !that.options.preserveInput) that.el.val(that.currentValue);
            that.onHint(null);
            that.suggestions = [];
            that.selection = suggestion;
            if (typeof onSelectCallback === "function") onSelectCallback.call(that.element, suggestion);
        },
        getValue: function(value) {
            var that = this, delimiter = that.options.delimiter, currentValue, parts;
            if (!delimiter) return value;
            currentValue = that.currentValue;
            parts = currentValue.split(delimiter);
            if (parts.length === 1) return value;
            return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
        },
        dispose: function() {
            var that = this;
            that.el.off(".autocomplete").removeData("autocomplete");
            $(window).off("resize.autocomplete", that.fixPositionCapture);
            $(that.suggestionsContainer).remove();
        }
    };
    // Create chainable jQuery plugin:
    $.fn.devbridgeAutocomplete = function(options, args) {
        var dataKey = "autocomplete";
        // If function invoked without argument return
        // instance of the first matched element:
        if (!arguments.length) return this.first().data(dataKey);
        return this.each(function() {
            var inputElement = $(this), instance = inputElement.data(dataKey);
            if (typeof options === "string") {
                if (instance && typeof instance[options] === "function") instance[options](args);
            } else {
                // If instance already exists, destroy it:
                if (instance && instance.dispose) instance.dispose();
                instance = new Autocomplete(this, options);
                inputElement.data(dataKey, instance);
            }
        });
    };
    // Don't overwrite if it already exists
    if (!$.fn.autocomplete) $.fn.autocomplete = $.fn.devbridgeAutocomplete;
});


let $40a2262fa6f4a298$var$searchInput = $('.search-input');
// Search box focus behaviour
$($40a2262fa6f4a298$var$searchInput).focusin(function() {
    $(this).closest('.search-form').addClass('focused');
    // Hide meta nav labels to have more space for the expanded search box
    if ($(this).hasClass('search-input-header')) $('header .hide-on-search-focus').addClass('d-none');
    // Scroll to top
    if ($(this).hasClass('search-input-mobile')) $('html, body').animate({
        scrollTop: $(this).offset().top - 15
    }, 300);
}).focusout(function() {
    setTimeout(function() {
        $('.search-form').removeClass('focused');
        $('header .hide-on-search-focus').removeClass('d-none');
        // Clear search input for various reasons
        // * users most probably won't continue their previous search but rather start a new search
        // * suggestion container would be still there with wrong width on the next focusin
        $('.search-input-header').val('');
    }, 200);
});
// Autocomplete configuration
$($40a2262fa6f4a298$var$searchInput).autocomplete({
    // Defer AJAX calls by 200ms to reduce HTTP requests
    // UX improvement if the keyword changes very fast (reduce suggestion box flickering)
    deferRequestBy: 200,
    serviceUrl: $($40a2262fa6f4a298$var$searchInput).data('autocomplete-source'),
    paramName: 'term',
    dataType: 'json',
    transformResult: function(response) {
        let completions = $.map(response.completions, function(completion) {
            return {
                value: completion,
                data: {
                    type: 'completion'
                }
            };
        });
        let nodes = $.map(response.suggestions, function(suggestion) {
            return {
                value: suggestion.payload.label,
                data: suggestion.payload
            };
        });
        return {
            suggestions: completions.concat(nodes)
        };
    },
    // Format suggestion results by type and given data properties
    formatResult: function(suggestion, currentValue) {
        let utils = function() {
            return {
                escapeRegExChars: function(value) {
                    return value.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
                },
                createNode: function(containerClass) {
                    let div = document.createElement('div');
                    div.className = containerClass;
                    div.style.position = 'absolute';
                    div.style.display = 'none';
                    return div;
                }
            };
        }();
        let pattern = '(' + utils.escapeRegExChars(currentValue) + ')';
        let label = '';
        if (!currentValue) label = suggestion.value;
        else label = suggestion.value.replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/&lt;(\/?strong)&gt;/g, '<$1>');
        if (suggestion.data.type === 'node') return suggestion.data.snippet.replace(/<span>.+<\/span>/, '<span>' + label + '</span>');
        else return '<div class="suggest-completion" title="' + suggestion.value + '"><i class="fa-fw far fa-search" data-fa-transform="shrink-3"></i> ' + label + '</div>';
    },
    // Autoselect first suggestion and type the completions ahead
    autoSelectFirst: true,
    onHint: function(firstSuggestionValue) {
        $(':focus').prev('input.search-input-typeahead').val(firstSuggestionValue);
    },
    // Open suggested document node on select - if the href property is given
    onSelect: function(suggestion) {
        if (suggestion.data.snippet) {
            let href = suggestion.data.snippet.match(/href="([^"]*)/)[1];
            // TODO: valid uri check disabled - we need to support relative urls
            //if (isValidUri(href))
            if (href) window.location.href = href;
        } else $(this).closest('.search-form').submit();
    }
});
function $40a2262fa6f4a298$var$isValidUri(uri) {
    return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(uri);
}


// Trigger Plausible event
(function() {
    if (getParameterByName('search') && window.plausible) {
        let query = getParameterByName('search');
        plausible('Site Search', {
            props: {
                query: query
            }
        });
    }
    function getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }
})();


// Import js-cookie
var $39b3979787198c97$exports = {};
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    $39b3979787198c97$exports = factory();
})($39b3979787198c97$exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});


// Render content of interest
function $5ef10cbdb16811bd$var$renderContentOfInterest() {
    var category = (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get('proell_category_of_interest');
    var categoryClass = '.' + category;
    var application = (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get('proell_application_of_interest');
    var applicationClass = '.' + application;
    // Set category based content elements
    if (category && $(categoryClass).length) {
        // Set active category button
        $('.category-select').prop('disabled', false).removeClass('active');
        $('button[data-category="' + category + '"]').prop('disabled', true).addClass('active');
        // Other content elements like breadcrumbs, downloads, etc.
        $('.category-based').addClass('d-none');
        $(categoryClass).removeClass('d-none');
    }
    // Set application based content elements
    if (application && $(applicationClass).length) {
        $('.application-based').addClass('d-none');
        $(applicationClass).removeClass('d-none');
    }
    // Set category based applications
    $('.category-based-application').removeClass('application-inactive');
    $('.category-based-application').each(function() {
        if (!$(this).hasClass(category)) $(this).addClass('application-inactive');
    });
}
// Set category / application of interest
$(function() {
    // Update interest cookie info when a user visits either an application or a category page
    if ($('#category-of-interest').length == 1) {
        (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).set('proell_category_of_interest', $('#category-of-interest').data('category'), {
            expires: 365
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).remove('proell_application_of_interest');
    }
    if ($('#application-of-interest').length == 1) (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).set('proell_application_of_interest', $('#application-of-interest').data('application'), {
        expires: 365
    });
    // Render content elements based on current interest
    if ($('.category-select').length && (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get('proell_category_of_interest')) $5ef10cbdb16811bd$var$renderContentOfInterest();
});
//  Manually switch category of interest
$('.category-select').on('click', function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).set('proell_category_of_interest', $(this).data('category'), {
        expires: 365
    });
    $5ef10cbdb16811bd$var$renderContentOfInterest();
});




$('.properties-product-carousel').slick({
    nextArrow: '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
    asNavFor: '.properties-data-carousel',
    dots: false,
    infinite: false,
    draggable: false,
    slidesToShow: 8,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 6
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 4
            }
        }
    ]
});
$('.properties-data-carousel').slick({
    arrows: false,
    dots: false,
    infinite: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    slidesToShow: 8,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 6
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 4
            }
        }
    ]
});


// Import atomic components
//
// DealerList
//
$('.address-select-country').on('change', function() {
    // Get selected country
    let addressCountryClass = '.' + this.value;
    // If address country class exists
    if ($(addressCountryClass)[0]) // Scroll to first country address card
    $('html, body').animate({
        scrollTop: $(addressCountryClass + ':visible:first').offset().top - 20
    }, 300, function() {
        // Add additional class to card elements to highlight the selected country cards
        $(addressCountryClass).addClass('bg-secondary');
        setTimeout(function() {
            $('.card-address').removeClass('bg-secondary');
        }, 400);
    });
});




// Prevent multiple form submit
$('form').submit(function() {
    $(this).find('button[type="submit"]').prop('disabled', true);
});
// TODO: workaround - needs better implementation
$('form').change(function() {
    $(this).find('button[type="submit"]').prop('disabled', false);
});


/**
 * Bunny Stream video - click-to-load
 *
 * Nothing is requested from Bunny until the visitor clicks the preview image.
 * The click replaces the poster with the player iframe and starts playback.
 */ function $629ea4732e166dfb$var$loadVideo(poster) {
    const src = poster.dataset.bunnyVideo;
    const iframe = document.createElement('iframe');
    iframe.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=true';
    iframe.title = poster.dataset.bunnyVideoTitle || '';
    iframe.className = 'embed-responsive-item';
    iframe.setAttribute('allow', 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    poster.replaceWith(iframe);
    iframe.focus();
}
function $629ea4732e166dfb$var$initBunnyVideos() {
    document.querySelectorAll('[data-bunny-video]').forEach(function(poster) {
        poster.addEventListener('click', function() {
            $629ea4732e166dfb$var$loadVideo(poster);
        }, {
            once: true
        });
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $629ea4732e166dfb$var$initBunnyVideos);
else $629ea4732e166dfb$var$initBunnyVideos();






})();
//# sourceMappingURL=App.js.map
